import React, { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import styled, { keyframes } from 'styled-components'

interface INoUpcomingsProps {
  style?: React.CSSProperties
}

const wind = keyframes`
0% {
  transform: rotate(0deg);
};
25% {
  transform: rotate(10deg);
};
75% {
  transform: rotate(-10deg);
};
`

const slideLeft = keyframes`
0% {
  opacity: 0;
  transform: translateX(-30px);
};
100% {
  opacity: 1;
  transform: translateX(0);
};
`

const slideDown = keyframes`
0% {
  opacity: 0;
  transform: translateY(-30px);
};
100% {
  opacity: 1;
  transform: translateY(0);
};
`

const floating = keyframes`
0% {
  opacity: 1;
    transform: translateY(0px);
};
50% {
    transform: translateY(-10px);
};
100% {
  opacity: 1;
    transform: translateY(0px);
};
`
const AnimateDay = styled.g`
animation: 1s 1 forwards ease-in ${slideLeft},1.5s Infinite  linear ${wind};
    animation-delay: 0s,1s;
`
const AnimateDater = styled.g`
animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) ${slideDown};
    animation-delay: 0s;
`
const AnimateCharacter = styled.g`
animation: 1.5s Infinite  linear ${floating};
    animation-delay: 0s;
`

export const NoUpcomings: React.FC<INoUpcomingsProps> = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width={756}
      height={546}
      style={style || {}}
    >
      <g
        className="animable"
        style={{
          transformOrigin: "252.29px 356.66px",
        }}
      >
        <ellipse
          cx={252.29}
          cy={356.66}
          rx={233.93}
          ry={135.06}
          style={{
            fill: "#fafafa",
            transformOrigin: "252.29px 356.66px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "234.585px 357.962px",
        }}
      >
        <path
          d="M140.88 476 28.07 411.45c-1.35-.78-1.35-2 0-2.82l295.33-170.5a5.4 5.4 0 0 1 4.89 0l112.81 64.52c1.35.78 1.35 2.05 0 2.83L145.77 476a5.4 5.4 0 0 1-4.89 0Z"
          style={{
            fill: "#e6e6e6",
            transformOrigin: "234.585px 357.065px",
          }}
          className="animable"
        />
        <path
          d="m431.54 375.72-11.47-6.62a8.82 8.82 0 0 0-8.4.21l-59.22 38.19c-11.56-6.74-27.53-10.91-45.17-10.91-35.28 0-63.89 16.69-63.89 37.29s28.61 37.29 63.89 37.29 63.89-16.69 63.89-37.29c0-6.59-2.94-12.77-8.07-18.14l68.33-35.3c2.42-1.24 2.47-3.36.11-4.72Z"
          style={{
            fill: "#e6e6e6",
            transformOrigin: "338.334px 419.654px",
          }}
          className="animable"
        />
        <path
          d="M113.45 462.38a11.85 11.85 0 0 1-1.88 4.39 21 21 0 0 1-7.09 6.3c-12.27 7.08-32.16 7.08-44.43 0a20.9 20.9 0 0 1-7.09-6.3 12 12 0 0 1-1.87-4.39c-1.1-5.32 1.9-10.87 9-14.95 12.27-7.09 32.16-7.09 44.43 0 7.03 4.08 10.03 9.63 8.93 14.95Z"
          style={{
            fill: "#e6e6e6",
            transformOrigin: "82.2701px 460.246px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "237.63px 62.225px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "267.19px 68.66px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "267.19px 68.66px",
            }}
          >
            <path
              style={{
                fill: "#fafafa",
                transformOrigin: "267.205px 88.49px",
              }}
              className="animable"
              d="m247.45 98.82 1.84 1.09 37.67-21.75-1.84-1.09-37.67 21.75z"
            />
            <path
              style={{
                fill: "#fff",
                transformOrigin: "267.205px 68.655px",
              }}
              className="animable"
              d="m285.12 77.07-35.83 20.68V60.23l35.83-20.67v37.51z"
            />
            <path
              d="m290.42 32.48-44.6 25.75v47.68l44.6-25.75ZM287 78.16l-37.71 21.75V60.23L287 38.48Z"
              style={{
                fill: "#f0f0f0",
                transformOrigin: "268.12px 69.195px",
              }}
              className="animable"
            />
            <path
              style={{
                fill: "#e0e0e0",
                transformOrigin: "286.04px 58.32px",
              }}
              className="animable"
              d="m286.96 78.16-1.84-1.09V39.56l1.84-1.08v39.68z"
            />
            <path
              style={{
                fill: "#fafafa",
                transformOrigin: "267.19px 44.82px",
              }}
              className="animable"
              d="m290.42 32.48-1.86-1.07-44.6 25.75 1.86 1.07 44.6-25.75z"
            />
            <path
              style={{
                fill: "#e0e0e0",
                transformOrigin: "244.89px 81.535px",
              }}
              className="animable"
              d="m243.96 57.16 1.86 1.07v47.68l-1.86-1.07V57.16z"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "267.205px 74.9px",
            }}
          >
            <path
              style={{
                fill: "#f0f0f0",
                transformOrigin: "267.205px 74.9px",
              }}
              className="animable"
              d="m283.72 75.94-33.03 19.08v-9.54l8.26-19.07 5.14 4.77-1.85 7.99 11.41-24.39 10.07 11.63v9.53z"
            />
            <path
              d="M263.78 57.2a5.39 5.39 0 0 0-2.44 4.23c0 1.56 1.09 2.19 2.44 1.41a5.39 5.39 0 0 0 2.44-4.23c0-1.56-1.09-2.19-2.44-1.41Z"
              style={{
                fill: "#f0f0f0",
                transformOrigin: "263.78px 60.02px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          className="animable"
          style={{
            transformOrigin: "208.07px 55.785px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "208.07px 55.785px",
            }}
          >
            <path
              style={{
                fill: "#fafafa",
                transformOrigin: "208.08px 75.615px",
              }}
              className="animable"
              d="m188.33 85.94 1.83 1.1 37.67-21.75-1.83-1.1-37.67 21.75z"
            />
            <path
              style={{
                fill: "#fff",
                transformOrigin: "208.08px 55.78px",
              }}
              className="animable"
              d="m226 64.19-35.84 20.69V47.35L226 26.68v37.51z"
            />
            <path
              d="m231.3 19.61-44.6 25.74V93l44.6-25.74Zm-3.47 45.68L190.16 87V47.35l37.67-21.74Z"
              style={{
                fill: "#f0f0f0",
                transformOrigin: "209px 56.305px",
              }}
              className="animable"
            />
            <path
              style={{
                fill: "#e0e0e0",
                transformOrigin: "226.915px 45.45px",
              }}
              className="animable"
              d="m227.83 65.29-1.83-1.1V26.68l1.83-1.07v39.68z"
            />
            <path
              style={{
                fill: "#fafafa",
                transformOrigin: "208.07px 31.945px",
              }}
              className="animable"
              d="m231.3 19.61-1.87-1.07-44.59 25.75 1.86 1.06 44.6-25.74z"
            />
            <path
              style={{
                fill: "#e0e0e0",
                transformOrigin: "185.77px 68.66px",
              }}
              className="animable"
              d="m184.84 44.29 1.86 1.06v47.68l-1.86-1.06V44.29z"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "208.08px 62.02px",
            }}
          >
            <path
              style={{
                fill: "#f0f0f0",
                transformOrigin: "208.08px 62.02px",
              }}
              className="animable"
              d="m224.6 63.07-33.04 19.07v-9.53l8.26-19.08 5.15 4.77-1.85 8 11.4-24.4 10.08 11.63v9.54z"
            />
            <path
              d="M204.66 44.33a5.4 5.4 0 0 0-2.45 4.23c0 1.56 1.1 2.19 2.45 1.41a5.39 5.39 0 0 0 2.44-4.23c0-1.56-1.1-2.19-2.44-1.41Z"
              style={{
                fill: "#f0f0f0",
                transformOrigin: "204.655px 47.15px",
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "77.235px 145.16px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "77.235px 145.16px",
          }}
        >
          <path
            d="M37.55 106.26c0-25.55 16.83-56 37.6-68 11-6.34 20.88-6.24 27.75-1 8.55 3.55 14 13.38 14 27.94v148.3l-75.17 43.41-4.18-2.41Z"
            style={{
              fill: "#e6e6e6",
              transformOrigin: "77.225px 145.16px",
            }}
            className="animable"
          />
          <path
            d="M41.73 256.91V108.68c0-25.56 16.83-56 37.59-68s37.6-1 37.6 24.57V213.5Z"
            style={{
              fill: "#f5f5f5",
              transformOrigin: "79.325px 146.366px",
            }}
            className="animable"
          />
          <path
            d="M45.84 108.68v141.11l67-38.67V65.27c0-12.77-4.5-21.59-12.06-24.36a15.46 15.46 0 0 0-5.51-.91c-4.28 0-8.94 1.44-13.89 4.3-19.6 11.27-35.54 40.17-35.54 64.38Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "79.34px 144.894px",
            }}
            className="animable"
          />
          <path
            style={{
              fill: "#ebebeb",
              transformOrigin: "79.325px 229.235px",
            }}
            className="animable"
            d="m112.81 211.12-4.25-2.44-62.72 36.22v4.89l66.97-38.67z"
          />
          <path
            d="M45.84 108.68V244.9l62.72-36.22V62.81c0-10.15-2.85-17.8-7.82-21.9a15.46 15.46 0 0 0-5.47-.91c-4.28 0-8.94 1.44-13.89 4.3-19.6 11.27-35.54 40.17-35.54 64.38Z"
            style={{
              fill: "#fff",
              transformOrigin: "77.2px 142.449px",
            }}
            className="animable"
          />
          <path
            style={{
              fill: "#f5f5f5",
              transformOrigin: "79.325px 137.21px",
            }}
            className="animable"
            d="m77.27 231.64 4.11-2.37V42.78h-4.11v188.86z"
          />
          <path
            d="M73.15 50.2v179.07l4.12 2.37V46.92q-2.1 1.52-4.12 3.28Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "75.21px 139.28px",
            }}
            className="animable"
          />
          <path
            style={{
              fill: "#f5f5f5",
              transformOrigin: "97.095px 193.595px",
            }}
            className="animable"
            d="m112.81 182.11-31.43 18.15v4.82l31.43-18.14v-4.83z"
          />
          <path
            style={{
              fill: "#ebebeb",
              transformOrigin: "97.095px 189.965px",
            }}
            className="animable"
            d="m108.56 179.67 4.25 2.44-31.43 18.15v-4.82l27.18-15.77z"
          />
          <path
            style={{
              fill: "#f5f5f5",
              transformOrigin: "61.555px 214.115px",
            }}
            className="animable"
            d="m77.27 202.63-31.43 18.14v4.83l31.43-18.14v-4.83z"
          />
          <path
            style={{
              fill: "#ebebeb",
              transformOrigin: "61.555px 210.475px",
            }}
            className="animable"
            d="m73.02 200.18 4.25 2.45-31.43 18.14v-4.82l27.18-15.77z"
          />
          <path
            style={{
              fill: "#f5f5f5",
              transformOrigin: "97.095px 85.91px",
            }}
            className="animable"
            d="M112.81 74.43 81.38 92.57v4.82l31.43-18.14v-4.82z"
          />
          <path
            style={{
              fill: "#ebebeb",
              transformOrigin: "97.095px 82.275px",
            }}
            className="animable"
            d="m108.56 71.98 4.25 2.45-31.43 18.14v-4.82l27.18-15.77z"
          />
          <path
            style={{
              fill: "#f5f5f5",
              transformOrigin: "61.555px 106.425px",
            }}
            className="animable"
            d="m77.27 94.94-31.43 18.14v4.83l31.43-18.14v-4.83z"
          />
          <path
            style={{
              fill: "#ebebeb",
              transformOrigin: "61.555px 102.785px",
            }}
            className="animable"
            d="m73.02 92.49 4.25 2.45-31.43 18.14v-4.82l27.18-15.77z"
          />
        </g>
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "241.788px 254.52px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "241.788px 254.52px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "236.323px 251.6px",
            }}
          >
            <path
              d="m342.69 255.54 5.36-3.1s28.52-93 31.17-98.4-2.14-8.14-7.28-5.18L104.3 303.18c-5.13 3-6.75 7-11.31 15.91s-30.32 94.34-30.32 94.34a4.77 4.77 0 0 0 2.3 5l60.93 35.29 280-161.62Z"
              style={{
                fill: "#455a64",
                transformOrigin: "234.245px 300.684px",
              }}
              className="animable"
            />
            <path
              d="M96.35 321.24c-3.47 6.72-30.28 94-30.28 94l285.37-164.76s28.31-88.71 31.14-94.3-2.15-8.18-7.28-5.18L107.66 305.33c-5.13 2.96-7.84 9.19-11.31 15.91Z"
              style={{
                fill: "#263238",
                transformOrigin: "224.736px 282.489px",
              }}
              className="animable"
            />
            <path
              style={{
                fill: "#37474f",
                transformOrigin: "237.035px 352.34px",
              }}
              className="animable"
              d="M346.01 253.63 66.07 415.25l61.99 35.8L408 289.43l-61.99-35.8z"
            />
            <path
              d="M365.5 49.8 95.8 205.23c-5.92 3.41-7.76 8.94-6.72 16.22l31.91 224c1 7.29 6.85 11.55 12.76 8.14L401.07 299.3c5.91-3.41 9.86-12.08 8.82-19.37L378.1 56.8c-1.04-7.28-6.68-10.42-12.6-7Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "249.431px 251.6px",
              }}
              className="animable"
            />
            <path
              d="M365.5 49.8 95.8 205.23c-5.92 3.41-7.76 8.94-6.72 16.22l31.91 224c1 7.29 6.85 11.55 12.76 8.14L401.07 299.3c5.91-3.41 9.86-12.08 8.82-19.37L378.1 56.8c-1.04-7.28-6.68-10.42-12.6-7Z"
              style={{
                fill: "#fff",
                opacity: 0.35,
                transformOrigin: "249.431px 251.6px",
              }}
              className="animable"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "256.672px 255.788px",
            }}
          >
            <path
              d="M383.68 54.55a8.32 8.32 0 0 0-7.27.9L109.08 209.74a18 18 0 0 0-6.82 7.82l-8.63-3.65c1.9-4.14 5.21-5.65 8-7.31L369 52.32c2.73-1.56 5.38-1.74 7.55-.77Z"
              style={{
                fill: "#455a64",
                transformOrigin: "238.655px 134.256px",
              }}
              className="animable"
            />
            <path
              d="M129.66 455.83c-2.66-1.1-4.66-3.83-5.19-7.83L92.84 226c-.65-4.55-.86-8.63.79-12.07l8.63 3.66c-.23.48-.44 1-.64 1.46s-.3.8-.42 1.2a.7.7 0 0 0-.06.19 13.91 13.91 0 0 0-.4 1.4c-.13.48-.24 1-.32 1.46a8.53 8.53 0 0 0-.15 1.1 17 17 0 0 0 0 4.73l31.79 223.13c.58 4 2.59 6.82 5.27 7.89Z"
              style={{
                fill: "#263238",
                transformOrigin: "114.844px 337.04px",
              }}
              className="animable"
            />
            <path
              d="M376.4 55.47 106.7 210.9c-5.92 3.41-7.76 8.94-6.72 16.22l32.08 225.12c1 7.28 6.68 10.42 12.59 7L412 305c5.92-3.42 9.86-12.09 8.82-19.38L389 62.47c-1-7.28-6.68-10.42-12.6-7Z"
              style={{
                fill: "#37474f",
                transformOrigin: "260.346px 257.355px",
              }}
              className="animable"
            />
            <path
              d="M395.56 304 157 441.65c-3.07 1.76-6 .14-6.53-3.63l-31.53-220.83c-.54-3.77 1.51-8.26 4.58-10L362.13 69.46c3.06-1.77 6-.14 6.52 3.63l31.48 220.82c.54 3.77-1.51 8.27-4.57 10.09Z"
              style={{
                fill: "#263238",
                transformOrigin: "259.535px 255.553px",
              }}
              className="animable"
            />
            <path
              d="M118.94 217.19 150.42 438c0 .15.05.29.08.43l238.61-137.7c3.07-1.77 5.11-6.26 4.57-10L362.13 69.46l-238.61 137.7c-3.07 1.77-5.12 6.26-4.58 10.03Z"
              style={{
                fill: "#fafafa",
                transformOrigin: "256.31px 253.945px",
              }}
              className="animable"
            />
            <path
              d="M131.12 353.93a5.35 5.35 0 0 1-2.3 5.05c-1.55.89-3 .07-3.29-1.83a5.35 5.35 0 0 1 2.3-5c1.54-.94 3.01-.15 3.29 1.78Z"
              style={{
                fill: "#263238",
                transformOrigin: "128.328px 355.547px",
              }}
              className="animable"
            />
            <path
              d="M120.68 302.22a4.16 4.16 0 0 0-1.79 3.93l5.22 36.36c.21 1.47 1.35 2.11 2.55 1.42a4.17 4.17 0 0 0 1.79-3.93l-5.22-36.36c-.23-1.48-1.35-2.11-2.55-1.42Z"
              style={{
                fill: "#263238",
                transformOrigin: "123.67px 323.074px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          className="animable"
          style={{
            transformOrigin: "244.782px 239.003px",
          }}
        >
          <path
            d="m118.94 217.2 3.33 23.3 244.15-141-4.29-30.08-238.61 137.74c-3.07 1.77-5.12 6.26-4.58 10.04Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "242.637px 154.96px",
            }}
            className="animable"
          />
          <path
            d="M135.22 224.32a1.25 1.25 0 0 1-.76-.24l-4.92-3.45a1.33 1.33 0 0 1-.47-1.57l3.26-8.16a1.32 1.32 0 1 1 2.45 1l-2.86 7.19 4.06 2.85a1.32 1.32 0 0 1-.76 2.4Z"
            style={{
              fill: "#fff",
              transformOrigin: "132.76px 217.208px",
            }}
            className="animable"
          />
          <path
            d="M223 168.14a.75.75 0 0 1 .06-.31.44.44 0 0 1 .16-.17l.73-.43a.19.19 0 0 1 .18 0 .24.24 0 0 1 .11.21 5.1 5.1 0 0 1 0 1.16 4.65 4.65 0 0 1-.34 1.22 4.87 4.87 0 0 1-.72 1.16 4.08 4.08 0 0 1-1.16 1 2.47 2.47 0 0 1-1.14.38 1.52 1.52 0 0 1-.91-.27 2.09 2.09 0 0 1-.68-.82 4.77 4.77 0 0 1-.42-1.29c-.06-.32-.12-.67-.17-1.06s-.11-.76-.14-1.09a7.29 7.29 0 0 1 0-1.55 5.38 5.38 0 0 1 .36-1.42 4.29 4.29 0 0 1 .7-1.19 3.84 3.84 0 0 1 1.06-.9 2.72 2.72 0 0 1 1.24-.42 1.58 1.58 0 0 1 .91.22 1.61 1.61 0 0 1 .62.67 3.41 3.41 0 0 1 .34.94.42.42 0 0 1 0 .29.34.34 0 0 1-.16.19l-.73.42a.19.19 0 0 1-.18 0 .27.27 0 0 1-.14-.19 1.2 1.2 0 0 0-.19-.43.88.88 0 0 0-.33-.28.94.94 0 0 0-.48-.06 1.52 1.52 0 0 0-.63.23 2.07 2.07 0 0 0-.59.51 2.41 2.41 0 0 0-.38.66 3.1 3.1 0 0 0-.18.77 3.75 3.75 0 0 0 0 .82c0 .33.07.69.13 1.08s.11.75.17 1.07a3 3 0 0 0 .22.7 1.38 1.38 0 0 0 .36.45.93.93 0 0 0 .5.16 1.27 1.27 0 0 0 .63-.21 2.31 2.31 0 0 0 .59-.47 2.36 2.36 0 0 0 .4-.57 2.19 2.19 0 0 0 .21-.59 2.28 2.28 0 0 0-.01-.59Z"
            style={{
              fill: "#fff",
              transformOrigin: "221.396px 167.354px",
            }}
            className="animable"
          />
          <path
            d="M227.33 159c.1-.06.18-.06.23 0a.77.77 0 0 1 .18.25l3.36 6.82a.2.2 0 0 1 0 .09.55.55 0 0 1 0 .28.36.36 0 0 1-.15.2l-.65.38c-.12.06-.21.08-.27 0a.37.37 0 0 1-.13-.15l-.59-1.2-2.84 1.64-.18 1.65a1.45 1.45 0 0 1-.07.26.5.5 0 0 1-.24.26l-.65.37a.15.15 0 0 1-.18 0 .27.27 0 0 1-.11-.2.17.17 0 0 1 0-.1l1-9.36a1.65 1.65 0 0 1 .08-.4.45.45 0 0 1 .2-.23Zm1.3 5.33-1.51-3.08-.47 4.22Z"
            style={{
              fill: "#fff",
              transformOrigin: "228.075px 164.417px",
            }}
            className="animable"
          />
          <path
            d="M235.94 162a.15.15 0 0 1 .19 0 .25.25 0 0 1 .11.2l.13.91a.55.55 0 0 1 0 .28.37.37 0 0 1-.16.2l-3.94 2.28a.15.15 0 0 1-.18 0 .25.25 0 0 1-.11-.2l-1.18-8.26a.58.58 0 0 1 0-.29.37.37 0 0 1 .16-.2l.73-.42a.17.17 0 0 1 .19 0 .3.3 0 0 1 .1.2l1 7Z"
            style={{
              fill: "#fff",
              transformOrigin: "233.585px 161.186px",
            }}
            className="animable"
          />
          <path
            d="M241.25 159a.14.14 0 0 1 .18 0 .28.28 0 0 1 .11.2l.13.91a.55.55 0 0 1 0 .28.41.41 0 0 1-.15.2l-4 2.28a.15.15 0 0 1-.18 0 .3.3 0 0 1-.11-.2l-1.18-8.27a.6.6 0 0 1 0-.29.39.39 0 0 1 .15-.2l3.88-2.24a.18.18 0 0 1 .19 0 .3.3 0 0 1 .1.2l.13.91a.45.45 0 0 1 0 .28.33.33 0 0 1-.16.2l-2.91 1.68.29 2 2.71-1.57a.18.18 0 0 1 .19 0 .3.3 0 0 1 .11.2l.13.91a.55.55 0 0 1 0 .28.33.33 0 0 1-.16.2l-2.7 1.6.31 2.12Z"
            style={{
              fill: "#fff",
              transformOrigin: "238.86px 157.271px",
            }}
            className="animable"
          />
          <path
            d="M246.92 157.42a.23.23 0 0 1-.25 0l-.14-.11-3.28-3.87.75 5.27a.55.55 0 0 1 0 .28.38.38 0 0 1-.15.21l-.73.42a.17.17 0 0 1-.19 0 .28.28 0 0 1-.11-.2l-1.18-8.27a.55.55 0 0 1 0-.28.37.37 0 0 1 .16-.2l.63-.37a.25.25 0 0 1 .25 0l.14.12 3.28 3.86-.75-5.27a.45.45 0 0 1 0-.28.33.33 0 0 1 .16-.2l.73-.42a.15.15 0 0 1 .18 0 .27.27 0 0 1 .11.2l1.18 8.27a.54.54 0 0 1 0 .28.33.33 0 0 1-.16.2Z"
            style={{
              fill: "#fff",
              transformOrigin: "244.675px 153.865px",
            }}
            className="animable"
          />
          <path
            d="M250.38 145.72a2.76 2.76 0 0 1 1.19-.42 1.46 1.46 0 0 1 .93.24 2.06 2.06 0 0 1 .66.82 5.42 5.42 0 0 1 .42 1.34q.16.93.27 1.89a8.34 8.34 0 0 1 0 1.58 5.71 5.71 0 0 1-.34 1.41 4.36 4.36 0 0 1-.71 1.17 4.19 4.19 0 0 1-1.09.9l-2.27 1.35a.17.17 0 0 1-.19 0 .3.3 0 0 1-.1-.2l-1.15-8.31a.49.49 0 0 1 0-.29.41.41 0 0 1 .16-.2Zm2 2.68a2.54 2.54 0 0 0-.22-.69 1.08 1.08 0 0 0-.37-.46.82.82 0 0 0-.52-.14 1.51 1.51 0 0 0-.68.24l-1.21.69.82 5.76 1.25-.72a2.12 2.12 0 0 0 .62-.52 2.48 2.48 0 0 0 .4-.66 3.21 3.21 0 0 0 .18-.77 3.84 3.84 0 0 0 0-.83c-.08-.65-.17-1.3-.29-1.9Z"
            style={{
              fill: "#fff",
              transformOrigin: "250.933px 150.662px",
            }}
            className="animable"
          />
          <path
            d="M257.08 141.85a.2.2 0 0 1 .23 0 .67.67 0 0 1 .17.25l3.36 6.82v.08a.59.59 0 0 1 0 .29.41.41 0 0 1-.16.2l-.65.37c-.12.07-.21.08-.26 0a.48.48 0 0 1-.13-.16l-.59-1.19-2.85 1.64-.18 1.64a1.08 1.08 0 0 1-.07.27.54.54 0 0 1-.24.26l-.64.37a.17.17 0 0 1-.19 0 .3.3 0 0 1-.11-.2v-.1l1.05-9.36a1.28 1.28 0 0 1 .08-.4.38.38 0 0 1 .2-.23Zm1.3 5.34-1.52-3.08-.46 4.22Z"
            style={{
              fill: "#fff",
              transformOrigin: "257.814px 147.266px",
            }}
            className="animable"
          />
          <path
            d="M263 138.43a1.77 1.77 0 0 1 1.81-.25 2.21 2.21 0 0 1 .88 1.72 4.54 4.54 0 0 1-.07 1.77 3.75 3.75 0 0 1-.75 1.49l1.7 2.45a.61.61 0 0 1 .05.12.37.37 0 0 1 0 .23.32.32 0 0 1-.12.17l-.77.44c-.12.07-.21.08-.28 0a.53.53 0 0 1-.15-.15l-1.61-2.31-1.2.7.43 3a.55.55 0 0 1 0 .28.32.32 0 0 1-.15.2l-.73.42a.17.17 0 0 1-.19 0 .3.3 0 0 1-.11-.2l-1.18-8.27a.55.55 0 0 1 0-.28.33.33 0 0 1 .16-.2Zm-.77 4.81 1.3-.76a2.12 2.12 0 0 0 .78-.73 1.66 1.66 0 0 0 .17-1.15c-.07-.47-.22-.73-.44-.78a1.31 1.31 0 0 0-.86.23l-1.3.75Z"
            style={{
              fill: "#fff",
              transformOrigin: "263.59px 143.388px",
            }}
            className="animable"
          />
          <path
            d="M306.67 118.16a1.16 1.16 0 0 1-.48-.11 1.52 1.52 0 0 1-.77-1.2l-.73-5.1a2.38 2.38 0 0 1 1-2.31l9.55-5.51a1.17 1.17 0 0 1 1.09-.06 1.52 1.52 0 0 1 .77 1.2l.73 5.1a2.36 2.36 0 0 1-1 2.31l-9.54 5.52a1.29 1.29 0 0 1-.62.16Zm9.16-13.32-9.63 5.53a1.34 1.34 0 0 0-.44 1.23l.73 5.1c0 .24.12.36.17.38l9.63-5.53a1.33 1.33 0 0 0 .44-1.23l-.72-5.1a.55.55 0 0 0-.18-.38Z"
            style={{
              fill: "#fff",
              transformOrigin: "311.261px 110.962px",
            }}
            className="animable"
          />
          <path
            d="M309 120.27a.54.54 0 0 1-.46-.27.54.54 0 0 1 .19-.73l8.51-4.91a.53.53 0 0 1 .73.19.55.55 0 0 1-.19.74l-8.51 4.91a.52.52 0 0 1-.27.07Z"
            style={{
              fill: "#fff",
              transformOrigin: "313.255px 117.278px",
            }}
            className="animable"
          />
          <path
            d="M309.48 123.38a.53.53 0 0 1-.27-1l8.5-4.91a.54.54 0 0 1 .74.2.53.53 0 0 1-.2.73l-8.5 4.91a.54.54 0 0 1-.27.07Z"
            style={{
              fill: "#fff",
              transformOrigin: "313.723px 120.389px",
            }}
            className="animable"
          />
          <path
            d="M307.59 120.57a1 1 0 0 1-.4 1c-.28.17-.55 0-.61-.42a1 1 0 0 1 .4-1c.28-.15.55.02.61.42Z"
            style={{
              fill: "#fff",
              transformOrigin: "307.085px 120.866px",
            }}
            className="animable"
          />
          <path
            d="M308 123.68a1.07 1.07 0 0 1-.41 1c-.27.16-.55 0-.6-.43a1.05 1.05 0 0 1 .4-1c.32-.16.61.03.61.43Z"
            style={{
              fill: "#fff",
              transformOrigin: "307.494px 123.967px",
            }}
            className="animable"
          />
          <path
            d="M330.94 107.09a3.06 3.06 0 0 1-1.35-.31 5 5 0 0 1-2.43-4c-.48-3.39 1-7.14 3.45-8.53a3.29 3.29 0 0 1 3.19-.21 5 5 0 0 1 2.42 4c.49 3.39-1 7.14-3.44 8.54a3.68 3.68 0 0 1-1.84.51Zm1.5-12.27a2.51 2.51 0 0 0-1.29.38c-2 1.17-3.34 4.51-2.92 7.45a4 4 0 0 0 1.83 3.16 2.23 2.23 0 0 0 2.18-.17c2-1.17 3.34-4.52 2.92-7.45a4 4 0 0 0-1.83-3.19 2.1 2.1 0 0 0-.89-.18Z"
            style={{
              fill: "#fff",
              transformOrigin: "331.691px 100.407px",
            }}
            className="animable"
          />
          <path
            d="M338.6 105.79a.56.56 0 0 1-.31-.09l-3.51-2.47a.54.54 0 0 1 .62-.88l3.51 2.47a.54.54 0 0 1 .13.75.53.53 0 0 1-.44.22Z"
            style={{
              fill: "#fff",
              transformOrigin: "336.862px 104.033px",
            }}
            className="animable"
          />
          <path
            d="M351.73 98.07a.54.54 0 0 1-.53-.46l-1.73-12.14a.53.53 0 0 1 .45-.61.53.53 0 0 1 .61.45l1.74 12.15a.53.53 0 0 1-.46.6Z"
            style={{
              fill: "#fff",
              transformOrigin: "350.869px 91.4616px",
            }}
            className="animable"
          />
          <path
            d="M346.6 94.46a.53.53 0 0 1-.47-.27.53.53 0 0 1 .2-.73l8.54-4.93a.53.53 0 0 1 .73.2.54.54 0 0 1-.19.73l-8.54 4.93a.54.54 0 0 1-.27.07Z"
            style={{
              fill: "#fff",
              transformOrigin: "350.864px 91.459px",
            }}
            className="animable"
          />
          <path
            style={{
              fill: "#e0e0e0",
              transformOrigin: "246.49px 184.975px",
            }}
            className="animable"
            d="M370.71 129.45 126.55 270.41l-4.28-29.91L366.43 99.54l4.28 29.91z"
          />
          <path
            d="m222.78 200.36 1.1-6.05a1.58 1.58 0 0 1 .11-.37.56.56 0 0 1 .23-.27l.34-.2a.17.17 0 0 1 .19 0 .26.26 0 0 1 .1.21l1.19 8.26a.59.59 0 0 1 0 .29.41.41 0 0 1-.16.2l-.36.21a.17.17 0 0 1-.19 0 .3.3 0 0 1-.11-.2l-.87-6.07-.85 4.66a1.53 1.53 0 0 1-.11.39.48.48 0 0 1-.2.24l-.34.19a.2.2 0 0 1-.23 0 .68.68 0 0 1-.2-.21l-1.95-3 .86 6.06a.49.49 0 0 1 0 .29.41.41 0 0 1-.16.2l-.37.21a.15.15 0 0 1-.18 0 .27.27 0 0 1-.11-.2l-1.18-8.27a.58.58 0 0 1 0-.29.41.41 0 0 1 .16-.2l.34-.2a.26.26 0 0 1 .27 0 .61.61 0 0 1 .19.2Z"
            style={{
              fill: "#455a64",
              transformOrigin: "222.685px 199.435px",
            }}
            className="animable"
          />
          <path
            d="m231.19 197.15-3.12 1.85-.23 2a1.08 1.08 0 0 1-.07.27.5.5 0 0 1-.23.25l-.34.2a.12.12 0 0 1-.15 0 .25.25 0 0 1-.09-.16 1.72 1.72 0 0 1 0-.2l1.05-9.35a2 2 0 0 1 .1-.36.57.57 0 0 1 .25-.3l.54-.31a.24.24 0 0 1 .29 0 .65.65 0 0 1 .17.2l3.36 6.81a.64.64 0 0 1 .06.16.47.47 0 0 1 0 .23.31.31 0 0 1-.13.16l-.33.19c-.12.07-.21.09-.27 0a.45.45 0 0 1-.13-.15Zm-3 .48 2.49-1.44-1.9-3.86Z"
            style={{
              fill: "#455a64",
              transformOrigin: "229.876px 196.369px",
            }}
            className="animable"
          />
          <path
            d="M234.89 187.51a2.71 2.71 0 0 1 .86-.33 1.24 1.24 0 0 1 1.34.62 2.85 2.85 0 0 1 .35 1.1 3.94 3.94 0 0 1-.93 3.27l1.84 2.58a1.12 1.12 0 0 1 .05.13.38.38 0 0 1 0 .23.37.37 0 0 1-.12.17l-.39.22c-.12.07-.21.08-.29 0l-.15-.14-1.77-2.51-1.55.89.47 3.26a.59.59 0 0 1 0 .29.46.46 0 0 1-.15.2l-.37.21a.17.17 0 0 1-.19 0 .3.3 0 0 1-.11-.2l-1.18-8.27a.6.6 0 0 1 0-.29.41.41 0 0 1 .16-.2Zm-1 5.1 1.52-.88a2.39 2.39 0 0 0 1-.94 2.31 2.31 0 0 0 .19-1.39c-.08-.55-.26-.87-.52-1a1.35 1.35 0 0 0-1.06.24l-1.52.88Z"
            style={{
              fill: "#455a64",
              transformOrigin: "235.5px 192.442px",
            }}
            className="animable"
          />
          <path
            d="M239.44 188.57c0 .39.09.75.14 1.08s.1.69.17 1.07a2.31 2.31 0 0 0 .7 1.46 1.13 1.13 0 0 0 1.32-.05 2.68 2.68 0 0 0 1.14-1.26 2.68 2.68 0 0 0 .22-.73 6.25 6.25 0 0 0 .07-.72.38.38 0 0 1 .06-.26.36.36 0 0 1 .13-.16l.41-.24a.13.13 0 0 1 .16 0 .22.22 0 0 1 .08.16 3.86 3.86 0 0 1 0 1 5.06 5.06 0 0 1-.31 1.2 4.82 4.82 0 0 1-.67 1.18 3.67 3.67 0 0 1-1.1 1 2.25 2.25 0 0 1-1.09.34 1.56 1.56 0 0 1-.89-.27 2.14 2.14 0 0 1-.66-.8 4.59 4.59 0 0 1-.4-1.28c-.13-.74-.23-1.5-.32-2.27a6.27 6.27 0 0 1 0-1.5 5.32 5.32 0 0 1 .35-1.4 4.54 4.54 0 0 1 .68-1.17 3.67 3.67 0 0 1 1-.87 2.29 2.29 0 0 1 1.19-.37 1.62 1.62 0 0 1 .88.29 2.06 2.06 0 0 1 .58.69 2.63 2.63 0 0 1 .28.83.46.46 0 0 1 0 .23.27.27 0 0 1-.13.16l-.41.25a.22.22 0 0 1-.16 0 .22.22 0 0 1-.11-.16 3.32 3.32 0 0 0-.25-.54 1.09 1.09 0 0 0-.38-.39.88.88 0 0 0-.55-.11 1.71 1.71 0 0 0-.75.27 2.5 2.5 0 0 0-1.13 1.36 4.36 4.36 0 0 0-.25 1.98Z"
            style={{
              fill: "#455a64",
              transformOrigin: "241.314px 188.675px",
            }}
            className="animable"
          />
          <path
            d="M249 179.38a.17.17 0 0 1 .19 0 .3.3 0 0 1 .1.2l1.18 8.27a.49.49 0 0 1 0 .29.41.41 0 0 1-.16.2l-.37.21a.15.15 0 0 1-.18 0 .27.27 0 0 1-.11-.2l-.52-3.61-3.17 1.83.52 3.61a.69.69 0 0 1 0 .28.42.42 0 0 1-.16.2l-.37.21a.17.17 0 0 1-.18 0 .27.27 0 0 1-.11-.21l-1.19-8.27a.55.55 0 0 1 0-.28.39.39 0 0 1 .16-.21l.37-.21a.14.14 0 0 1 .18 0 .25.25 0 0 1 .11.2l.5 3.5 3.17-1.83-.5-3.5a.58.58 0 0 1 0-.29.41.41 0 0 1 .16-.2Z"
            style={{
              fill: "#455a64",
              transformOrigin: "247.472px 185.123px",
            }}
            className="animable"
          />
          <path
            d="M256.06 179.89a4.6 4.6 0 0 0 .3-.94 2.84 2.84 0 0 0 0-1 1.45 1.45 0 0 0-.44-1c-.23-.2-.54-.18-.94.05a1.62 1.62 0 0 0-.52.44 2.08 2.08 0 0 0-.32.56 2.81 2.81 0 0 0-.16.65c0 .22 0 .45-.06.67a.61.61 0 0 1-.06.28.43.43 0 0 1-.13.16l-.41.23a.12.12 0 0 1-.15 0 .22.22 0 0 1-.09-.16 4.15 4.15 0 0 1 0-1 4.84 4.84 0 0 1 .28-1.12 4.22 4.22 0 0 1 .57-1 2.75 2.75 0 0 1 .86-.77 1.85 1.85 0 0 1 .9-.29 1.17 1.17 0 0 1 .72.23 1.61 1.61 0 0 1 .5.65 3.42 3.42 0 0 1 .29 1 5.4 5.4 0 0 1 .06.77 4.37 4.37 0 0 1-.06.72 5.3 5.3 0 0 1-.18.74c-.08.25-.19.52-.31.8l-1.63 3.82 2.75-1.59a.17.17 0 0 1 .19 0 .28.28 0 0 1 .11.2l.06.46a.46.46 0 0 1 0 .28.32.32 0 0 1-.15.2l-3.88 2.24a.17.17 0 0 1-.19 0 .3.3 0 0 1-.1-.2l-.07-.46a.8.8 0 0 1 0-.27 1.7 1.7 0 0 1 .12-.33Z"
            style={{
              fill: "#455a64",
              transformOrigin: "255.631px 180.924px",
            }}
            className="animable"
          />
          <path
            d="M263.06 174.93c.06.38.11.74.16 1.08s.1.7.14 1.08a6.71 6.71 0 0 1 .05 1.48 5.37 5.37 0 0 1-.25 1.36 4.19 4.19 0 0 1-.6 1.15 3.18 3.18 0 0 1-1 .86 1.91 1.91 0 0 1-1.06.32 1.22 1.22 0 0 1-.81-.33 2.45 2.45 0 0 1-.58-.88 6.22 6.22 0 0 1-.35-1.31c-.06-.38-.11-.73-.16-1.07s-.1-.7-.14-1.09a7.3 7.3 0 0 1-.06-1.47 5.76 5.76 0 0 1 .26-1.36 4 4 0 0 1 .6-1.16 3.12 3.12 0 0 1 1-.86 1.93 1.93 0 0 1 1.06-.32 1.29 1.29 0 0 1 .82.34 2.45 2.45 0 0 1 .58.88 6.28 6.28 0 0 1 .34 1.3Zm-3.44 4.33a2.6 2.6 0 0 0 .64 1.57 1 1 0 0 0 1.15 0 2.18 2.18 0 0 0 1-1.19 4.45 4.45 0 0 0 .13-2c0-.38-.1-.75-.15-1.08s-.1-.7-.16-1.08a2.63 2.63 0 0 0-.64-1.58 1 1 0 0 0-1.15 0 2.14 2.14 0 0 0-1 1.19 4.46 4.46 0 0 0-.13 2c.05.39.1.75.15 1.09s.1.7.16 1.08Z"
            style={{
              fill: "#455a64",
              transformOrigin: "260.908px 177.335px",
            }}
            className="animable"
          />
          <path
            d="M267 173.57a4.68 4.68 0 0 0 .31-.94 3.4 3.4 0 0 0 0-1 1.57 1.57 0 0 0-.44-1c-.23-.2-.55-.18-.95 0a1.87 1.87 0 0 0-.52.44 2.39 2.39 0 0 0-.32.56 2.94 2.94 0 0 0-.16.65 5.19 5.19 0 0 0-.05.68.77.77 0 0 1-.07.27.35.35 0 0 1-.12.16l-.42.24a.12.12 0 0 1-.15 0 .2.2 0 0 1-.09-.16 4.15 4.15 0 0 1 0-1.05 4.4 4.4 0 0 1 .29-1.12 4.22 4.22 0 0 1 .57-1 2.71 2.71 0 0 1 .85-.77 1.88 1.88 0 0 1 .91-.29 1.16 1.16 0 0 1 .71.23 1.8 1.8 0 0 1 .51.65 3.4 3.4 0 0 1 .28 1 5.17 5.17 0 0 1 .06.76 3.5 3.5 0 0 1-.06.72 5.3 5.3 0 0 1-.18.74 6.85 6.85 0 0 1-.31.8L266 178l2.76-1.59a.17.17 0 0 1 .18 0 .27.27 0 0 1 .11.2l.06.46a.45.45 0 0 1 0 .28.39.39 0 0 1-.16.21l-3.88 2.24a.17.17 0 0 1-.18 0 .27.27 0 0 1-.11-.2l-.06-.46a.61.61 0 0 1 0-.27 1.7 1.7 0 0 1 .12-.33Z"
            style={{
              fill: "#455a64",
              transformOrigin: "266.559px 174.533px",
            }}
            className="animable"
          />
          <path
            d="M272.24 170.55a4.05 4.05 0 0 0 .3-.94 2.9 2.9 0 0 0 0-1 1.5 1.5 0 0 0-.44-1c-.23-.19-.54-.17-.94.06a1.74 1.74 0 0 0-.52.44 1.94 1.94 0 0 0-.32.56 2.81 2.81 0 0 0-.16.65 5 5 0 0 0-.05.67.77.77 0 0 1-.07.28.39.39 0 0 1-.13.15l-.41.24a.14.14 0 0 1-.15 0 .22.22 0 0 1-.09-.17 4.07 4.07 0 0 1 0-1 5 5 0 0 1 .28-1.13 5.19 5.19 0 0 1 .57-1 2.86 2.86 0 0 1 .86-.77 1.85 1.85 0 0 1 .91-.29 1.1 1.1 0 0 1 .71.23 1.76 1.76 0 0 1 .51.64 3.59 3.59 0 0 1 .28 1 5.4 5.4 0 0 1 .06.77 4.37 4.37 0 0 1-.06.72 5.18 5.18 0 0 1-.18.73 7.73 7.73 0 0 1-.31.81l-1.61 3.8 2.75-1.59a.17.17 0 0 1 .19 0 .3.3 0 0 1 .11.2l.06.47a.54.54 0 0 1 0 .28.37.37 0 0 1-.16.2l-3.88 2.24a.15.15 0 0 1-.18 0 .27.27 0 0 1-.11-.2l-.07-.46a.8.8 0 0 1 0-.27 2 2 0 0 1 .12-.34Z"
            style={{
              fill: "#455a64",
              transformOrigin: "271.819px 171.565px",
            }}
            className="animable"
          />
          <path
            d="M139.51 254.35a1.34 1.34 0 0 1-.76-.24l-4.91-3.45a1.32 1.32 0 0 1-.47-1.57l3.25-8.17a1.32 1.32 0 1 1 2.46 1l-2.87 7.19 4.06 2.85a1.33 1.33 0 0 1 .32 1.85 1.31 1.31 0 0 1-1.08.54Z"
            style={{
              fill: "#455a64",
              transformOrigin: "137.054px 247.221px",
            }}
            className="animable"
          />
          <path
            d="M355.13 129.86a1.41 1.41 0 0 1-.49-.09 1.32 1.32 0 0 1-.74-1.72l2.87-7.19-4.06-2.86a1.32 1.32 0 1 1 1.52-2.17l4.91 3.45a1.32 1.32 0 0 1 .47 1.57l-3.25 8.15a1.33 1.33 0 0 1-1.23.86Z"
            style={{
              fill: "#455a64",
              transformOrigin: "355.924px 122.725px",
            }}
            className="animable"
          />
          <path
            d="M303.48 265.16c1.09 7.61-2.37 16.28-7.72 19.37s-10.57-.58-11.66-8.19 2.37-16.28 7.72-19.37 10.57.58 11.66 8.19Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "293.79px 270.75px",
            }}
            className="animable"
          />
          <path
            d="m147.16 276 .6-3.28a.76.76 0 0 1 .06-.2.44.44 0 0 1 .12-.15l.19-.1a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11l.64 4.48a.39.39 0 0 1 0 .15.2.2 0 0 1-.09.11l-.2.12a.08.08 0 0 1-.1 0 .14.14 0 0 1-.06-.1l-.47-3.29-.46 2.52a1.42 1.42 0 0 1-.06.21.24.24 0 0 1-.11.13l-.18.11a.12.12 0 0 1-.13 0 .32.32 0 0 1-.1-.12l-1.06-1.65.47 3.29a.39.39 0 0 1 0 .15.17.17 0 0 1-.09.11l-.2.12a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.47.47 0 0 1 0-.16.18.18 0 0 1 .09-.1l.18-.11h.15a.36.36 0 0 1 .1.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "147.11px 275.495px",
            }}
            className="animable"
          />
          <path
            d="M149.23 273.59a3.47 3.47 0 0 1 0-.79 3 3 0 0 1 .18-.74 2.3 2.3 0 0 1 .36-.65 2 2 0 0 1 .55-.48 1.21 1.21 0 0 1 .59-.18.83.83 0 0 1 .47.16 1.16 1.16 0 0 1 .35.45 2.48 2.48 0 0 1 .2.68q.11.6.18 1.23a3.48 3.48 0 0 1 0 .79 3.14 3.14 0 0 1-.17.75 2.35 2.35 0 0 1-.36.64 2.11 2.11 0 0 1-.55.48 1.21 1.21 0 0 1-.59.18.78.78 0 0 1-.44-.11 1.24 1.24 0 0 1-.35-.45 2.59 2.59 0 0 1-.2-.68q-.14-.65-.22-1.28Zm2.23-1.25a2.63 2.63 0 0 0-.15-.53.72.72 0 0 0-.25-.29.46.46 0 0 0-.3-.08.65.65 0 0 0-.36.12 1.13 1.13 0 0 0-.34.28 1.33 1.33 0 0 0-.24.4 1.59 1.59 0 0 0-.13.51 2.52 2.52 0 0 0 0 .61c0 .21 0 .4.07.59l.09.57a2 2 0 0 0 .16.53.79.79 0 0 0 .24.29.48.48 0 0 0 .31.08.81.81 0 0 0 .36-.12 1.13 1.13 0 0 0 .34-.28 1.33 1.33 0 0 0 .24-.4 2.37 2.37 0 0 0 .13-.51 3.15 3.15 0 0 0 0-.61c0-.21 0-.41-.07-.59s-.06-.37-.1-.57Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "150.67px 273.43px",
            }}
            className="animable"
          />
          <path
            d="M155.31 273.37h-.12a.28.28 0 0 1-.1-.09L153 270.8l.48 3.41a.23.23 0 0 1 0 .16.19.19 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.24.24 0 0 1 .08-.11l.18-.1a.11.11 0 0 1 .12 0l.1.1 2.07 2.47-.49-3.41a.39.39 0 0 1 0-.15.17.17 0 0 1 .09-.11l.2-.12a.09.09 0 0 1 .1 0 .2.2 0 0 1 .06.11l.64 4.48a.47.47 0 0 1 0 .16.2.2 0 0 1-.09.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "153.973px 271.505px",
            }}
            className="animable"
          />
          <path
            d="M158.67 268.21c0 .21.06.39.09.55s0 .34.07.55a3 3 0 0 1 0 .85 3 3 0 0 1-.19.75 2.58 2.58 0 0 1-.38.62 2.08 2.08 0 0 1-.53.45l-1.15.66a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.47.47 0 0 1 0-.16.18.18 0 0 1 .09-.1l1.11-.65a1.46 1.46 0 0 1 .58-.19.79.79 0 0 1 .5.11 1.14 1.14 0 0 1 .37.43 2.18 2.18 0 0 1 .24.72Zm-.46.3a1.66 1.66 0 0 0-.12-.45.82.82 0 0 0-.22-.31.52.52 0 0 0-.34-.12 1 1 0 0 0-.46.15l-.76.44.51 3.6.79-.45a1.4 1.4 0 0 0 .39-.37 1.35 1.35 0 0 0 .24-.46 1.71 1.71 0 0 0 .1-.5 2.9 2.9 0 0 0 0-.51v-.75c-.1-.07-.11-.16-.13-.27Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "157.317px 269.8px",
            }}
            className="animable"
          />
          <path
            d="m161.67 268.52-1.69 1-.13 1.07a.44.44 0 0 1 0 .15.34.34 0 0 1-.13.14l-.18.1a.06.06 0 0 1-.08 0 .11.11 0 0 1-.05-.09v-.11l.57-5.06a1.94 1.94 0 0 1 .05-.2.31.31 0 0 1 .14-.16l.29-.17h.16a.34.34 0 0 1 .09.12l1.79 3.69a.23.23 0 0 1 0 .09.25.25 0 0 1 0 .12s0 .08-.07.09l-.18.11h-.15a.31.31 0 0 1-.07-.09Zm-1.61.25 1.35-.78-1-2.08Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "160.959px 268.093px",
            }}
            className="animable"
          />
          <path
            d="M164.05 268.12a.31.31 0 0 1 0 .16.24.24 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.23-1.62-1.57-2.12a.16.16 0 0 1 0-.09.25.25 0 0 1 0-.12.22.22 0 0 1 .07-.09l.21-.12c.07 0 .11-.05.15 0l.08.08 1.21 1.69.59-2.73a.88.88 0 0 1 0-.15.29.29 0 0 1 .13-.14l.21-.12h.08a.13.13 0 0 1 0 .09.49.49 0 0 1 0 .11l-.77 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "163.175px 265.688px",
            }}
            className="animable"
          />
          <path
            d="M178.53 254.71a.08.08 0 0 1 .1 0 .14.14 0 0 1 .06.1v.25a.44.44 0 0 1 0 .16.2.2 0 0 1-.09.11l-.91.52.58 4a.29.29 0 0 1 0 .16.2.2 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .13.13 0 0 1 0-.11l-.58-4-.91.53a.08.08 0 0 1-.1 0 .1.1 0 0 1-.06-.1v-.25a.41.41 0 0 1 0-.16.2.2 0 0 1 .09-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "177.46px 257.469px",
            }}
            className="animable"
          />
          <path
            d="M181.66 252.91a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11l.39 2.77a3.94 3.94 0 0 1 0 .83 2.7 2.7 0 0 1-.15.76 2.07 2.07 0 0 1-.34.64 2 2 0 0 1-.58.49 1.21 1.21 0 0 1-.62.2.69.69 0 0 1-.46-.17 1.27 1.27 0 0 1-.32-.49 3 3 0 0 1-.19-.74l-.4-2.78a.39.39 0 0 1 0-.15.2.2 0 0 1 .09-.11l.2-.12a.12.12 0 0 1 .1 0 .17.17 0 0 1 .06.11l.4 2.8a1.27 1.27 0 0 0 .37.88.56.56 0 0 0 .67 0 1.33 1.33 0 0 0 .58-.69 2.31 2.31 0 0 0 .08-1.14l-.4-2.81a.26.26 0 0 1 0-.15.24.24 0 0 1 .08-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "180.687px 255.802px",
            }}
            className="animable"
          />
          <path
            d="M185.3 255.38a.11.11 0 0 1 .11 0 .13.13 0 0 1 .05.11v.25a.31.31 0 0 1 0 .16.24.24 0 0 1-.09.11l-2 1.13a.09.09 0 0 1-.1 0 .13.13 0 0 1 0-.11l-.64-4.48a.2.2 0 0 1 0-.15.19.19 0 0 1 .08-.11l1.93-1.12a.08.08 0 0 1 .1 0 .15.15 0 0 1 .06.11v.25a.77.77 0 0 1 0 .15c0 .05-.05.09-.09.11l-1.6.92.21 1.47 1.49-.87a.08.08 0 0 1 .1 0 .14.14 0 0 1 .06.1v.25a.44.44 0 0 1 0 .16.2.2 0 0 1-.09.11l-1.49.86.22 1.52Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "184.043px 254.154px",
            }}
            className="animable"
          />
          <path
            d="M186.52 250a1.16 1.16 0 0 1 .55-.17 1 1 0 0 1 .43.1 1 1 0 0 1 .3.27 1.07 1.07 0 0 1 .14.34.29.29 0 0 1 0 .13.24.24 0 0 1-.08.09l-.2.11a.16.16 0 0 1-.09 0 .24.24 0 0 1-.08-.09.91.91 0 0 0-.1-.13.57.57 0 0 0-.18-.12.55.55 0 0 0-.26 0 .68.68 0 0 0-.33.11 1.5 1.5 0 0 0-.25.19 1.39 1.39 0 0 0-.21.27 1.66 1.66 0 0 0-.12.31.83.83 0 0 0 0 .35.55.55 0 0 0 .1.28.37.37 0 0 0 .21.12 1 1 0 0 0 .34 0l.49-.08a1.85 1.85 0 0 1 .5 0 .8.8 0 0 1 .36.09.73.73 0 0 1 .23.26 2 2 0 0 1 .12.43 1.9 1.9 0 0 1 0 .63 2.14 2.14 0 0 1-.21.6 2.24 2.24 0 0 1-.89.94 1.4 1.4 0 0 1-.54.19.86.86 0 0 1-.78-.33.85.85 0 0 1-.17-.39.2.2 0 0 1 0-.13.2.2 0 0 1 .06-.09l.2-.11a.13.13 0 0 1 .1 0s0 0 .08.08a.61.61 0 0 0 .12.16.41.41 0 0 0 .19.12.62.62 0 0 0 .28 0 .84.84 0 0 0 .35-.13 2.43 2.43 0 0 0 .32-.24 1.85 1.85 0 0 0 .25-.32 1.94 1.94 0 0 0 .15-.36 1.09 1.09 0 0 0 0-.36.38.38 0 0 0-.13-.26.48.48 0 0 0-.25-.11 1.34 1.34 0 0 0-.39 0l-.51.09a1.12 1.12 0 0 1-.44 0 .66.66 0 0 1-.32-.13.67.67 0 0 1-.21-.28 2 2 0 0 1-.11-.41 2 2 0 0 1 0-.54 1.86 1.86 0 0 1 .15-.56 2.29 2.29 0 0 1 .32-.51 2 2 0 0 1 .51-.41Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "186.969px 252.528px",
            }}
            className="animable"
          />
          <path
            d="M191.41 249.31c0 .21.06.39.09.55s0 .34.07.54a3 3 0 0 1 0 .85 2.92 2.92 0 0 1-.19.76 2.58 2.58 0 0 1-.38.62 2.08 2.08 0 0 1-.53.45l-1.15.66a.08.08 0 0 1-.1 0 .14.14 0 0 1-.06-.1l-.64-4.48a.47.47 0 0 1 0-.16.2.2 0 0 1 .09-.11l1.11-.64a1.31 1.31 0 0 1 .58-.19.79.79 0 0 1 .5.11 1.06 1.06 0 0 1 .37.43 2.18 2.18 0 0 1 .24.71Zm-.46.3a1.66 1.66 0 0 0-.12-.45 1 1 0 0 0-.22-.32.58.58 0 0 0-.34-.11.8.8 0 0 0-.46.15l-.76.44.51 3.6.79-.45a1.58 1.58 0 0 0 .43-.37 1.4 1.4 0 0 0 .24-.45 1.71 1.71 0 0 0 .1-.5 2.9 2.9 0 0 0 0-.51v-.75c-.12-.08-.12-.17-.12-.28Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "190.057px 250.906px",
            }}
            className="animable"
          />
          <path
            d="m194.41 249.62-1.69 1-.13 1.07a.49.49 0 0 1 0 .15.27.27 0 0 1-.13.13l-.18.11a.08.08 0 0 1-.08 0 .11.11 0 0 1 0-.09v-.11l.57-5.06a1.46 1.46 0 0 1 .05-.2.31.31 0 0 1 .14-.16l.29-.17h.16a.31.31 0 0 1 .09.11l1.82 3.69a.19.19 0 0 1 0 .09.25.25 0 0 1 0 .12.22.22 0 0 1-.07.09l-.18.11h-.15a.27.27 0 0 1-.07-.08Zm-1.61.25 1.35-.78-1-2.09Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "193.759px 249.19px",
            }}
            className="animable"
          />
          <path
            d="M196.79 249.22a.31.31 0 0 1 0 .16.16.16 0 0 1-.08.1l-.2.12a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.23-1.62-1.57-2.13a.16.16 0 0 1 0-.08.17.17 0 0 1 0-.12s0-.08.07-.09l.21-.12c.07 0 .11-.05.15 0a.3.3 0 0 1 .08.08l1.21 1.69.59-2.73a.88.88 0 0 1 .05-.15.25.25 0 0 1 .13-.14l.21-.12a.06.06 0 0 1 .08 0 .13.13 0 0 1 .05.09.54.54 0 0 1 0 .11l-.77 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "195.961px 246.78px",
            }}
            className="animable"
          />
          <path
            d="M206.62 239.74a.37.37 0 0 1 .06.1l.93 2.44-.05-4.12a.3.3 0 0 1 0-.18.21.21 0 0 1 .08-.1l.2-.11a.06.06 0 0 1 .08 0 .19.19 0 0 1 0 .09v4.69a1.3 1.3 0 0 1 0 .31.37.37 0 0 1-.16.19l-.19.11a.14.14 0 0 1-.18 0 .64.64 0 0 1-.12-.22l-.78-2.05-.12 2.57a1.37 1.37 0 0 1 0 .31.38.38 0 0 1-.15.2l-.2.11h-.18a.56.56 0 0 1-.11-.22l-1.21-3.94a.28.28 0 0 1 0-.13.22.22 0 0 1 .07-.09l.2-.11a.08.08 0 0 1 .09 0s.06 0 .08.11l1 3.54.14-3.05a.49.49 0 0 1 0-.15.27.27 0 0 1 .11-.15l.17-.09a.09.09 0 0 1 .24-.06Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "206.221px 240.917px",
            }}
            className="animable"
          />
          <path
            d="M211.31 240.37a.09.09 0 0 1 .1 0 .13.13 0 0 1 .05.11v.25a.31.31 0 0 1 0 .16.21.21 0 0 1-.08.1l-2 1.14a.09.09 0 0 1-.1 0 .13.13 0 0 1 0-.11l-.64-4.48a.2.2 0 0 1 0-.15.16.16 0 0 1 .08-.11l1.93-1.12a.08.08 0 0 1 .1 0 .14.14 0 0 1 .06.1v.25a.88.88 0 0 1 0 .16s-.05.09-.09.11l-1.6.92.21 1.46 1.49-.86a.09.09 0 0 1 .1 0 .2.2 0 0 1 .06.11v.25a.44.44 0 0 1 0 .16.2.2 0 0 1-.09.11l-1.49.86.22 1.52Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "210.048px 239.144px",
            }}
            className="animable"
          />
          <path
            d="M214.4 236c0 .21.06.39.08.54s.05.34.08.55a3 3 0 0 1 0 .85 2.57 2.57 0 0 1-.2.76 2.27 2.27 0 0 1-.37.62 2 2 0 0 1-.53.44l-1.15.67a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.47a.29.29 0 0 1 0-.16.2.2 0 0 1 .09-.11l1.11-.64a1.44 1.44 0 0 1 .58-.2.82.82 0 0 1 .49.12 1.12 1.12 0 0 1 .38.42 2.33 2.33 0 0 1 .24.72Zm-.46.3a3 3 0 0 0-.12-.45 1 1 0 0 0-.22-.32.66.66 0 0 0-.34-.12 1 1 0 0 0-.46.15l-.76.45.51 3.6.79-.46a1.4 1.4 0 0 0 .67-.81 1.71 1.71 0 0 0 .1-.5 2.9 2.9 0 0 0 0-.51v-.52a2.23 2.23 0 0 0 0-.23c-.11-.04-.11-.13-.17-.24Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "213.045px 237.591px",
            }}
            className="animable"
          />
          <path
            d="M217.78 237.31a.1.1 0 0 1-.13 0l-.1-.09-2.07-2.48.49 3.41a.26.26 0 0 1 0 .15.17.17 0 0 1-.09.11l-.2.12a.09.09 0 0 1-.1 0 .14.14 0 0 1-.05-.11l-.64-4.48a.23.23 0 0 1 0-.16.16.16 0 0 1 .08-.1l.17-.1a.1.1 0 0 1 .13 0l.1.09 2.06 2.48-.48-3.41a.31.31 0 0 1 0-.16.24.24 0 0 1 .08-.11l.2-.11a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11l.64 4.48a.26.26 0 0 1 0 .15.24.24 0 0 1-.08.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "216.458px 235.445px",
            }}
            className="animable"
          />
          <path
            d="M220.93 234.81a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11v.25a.26.26 0 0 1 0 .15.24.24 0 0 1-.08.11l-2 1.14a.08.08 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.47a.29.29 0 0 1 0-.16.24.24 0 0 1 .08-.11l1.93-1.11a.11.11 0 0 1 .11 0 .13.13 0 0 1 .05.11v.25a.26.26 0 0 1 0 .15.2.2 0 0 1-.09.11l-1.6.92.21 1.47 1.49-.86a.11.11 0 0 1 .11 0 .13.13 0 0 1 0 .11v.25a.26.26 0 0 1 0 .15.2.2 0 0 1-.09.11l-1.49.86.22 1.52Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "219.65px 233.591px",
            }}
            className="animable"
          />
          <path
            d="M222.15 229.46a1 1 0 0 1 .54-.17.85.85 0 0 1 .43.1.77.77 0 0 1 .3.27.82.82 0 0 1 .14.34.17.17 0 0 1 0 .12s0 .08-.07.09l-.2.12a.18.18 0 0 1-.09 0s-.05 0-.09-.09a.5.5 0 0 0-.1-.13.57.57 0 0 0-.18-.12.68.68 0 0 0-.26 0 .8.8 0 0 0-.33.11 1.57 1.57 0 0 0-.25.2 1 1 0 0 0-.2.26 1.13 1.13 0 0 0-.13.32 1 1 0 0 0 0 .35.57.57 0 0 0 .1.27.37.37 0 0 0 .21.12 1 1 0 0 0 .34 0l.49-.08a1.92 1.92 0 0 1 .51 0 .72.72 0 0 1 .35.1.54.54 0 0 1 .23.26 1.16 1.16 0 0 1 .12.42 1.9 1.9 0 0 1 0 .63 2.49 2.49 0 0 1-.2.6 2.4 2.4 0 0 1-.37.53 2.45 2.45 0 0 1-.53.42 1.16 1.16 0 0 1-.53.18 1 1 0 0 1-.46-.07.93.93 0 0 1-.33-.26.86.86 0 0 1-.17-.39.25.25 0 0 1 0-.12c0-.05 0-.08.07-.09l.2-.12a.15.15 0 0 1 .09 0s0 0 .08.09l.12.16a.56.56 0 0 0 .2.12.74.74 0 0 0 .27 0 .84.84 0 0 0 .35-.13 1.22 1.22 0 0 0 .32-.24 1.54 1.54 0 0 0 .25-.32 1.19 1.19 0 0 0 .15-.35.94.94 0 0 0 0-.37.42.42 0 0 0-.12-.26.52.52 0 0 0-.26-.11 1.81 1.81 0 0 0-.39 0l-.5.09a1.19 1.19 0 0 1-.45 0 .71.71 0 0 1-.32-.14.65.65 0 0 1-.2-.28 1.43 1.43 0 0 1-.11-.41 1.63 1.63 0 0 1 0-.54 2.64 2.64 0 0 1 .15-.55 2.29 2.29 0 0 1 .32-.51 1.83 1.83 0 0 1 .51-.42Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "222.592px 231.987px",
            }}
            className="animable"
          />
          <path
            d="M227 228.74c0 .21.06.39.08.55s0 .34.07.55a3.46 3.46 0 0 1 0 .85 3 3 0 0 1-.2.75 2.15 2.15 0 0 1-.38.62 2.08 2.08 0 0 1-.53.45l-1.14.66a.09.09 0 0 1-.1 0s0-.06-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.2.2 0 0 1 .08-.11l1.12-.65a1.37 1.37 0 0 1 .57-.19.84.84 0 0 1 .5.11 1.22 1.22 0 0 1 .37.43 2.18 2.18 0 0 1 .26.72Zm-.46.31a1.84 1.84 0 0 0-.13-.45.7.7 0 0 0-.22-.32.48.48 0 0 0-.33-.12 1 1 0 0 0-.46.15l-.77.44.52 3.61.79-.46a1.48 1.48 0 0 0 .42-.36 1.58 1.58 0 0 0 .25-.46 2 2 0 0 0 .09-.5 2.9 2.9 0 0 0 0-.51v-.75c0-.08-.11-.17-.12-.27Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "225.633px 230.331px",
            }}
            className="animable"
          />
          <path
            d="m230 229.05-1.69 1-.12 1.06a.83.83 0 0 1 0 .15.29.29 0 0 1-.13.14l-.18.1a.06.06 0 0 1-.08 0 .13.13 0 0 1 0-.09.54.54 0 0 1 0-.11l.57-5.06a.84.84 0 0 1 .05-.2.29.29 0 0 1 .13-.16l.3-.17h.15a.36.36 0 0 1 .1.11l1.81 3.68v.09a.32.32 0 0 1 0 .13s0 .07-.07.08l-.18.11h-.15a.18.18 0 0 1-.06-.09Zm-1.61.25 1.35-.78-1-2.08Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "229.354px 228.613px",
            }}
            className="animable"
          />
          <path
            d="M232.42 228.65a.41.41 0 0 1 0 .16.2.2 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.23-1.62-1.56-2.12a.12.12 0 0 1 0-.08.28.28 0 0 1 0-.13.22.22 0 0 1 .07-.09l.21-.12q.1-.06.15 0a.6.6 0 0 1 .08.08l1.21 1.69.59-2.72a.75.75 0 0 1 .05-.16.34.34 0 0 1 .13-.14l.21-.12a.11.11 0 0 1 .08 0s0 0 .05.1a.46.46 0 0 1 0 .1l-.77 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "231.593px 226.214px",
            }}
            className="animable"
          />
          <path
            d="M240.59 218.89a.08.08 0 0 1 .1 0 .17.17 0 0 1 .06.11v.25a.26.26 0 0 1 0 .15.24.24 0 0 1-.08.11l-.91.53.57 4a.2.2 0 0 1 0 .15.19.19 0 0 1-.08.11l-.2.12a.08.08 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.58-4-.91.53a.09.09 0 0 1-.1 0 .2.2 0 0 1-.06-.11v-.25a.31.31 0 0 1 0-.16.17.17 0 0 1 .08-.1Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "239.495px 221.655px",
            }}
            className="animable"
          />
          <path
            d="M243.76 217.05a.09.09 0 0 1 .1 0 .2.2 0 0 1 .06.11l.64 4.48a.31.31 0 0 1 0 .16.24.24 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.28-1.95-1.72 1 .28 2a.26.26 0 0 1 0 .15.2.2 0 0 1-.08.11l-.2.12a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.2.2 0 0 1 .08-.11l.2-.12a.09.09 0 0 1 .1 0s0 .06.06.11l.27 1.9 1.72-1-.27-1.9a.26.26 0 0 1 0-.15.2.2 0 0 1 .08-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "242.94px 220.195px",
            }}
            className="animable"
          />
          <path
            d="M247.2 215.07a.09.09 0 0 1 .1 0 .13.13 0 0 1 0 .11l.4 2.78a4.66 4.66 0 0 1 0 .83 3.12 3.12 0 0 1-.15.75 2.09 2.09 0 0 1-.35.64 1.81 1.81 0 0 1-.57.49 1.12 1.12 0 0 1-.62.2.67.67 0 0 1-.47-.17 1.3 1.3 0 0 1-.32-.49 3.34 3.34 0 0 1-.18-.74l-.4-2.77a.3.3 0 0 1 0-.16.24.24 0 0 1 .08-.11l.21-.11a.09.09 0 0 1 .1 0 .13.13 0 0 1 .05.11l.41 2.81a1.32 1.32 0 0 0 .36.88.58.58 0 0 0 .67 0 1.28 1.28 0 0 0 .58-.69 2.29 2.29 0 0 0 .09-1.14l-.41-2.8a.3.3 0 0 1 0-.16.15.15 0 0 1 .08-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "246.174px 217.963px",
            }}
            className="animable"
          />
          <path
            d="M249.45 213.77a1.56 1.56 0 0 1 .46-.18.71.71 0 0 1 .41 0 .73.73 0 0 1 .32.29 1.57 1.57 0 0 1 .19.6 2.24 2.24 0 0 1-.07 1 2.2 2.2 0 0 1-.44.76l1 1.4a.14.14 0 0 1 0 .06.28.28 0 0 1 0 .13.22.22 0 0 1-.07.09l-.21.12h-.16l-.08-.08-1-1.36-.84.49.26 1.77a.27.27 0 0 1 0 .15.15.15 0 0 1-.08.11l-.2.11a.08.08 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.47a.29.29 0 0 1 0-.16.2.2 0 0 1 .09-.11Zm-.53 2.77.83-.48a1.38 1.38 0 0 0 .51-.51 1.18 1.18 0 0 0 .1-.76c0-.29-.13-.46-.28-.51a.7.7 0 0 0-.57.13l-.82.48Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "249.728px 216.404px",
            }}
            className="animable"
          />
          <path
            d="M252.35 212a1.12 1.12 0 0 1 .54-.17.85.85 0 0 1 .73.37.82.82 0 0 1 .14.34.2.2 0 0 1 0 .13.22.22 0 0 1-.07.09l-.2.11h-.09c-.02 0 0 0-.08-.08l-.11-.13a.83.83 0 0 0-.18-.13.69.69 0 0 0-.26 0 .74.74 0 0 0-.32.1 1.28 1.28 0 0 0-.26.2 1.21 1.21 0 0 0-.2.26 1.27 1.27 0 0 0-.13.32 1 1 0 0 0 0 .35.57.57 0 0 0 .1.27.37.37 0 0 0 .21.12 1.25 1.25 0 0 0 .34 0l.49-.08a2 2 0 0 1 .51-.05.72.72 0 0 1 .35.1.53.53 0 0 1 .23.26 1.22 1.22 0 0 1 .12.43 1.84 1.84 0 0 1 0 .62 2.49 2.49 0 0 1-.2.6 2.19 2.19 0 0 1-.37.53 2.09 2.09 0 0 1-.52.42 1.23 1.23 0 0 1-.54.18.88.88 0 0 1-.46-.07.83.83 0 0 1-.33-.26.86.86 0 0 1-.17-.39.25.25 0 0 1 0-.12.22.22 0 0 1 .07-.09l.2-.12h.09s.05 0 .08.09a.83.83 0 0 0 .12.16.67.67 0 0 0 .2.12.56.56 0 0 0 .27 0 1 1 0 0 0 .36-.14 1.18 1.18 0 0 0 .31-.24 1.48 1.48 0 0 0 .25-.31 1.38 1.38 0 0 0 .15-.36.88.88 0 0 0 0-.36.45.45 0 0 0-.12-.27.51.51 0 0 0-.26-.1 1.66 1.66 0 0 0-.38 0l-.51.1a1.41 1.41 0 0 1-.45 0 .67.67 0 0 1-.52-.41 1.64 1.64 0 0 1-.11-.41 1.69 1.69 0 0 1 0-.55 2.16 2.16 0 0 1 .16-.55 1.94 1.94 0 0 1 .31-.51 1.83 1.83 0 0 1 .51-.37Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "252.792px 214.498px",
            }}
            className="animable"
          />
          <path
            d="M257.24 211.31c0 .2.06.39.08.54s.05.34.07.55a3.47 3.47 0 0 1 0 .85 3 3 0 0 1-.2.76 2.29 2.29 0 0 1-.38.62 1.86 1.86 0 0 1-.53.44l-1.14.66a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.24.24 0 0 1 .08-.11l1.12-.64a1.26 1.26 0 0 1 .58-.2.83.83 0 0 1 .49.12 1 1 0 0 1 .37.42 2.32 2.32 0 0 1 .26.73Zm-.46.3a2 2 0 0 0-.13-.45.83.83 0 0 0-.22-.32.48.48 0 0 0-.33-.12 1 1 0 0 0-.46.15l-.77.44.52 3.61.79-.46a1.36 1.36 0 0 0 .42-.36 1.66 1.66 0 0 0 .25-.45 2.1 2.1 0 0 0 .09-.5 2.86 2.86 0 0 0 0-.51v-.75c0-.08-.15-.17-.16-.28Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "255.873px 212.892px",
            }}
            className="animable"
          />
          <path
            d="m260.23 211.61-1.69 1-.12 1.07a1 1 0 0 1 0 .14.25.25 0 0 1-.13.14l-.18.11a.08.08 0 0 1-.08 0 .11.11 0 0 1-.05-.09.41.41 0 0 1 0-.1l.57-5.07a.77.77 0 0 1 .05-.19.26.26 0 0 1 .13-.16l.3-.17a.12.12 0 0 1 .15 0 .35.35 0 0 1 .1.11l1.81 3.69v.08a.3.3 0 0 1 0 .13.22.22 0 0 1-.07.09l-.18.1c-.06 0-.11.05-.14 0a.13.13 0 0 1-.07-.08Zm-1.61.26 1.35-.78-1-2.09Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "259.537px 211.172px",
            }}
            className="animable"
          />
          <path
            d="M262.62 211.22a.26.26 0 0 1 0 .15.2.2 0 0 1-.09.11l-.2.12a.08.08 0 0 1-.1 0 .15.15 0 0 1-.06-.11l-.23-1.62-1.56-2.12a.2.2 0 0 1 0-.08.2.2 0 0 1 0-.13.2.2 0 0 1 .06-.09l.22-.12h.14a.3.3 0 0 1 .08.08l1.22 1.68.58-2.72a1.42 1.42 0 0 1 .05-.16.32.32 0 0 1 .13-.13l.21-.12a.06.06 0 0 1 .08 0 .11.11 0 0 1 .05.09.54.54 0 0 1 0 .11l-.76 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "261.786px 208.781px",
            }}
            className="animable"
          />
          <path
            d="M276.79 198a.08.08 0 0 1 .1 0 .14.14 0 0 1 .06.1v.25a.29.29 0 0 1 0 .16c0 .05-.05.09-.09.11l-1.6.92.22 1.61 1.51-.87a.08.08 0 0 1 .1 0 .17.17 0 0 1 .06.11v.25a.39.39 0 0 1 0 .15c0 .05-.05.09-.09.11l-1.51.87.26 1.82a.26.26 0 0 1 0 .15.19.19 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.2.2 0 0 1 .09-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "275.938px 200.979px",
            }}
            className="animable"
          />
          <path
            d="M278.85 196.8a1.16 1.16 0 0 1 .46-.18.66.66 0 0 1 .73.34 1.57 1.57 0 0 1 .19.59 2.23 2.23 0 0 1-.07 1 2.11 2.11 0 0 1-.44.76l1 1.4a.19.19 0 0 1 0 .07.25.25 0 0 1 0 .12c0 .05 0 .08-.07.09l-.21.13h-.15l-.09-.08-1-1.36-.84.48.26 1.77a.47.47 0 0 1 0 .16.24.24 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.39.39 0 0 1 0-.15.17.17 0 0 1 .09-.11Zm-.52 2.76.82-.48a1.18 1.18 0 0 0 .62-1.26c0-.3-.14-.47-.29-.52a.8.8 0 0 0-.57.13l-.82.48Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "279.125px 199.465px",
            }}
            className="animable"
          />
          <path
            d="M281.54 200.5a.11.11 0 0 1-.11 0 .19.19 0 0 1-.05-.11l-.64-4.48a.31.31 0 0 1 0-.16.31.31 0 0 1 .08-.11l.2-.11a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11l.64 4.48a.26.26 0 0 1 0 .15.2.2 0 0 1-.08.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "281.28px 198.015px",
            }}
            className="animable"
          />
          <path
            d="M284.93 195.32c0 .21.06.39.08.55s.05.34.07.54a3.47 3.47 0 0 1 0 .85 2.57 2.57 0 0 1-.2.76 2.55 2.55 0 0 1-.37.62 2.31 2.31 0 0 1-.54.45l-1.14.66a.08.08 0 0 1-.1 0 .14.14 0 0 1-.06-.1l-.64-4.48a.3.3 0 0 1 0-.16.24.24 0 0 1 .08-.11l1.12-.64a1.39 1.39 0 0 1 .58-.2.83.83 0 0 1 .49.12 1 1 0 0 1 .37.43 2.18 2.18 0 0 1 .26.71Zm-.46.3a2.13 2.13 0 0 0-.13-.45.83.83 0 0 0-.22-.32.6.6 0 0 0-.33-.12 1 1 0 0 0-.46.15l-.77.45.52 3.6.79-.46a1.4 1.4 0 0 0 .43-.36 2 2 0 0 0 .24-.45 2.1 2.1 0 0 0 .09-.5 2.9 2.9 0 0 0 0-.51v-.51a2 2 0 0 0 0-.24c-.13-.08-.15-.17-.16-.28Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "283.563px 196.913px",
            }}
            className="animable"
          />
          <path
            d="m287.92 195.63-1.69 1-.12 1.07a1 1 0 0 1 0 .14.22.22 0 0 1-.13.14l-.18.11a.08.08 0 0 1-.08 0s0 0-.05-.08a.49.49 0 0 1 0-.11l.57-5.06a.73.73 0 0 1 .05-.2.27.27 0 0 1 .14-.16l.29-.17a.14.14 0 0 1 .16 0 .48.48 0 0 1 .09.11l1.81 3.69v.08a.27.27 0 0 1 0 .13.22.22 0 0 1-.07.09l-.18.11h-.14a.18.18 0 0 1-.07-.08Zm-1.61.25 1.35-.78-1-2.09Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "287.227px 195.193px",
            }}
            className="animable"
          />
          <path
            d="M290.31 195.23a.31.31 0 0 1 0 .16.18.18 0 0 1-.09.1l-.2.12a.09.09 0 0 1-.1 0 .14.14 0 0 1 0-.11l-.24-1.62-1.56-2.13a.2.2 0 0 1 0-.08.25.25 0 0 1 0-.12.11.11 0 0 1 .07-.09l.21-.12c.06 0 .11-.05.14 0l.09.08 1.21 1.69.58-2.73a.88.88 0 0 1 .05-.15.29.29 0 0 1 .13-.14l.21-.12a.07.07 0 0 1 .09 0 .13.13 0 0 1 0 .09.54.54 0 0 1 0 .11l-.76 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "289.51px 192.789px",
            }}
            className="animable"
          />
          <path
            d="M303.73 182.35a1.16 1.16 0 0 1 .54-.17.94.94 0 0 1 .43.1.79.79 0 0 1 .3.27.91.91 0 0 1 .15.34.29.29 0 0 1 0 .13.24.24 0 0 1-.08.09l-.2.11a.16.16 0 0 1-.09 0 .24.24 0 0 1-.08-.09.58.58 0 0 0-.11-.13.41.41 0 0 0-.18-.12.51.51 0 0 0-.25 0 .68.68 0 0 0-.33.11 1.18 1.18 0 0 0-.25.19 1.39 1.39 0 0 0-.21.27 1.66 1.66 0 0 0-.12.31.83.83 0 0 0 0 .35.55.55 0 0 0 .1.28.31.31 0 0 0 .21.12 1 1 0 0 0 .34 0l.49-.08a1.83 1.83 0 0 1 .5 0 .8.8 0 0 1 .36.09.73.73 0 0 1 .23.26 2 2 0 0 1 .12.43 1.91 1.91 0 0 1 0 .63 1.85 1.85 0 0 1-.2.6 2.24 2.24 0 0 1-.89.94 1.4 1.4 0 0 1-.54.19.86.86 0 0 1-.78-.33.85.85 0 0 1-.17-.39.29.29 0 0 1 0-.13.22.22 0 0 1 .07-.09l.2-.11h.09c.02 0 .06 0 .09.08a.45.45 0 0 0 .12.16.41.41 0 0 0 .19.12.59.59 0 0 0 .27 0 .83.83 0 0 0 .36-.13 2.43 2.43 0 0 0 .32-.24 1.78 1.78 0 0 0 .24-.32 1.14 1.14 0 0 0 .15-.36.88.88 0 0 0 0-.36.38.38 0 0 0-.13-.26.48.48 0 0 0-.26-.11 1.29 1.29 0 0 0-.38 0l-.51.09a1.12 1.12 0 0 1-.44 0 .62.62 0 0 1-.32-.13.67.67 0 0 1-.21-.28 1.53 1.53 0 0 1-.11-.41 2.44 2.44 0 0 1 0-.54 2.23 2.23 0 0 1 .16-.56 2 2 0 0 1 .32-.51 1.81 1.81 0 0 1 .49-.41Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "304.186px 184.878px",
            }}
            className="animable"
          />
          <path
            d="m308.29 183.87-1.7 1-.12 1.07a.48.48 0 0 1 0 .15.31.31 0 0 1-.12.14l-.18.1a.08.08 0 0 1-.09 0 .13.13 0 0 1 0-.09.39.39 0 0 1 0-.11l.57-5.06a1.94 1.94 0 0 1 .05-.2.31.31 0 0 1 .14-.16l.29-.17h.16a.34.34 0 0 1 .09.12l1.82 3.68a.23.23 0 0 1 0 .09.25.25 0 0 1 0 .12.17.17 0 0 1-.07.09l-.18.11h-.15a.31.31 0 0 1-.07-.09Zm-1.62.25 1.36-.78-1-2.08Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "307.64px 183.442px",
            }}
            className="animable"
          />
          <path
            d="M310.74 178.38a.08.08 0 0 1 .1 0 .14.14 0 0 1 .06.1v.25a.44.44 0 0 1 0 .16s-.05.09-.09.11l-.91.52.58 4a.41.41 0 0 1 0 .16.2.2 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.57-4-.92.53a.08.08 0 0 1-.1 0 .11.11 0 0 1-.05-.1v-.25a.29.29 0 0 1 0-.16.2.2 0 0 1 .09-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "309.643px 181.139px",
            }}
            className="animable"
          />
          <path
            d="M313.87 176.58a.09.09 0 0 1 .1 0 .13.13 0 0 1 0 .11l.4 2.77a3.94 3.94 0 0 1 0 .83 3.1 3.1 0 0 1-.15.76 1.9 1.9 0 0 1-.35.64 1.81 1.81 0 0 1-.57.49 1.21 1.21 0 0 1-.62.2.71.71 0 0 1-.47-.17 1.39 1.39 0 0 1-.32-.49 3.49 3.49 0 0 1-.18-.74l-.4-2.78a.39.39 0 0 1 0-.15.2.2 0 0 1 .09-.11l.2-.12a.08.08 0 0 1 .1 0 .17.17 0 0 1 .06.11l.4 2.8a1.23 1.23 0 0 0 .37.88.56.56 0 0 0 .67 0 1.33 1.33 0 0 0 .58-.69 2.31 2.31 0 0 0 .08-1.14l-.4-2.81a.26.26 0 0 1 0-.15.24.24 0 0 1 .08-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "312.847px 179.472px",
            }}
            className="animable"
          />
          <path
            d="M316.12 175.28a1.56 1.56 0 0 1 .46-.18.7.7 0 0 1 .41 0 .83.83 0 0 1 .32.3 1.57 1.57 0 0 1 .19.59 2.23 2.23 0 0 1-.07 1 2.16 2.16 0 0 1-.44.77l1 1.39a.25.25 0 0 1 0 .07.3.3 0 0 1 0 .13.22.22 0 0 1-.07.09l-.21.12h-.16a.6.6 0 0 1-.08-.08l-1-1.36-.84.49.26 1.76a.44.44 0 0 1 0 .16.2.2 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.64-4.48a.39.39 0 0 1 0-.15.2.2 0 0 1 .09-.11Zm-.52 2.72.82-.47a1.34 1.34 0 0 0 .51-.52 1.2 1.2 0 0 0 .11-.75c-.05-.29-.14-.47-.29-.51a.71.71 0 0 0-.57.13l-.82.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "316.395px 177.917px",
            }}
            className="animable"
          />
          <path
            d="M320.9 174.55c0 .21.06.39.08.55s0 .34.07.55a3.46 3.46 0 0 1 0 .85 3 3 0 0 1-.2.75 2.29 2.29 0 0 1-.38.62 2.08 2.08 0 0 1-.53.45l-1.14.66a.11.11 0 0 1-.11 0 .13.13 0 0 1-.05-.11l-.64-4.48a.26.26 0 0 1 0-.15.2.2 0 0 1 .08-.11l1.12-.65a1.37 1.37 0 0 1 .57-.19.84.84 0 0 1 .5.11 1.22 1.22 0 0 1 .37.43 2.18 2.18 0 0 1 .26.72Zm-.46.31a1.84 1.84 0 0 0-.13-.45.7.7 0 0 0-.22-.32.48.48 0 0 0-.33-.12 1 1 0 0 0-.46.15l-.77.44.52 3.61.79-.46a1.48 1.48 0 0 0 .42-.36 1.58 1.58 0 0 0 .25-.46 2 2 0 0 0 .09-.5 2.9 2.9 0 0 0 0-.51v-.74c0-.08-.15-.14-.16-.28Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "319.533px 176.141px",
            }}
            className="animable"
          />
          <path
            d="m323.89 174.86-1.69 1-.12 1.06a.83.83 0 0 1 0 .15.29.29 0 0 1-.13.14l-.18.1a.06.06 0 0 1-.08 0 .13.13 0 0 1 0-.09.54.54 0 0 1 0-.11l.57-5.06a.84.84 0 0 1 .05-.2.29.29 0 0 1 .13-.16l.29-.17h.16a.36.36 0 0 1 .1.11l1.81 3.68v.09a.32.32 0 0 1 0 .13s0 .07-.07.08l-.18.11a.13.13 0 0 1-.14 0l-.08-.08Zm-1.61.25 1.35-.78-1-2.08Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "323.244px 174.423px",
            }}
            className="animable"
          />
          <path
            d="M326.28 174.46a.44.44 0 0 1 0 .16.2.2 0 0 1-.09.11l-.2.11a.09.09 0 0 1-.1 0 .17.17 0 0 1-.06-.11l-.23-1.62L324 171a.12.12 0 0 1 0-.08.28.28 0 0 1 0-.13.35.35 0 0 1 .07-.09l.21-.12h.15a.27.27 0 0 1 .08.07l1.22 1.69.58-2.72a1 1 0 0 1 .05-.16.34.34 0 0 1 .13-.14l.21-.12h.08a.13.13 0 0 1 .05.09.62.62 0 0 1 0 .12l-.77 3.46Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "325.413px 172.028px",
            }}
            className="animable"
          />
          <path
            d="M338.44 162.31a1.16 1.16 0 0 1 .55-.17 1 1 0 0 1 .43.1 1 1 0 0 1 .3.27 1.07 1.07 0 0 1 .14.34.2.2 0 0 1 0 .13.22.22 0 0 1-.07.09l-.2.11h-.09a.19.19 0 0 1-.09-.09.5.5 0 0 0-.1-.13.57.57 0 0 0-.18-.12.55.55 0 0 0-.26 0 .68.68 0 0 0-.33.11 1.1 1.1 0 0 0-.25.19 1.05 1.05 0 0 0-.2.27 1.07 1.07 0 0 0-.13.31 1 1 0 0 0 0 .35.57.57 0 0 0 .1.27.32.32 0 0 0 .21.12 1.23 1.23 0 0 0 .34 0l.49-.08a2 2 0 0 1 .51 0 .9.9 0 0 1 .35.1.65.65 0 0 1 .23.26 1.28 1.28 0 0 1 .12.43 1.9 1.9 0 0 1 0 .63 2.49 2.49 0 0 1-.2.6 2.66 2.66 0 0 1-.37.53 2.15 2.15 0 0 1-.53.41 1.23 1.23 0 0 1-.54.18.74.74 0 0 1-.45-.07.81.81 0 0 1-.33-.25 1 1 0 0 1-.17-.39.3.3 0 0 1 0-.13.16.16 0 0 1 .07-.09l.2-.11h.08a.19.19 0 0 1 .09.09.59.59 0 0 0 .31.28.62.62 0 0 0 .28 0 1 1 0 0 0 .35-.13 1.54 1.54 0 0 0 .32-.25 1.48 1.48 0 0 0 .25-.31 1.61 1.61 0 0 0 .15-.36.88.88 0 0 0 0-.36.48.48 0 0 0-.12-.27.51.51 0 0 0-.26-.1 1.34 1.34 0 0 0-.39 0l-.5.09a1.41 1.41 0 0 1-.45 0 .66.66 0 0 1-.32-.13.74.74 0 0 1-.21-.28 2 2 0 0 1-.1-1 2.21 2.21 0 0 1 .15-.56 2.29 2.29 0 0 1 .32-.51 2 2 0 0 1 .5-.37Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "338.891px 164.835px",
            }}
            className="animable"
          />
          <path
            d="M342.88 159.83a.09.09 0 0 1 .1 0 .17.17 0 0 1 .06.11l.39 2.77a3.37 3.37 0 0 1 0 .83 2.69 2.69 0 0 1-.14.76 2.09 2.09 0 0 1-.35.64 1.74 1.74 0 0 1-.58.49 1.21 1.21 0 0 1-.62.2.69.69 0 0 1-.46-.17 1.27 1.27 0 0 1-.28-.46 3.41 3.41 0 0 1-.19-.75l-.39-2.77a.2.2 0 0 1 0-.15.19.19 0 0 1 .08-.11l.2-.12a.08.08 0 0 1 .1 0 .17.17 0 0 1 .06.11l.4 2.8a1.32 1.32 0 0 0 .37.88.57.57 0 0 0 .67 0 1.28 1.28 0 0 0 .58-.69 2.21 2.21 0 0 0 .12-1.2l-.4-2.81a.26.26 0 0 1 0-.15.24.24 0 0 1 .08-.11Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "341.931px 162.722px",
            }}
            className="animable"
          />
          <path
            d="M346.76 162.84a.1.1 0 0 1-.13 0 .41.41 0 0 1-.1-.09l-2.07-2.48.49 3.41a.3.3 0 0 1 0 .16.24.24 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .11.11 0 0 1-.06-.11l-.64-4.48a.26.26 0 0 1 0-.15.2.2 0 0 1 .08-.11l.17-.1a.1.1 0 0 1 .13 0l.1.1 2.07 2.47-.49-3.41a.26.26 0 0 1 0-.15.2.2 0 0 1 .07-.12l.2-.12a.09.09 0 0 1 .1 0 .15.15 0 0 1 .06.11l.64 4.48a.31.31 0 0 1 0 .16.21.21 0 0 1-.08.1Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "345.435px 160.97px",
            }}
            className="animable"
          />
          <path
            d="M350.12 157.68c0 .21.06.39.08.55s.05.34.08.55a3.45 3.45 0 0 1 0 .85 2.59 2.59 0 0 1-.2.75 2.27 2.27 0 0 1-.37.62 2.12 2.12 0 0 1-.54.45l-1.14.66a.09.09 0 0 1-.1 0 .2.2 0 0 1-.06-.11l-.64-4.48a.31.31 0 0 1 0-.16.21.21 0 0 1 .08-.1l1.12-.65a1.28 1.28 0 0 1 .58-.19.75.75 0 0 1 .49.11 1.08 1.08 0 0 1 .38.43 2.45 2.45 0 0 1 .24.72Zm-.46.3a3 3 0 0 0-.12-.45.84.84 0 0 0-.23-.31.48.48 0 0 0-.33-.12.8.8 0 0 0-.46.15l-.76.44.51 3.6.79-.45a1.3 1.3 0 0 0 .43-.37 1.4 1.4 0 0 0 .24-.45 1.71 1.71 0 0 0 .1-.5 4.35 4.35 0 0 0 0-.51v-.51a2 2 0 0 0 0-.24c-.14-.08-.15-.17-.17-.26Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "348.763px 159.27px",
            }}
            className="animable"
          />
          <path
            d="m353.11 158-1.69 1-.12 1a.56.56 0 0 1 0 .15.31.31 0 0 1-.12.14l-.19.1a.06.06 0 0 1-.08 0 .19.19 0 0 1-.05-.09.54.54 0 0 1 0-.11l.57-5.06a1.94 1.94 0 0 1 .05-.2.31.31 0 0 1 .14-.16l.29-.17a.14.14 0 0 1 .16 0 .44.44 0 0 1 .09.11l1.82 3.69a.19.19 0 0 1 0 .09.17.17 0 0 1 0 .12.13.13 0 0 1-.06.09l-.19.11h-.14a.28.28 0 0 1-.07-.09Zm-1.61.25 1.35-.78-1-2.09Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "352.424px 157.49px",
            }}
            className="animable"
          />
          <path
            d="M355.5 157.59a.31.31 0 0 1 0 .16.31.31 0 0 1-.08.11l-.2.11a.09.09 0 0 1-.1 0 .11.11 0 0 1-.06-.11l-.24-1.62-1.56-2.12v-.09a.25.25 0 0 1 0-.12.13.13 0 0 1 .07-.09l.21-.12h.14a.34.34 0 0 1 .09.08l1.21 1.69.59-2.73a.44.44 0 0 1 .05-.15.29.29 0 0 1 .13-.14l.2-.12a.07.07 0 0 1 .09 0 .13.13 0 0 1 0 .09.22.22 0 0 1 0 .11l-.76 3.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "354.65px 155.149px",
            }}
            className="animable"
          />
          <path
            d="M155.08 293.66a6.19 6.19 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.28-.78-.25-1.35.08a2.61 2.61 0 0 0-.73.62 3 3 0 0 0-.45.8 4 4 0 0 0-.23.92 7.45 7.45 0 0 0-.07.95 1.12 1.12 0 0 1-.09.39.53.53 0 0 1-.19.22l-.58.34a.22.22 0 0 1-.22 0 .35.35 0 0 1-.12-.24 5.68 5.68 0 0 1 0-1.48 6.89 6.89 0 0 1 .41-1.59 6.56 6.56 0 0 1 .8-1.47 4 4 0 0 1 1.22-1.09 2.61 2.61 0 0 1 1.28-.41 1.67 1.67 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 4.69 4.69 0 0 1 .4 1.4 7.16 7.16 0 0 1 .09 1.09 6.77 6.77 0 0 1-.08 1 8.46 8.46 0 0 1-.26 1.05 11.6 11.6 0 0 1-.45 1.14l-2.3 5.41 3.9-2.25a.24.24 0 0 1 .27 0 .43.43 0 0 1 .15.29l.09.65a.84.84 0 0 1 0 .41.59.59 0 0 1-.22.28l-5.5 3.17a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.38 3.27 3.27 0 0 1 .16-.47Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "154.468px 295.023px",
            }}
            className="animable"
          />
          <path
            d="M159 294.72a5.16 5.16 0 0 1 .08-1.91 6.19 6.19 0 0 1 .72-1.84 1.91 1.91 0 0 1-.9-.75 3.26 3.26 0 0 1-.48-1.36 4.74 4.74 0 0 1 0-1.5 5.84 5.84 0 0 1 .45-1.49 5.93 5.93 0 0 1 .83-1.31 4.7 4.7 0 0 1 1.14-1 2.82 2.82 0 0 1 1.22-.4 1.95 1.95 0 0 1 1.84 1 3.36 3.36 0 0 1 .42 1.25 4.66 4.66 0 0 1-.06 1.66 6.4 6.4 0 0 1-.56 1.61 2.1 2.1 0 0 1 1.09.79 3.25 3.25 0 0 1 .58 1.52 5.46 5.46 0 0 1 0 1.61 5.91 5.91 0 0 1-.49 1.58 5.58 5.58 0 0 1-.9 1.4 4.59 4.59 0 0 1-1.24 1.05 3.11 3.11 0 0 1-1.33.44 2 2 0 0 1-1.13-.23 2.2 2.2 0 0 1-.84-.82 3.54 3.54 0 0 1-.44-1.3Zm.63-6.56a1.53 1.53 0 0 0 .25.68 1 1 0 0 0 .45.39 1.23 1.23 0 0 0 .61.09 1.71 1.71 0 0 0 .71-.24 2.57 2.57 0 0 0 .68-.56 3.26 3.26 0 0 0 .5-.73 3 3 0 0 0 .28-.82 2.34 2.34 0 0 0 0-.83 1.61 1.61 0 0 0-.24-.67 1 1 0 0 0-.46-.4 1.25 1.25 0 0 0-.62-.08 1.8 1.8 0 0 0-.72.24 2.89 2.89 0 0 0-.66.56 3.2 3.2 0 0 0-.5.72 3.46 3.46 0 0 0-.28.82 2.6 2.6 0 0 0 0 .83Zm.58 5.86a1.67 1.67 0 0 0 .27.75 1.13 1.13 0 0 0 .5.45 1.29 1.29 0 0 0 .69.1 2 2 0 0 0 .84-.3 3 3 0 0 0 .77-.63 3.83 3.83 0 0 0 .57-.83 3.38 3.38 0 0 0 .31-.91 2.92 2.92 0 0 0 0-.93 2 2 0 0 0-.27-.76 1.22 1.22 0 0 0-1.2-.54 2.07 2.07 0 0 0-.83.29 3.26 3.26 0 0 0-.79.64 4.1 4.1 0 0 0-.56.82 3.84 3.84 0 0 0-.31.92 2.64 2.64 0 0 0 .01.91Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "161.895px 290.117px",
            }}
            className="animable"
          />
          <path
            d="M192.64 278.67a.81.81 0 0 1 0 .4.5.5 0 0 1-.22.28l-.52.31a.24.24 0 0 1-.27 0 .41.41 0 0 1-.15-.28l-1.43-10-1.74 3.42a.45.45 0 0 1-.24.25.26.26 0 0 1-.26 0l-.39-.39a.49.49 0 0 1-.12-.32.85.85 0 0 1 .09-.41l2.3-4.55a.69.69 0 0 1 .19-.24l.2-.14.52-.3a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "189.982px 273.18px",
            }}
            className="animable"
          />
          <path
            d="M222.9 254.5a6.26 6.26 0 0 0 .44-1.33 4.27 4.27 0 0 0 0-1.43 2.13 2.13 0 0 0-.63-1.38c-.32-.28-.77-.25-1.34.08a2.48 2.48 0 0 0-.73.62 3 3 0 0 0-.45.8 4 4 0 0 0-.23.92c0 .31-.07.63-.08.95a.8.8 0 0 1-.09.39.46.46 0 0 1-.18.22l-.59.34a.2.2 0 0 1-.21 0 .31.31 0 0 1-.12-.24 5.68 5.68 0 0 1 0-1.48 6.42 6.42 0 0 1 .41-1.59 6.56 6.56 0 0 1 .8-1.47 4 4 0 0 1 1.22-1.09 2.58 2.58 0 0 1 1.28-.41 1.67 1.67 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 5 5 0 0 1 .4 1.4c0 .39.08.75.09 1.09a6 6 0 0 1-.09 1 6.82 6.82 0 0 1-.25 1q-.18.52-.45 1.14l-2.3 5.41 3.9-2.25a.23.23 0 0 1 .26 0 .43.43 0 0 1 .15.29l.1.65a.74.74 0 0 1-.06.41.49.49 0 0 1-.22.28l-5.49 3.17a.22.22 0 0 1-.27 0 .41.41 0 0 1-.15-.29l-.09-.65a1.2 1.2 0 0 1 0-.38 3.54 3.54 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "222.289px 255.838px",
            }}
            className="animable"
          />
          <path
            d="M252.4 241.38a2.37 2.37 0 0 0 .26.47.88.88 0 0 0 .42.32 1.29 1.29 0 0 0 .66 0 3.32 3.32 0 0 0 1-.42 3.66 3.66 0 0 0 .74-.57 3.22 3.22 0 0 0 .56-.79 3.89 3.89 0 0 0 .33-1 3.49 3.49 0 0 0 0-1.12 2.11 2.11 0 0 0-.3-.9.93.93 0 0 0-.5-.41 1.27 1.27 0 0 0-.67 0 3.75 3.75 0 0 0-.8.34l-1 .61a.22.22 0 0 1-.27 0 .43.43 0 0 1-.15-.29l-.09-.65a.67.67 0 0 1 0-.34 2 2 0 0 1 .1-.32l1.79-4.85-3.68 2.12a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a.7.7 0 0 1 .05-.4.52.52 0 0 1 .22-.29l5-2.9a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28l.09.65a.89.89 0 0 1 0 .36 1.46 1.46 0 0 1-.12.39l-1.76 4.77a3.1 3.1 0 0 1 1.21-.39 1.66 1.66 0 0 1 1 .22 2 2 0 0 1 .75.82 4 4 0 0 1 .43 1.41 5.77 5.77 0 0 1 0 1.81 6.26 6.26 0 0 1-.5 1.62 6 6 0 0 1-.9 1.36 5 5 0 0 1-1.19 1 4 4 0 0 1-1.51.57 2 2 0 0 1-1.13-.16 1.82 1.82 0 0 1-.75-.68 3.2 3.2 0 0 1-.38-1 .64.64 0 0 1 .05-.33.39.39 0 0 1 .18-.23l.58-.34a.2.2 0 0 1 .24 0 .35.35 0 0 1 .12.2Z"
            style={{
              fill: "#455a64",
              transformOrigin: "253.976px 236.475px",
            }}
            className="animable"
          />
          <path
            d="M288.05 224.11a.23.23 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-.36-2.5-4 2.31a.26.26 0 0 1-.27 0 .43.43 0 0 1-.15-.29l-.09-.65a1.8 1.8 0 0 1 0-.33 1.38 1.38 0 0 1 .09-.39l2.95-9.83a1.91 1.91 0 0 1 .18-.45.71.71 0 0 1 .26-.28l.51-.29a.23.23 0 0 1 .26 0 .43.43 0 0 1 .15.29l1.09 7.58 1.09-.64a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.28l.09.66a.79.79 0 0 1-.05.4.56.56 0 0 1-.22.29l-1.1.63.36 2.5a.84.84 0 0 1-.05.41.59.59 0 0 1-.22.28Zm-1-4.42-.74-5.12-2 6.71Z"
            style={{
              fill: "#455a64",
              transformOrigin: "286.315px 217.615px",
            }}
            className="animable"
          />
          <path
            d="M316.34 204.21a1.38 1.38 0 0 0 .92.93 1.77 1.77 0 0 0 1.37-.25 3.44 3.44 0 0 0 .77-.62 3.39 3.39 0 0 0 .57-.86 3.66 3.66 0 0 0 .31-1.08 4.29 4.29 0 0 0 0-1.24A3 3 0 0 0 320 200a1.49 1.49 0 0 0-.56-.58 1.13 1.13 0 0 0-.71-.11 2.15 2.15 0 0 0-.81.29 2.66 2.66 0 0 0-.75.6 4 4 0 0 0-.43.6c-.1.18-.2.36-.28.52a1 1 0 0 1-.32.35l-.65.37a.2.2 0 0 1-.21 0 .35.35 0 0 1-.13-.24l-.48-6.27a.83.83 0 0 1 .05-.41.59.59 0 0 1 .22-.28l4.5-2.6a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28l.09.65a.83.83 0 0 1-.05.41.53.53 0 0 1-.22.28l-3.75 2.14.24 3.26a4.8 4.8 0 0 1 .56-.62 4 4 0 0 1 .91-.68 3.14 3.14 0 0 1 1.3-.44 2 2 0 0 1 1.15.25 2.46 2.46 0 0 1 .89.94 4.4 4.4 0 0 1 .51 1.64 6.24 6.24 0 0 1 0 1.93 6.56 6.56 0 0 1-.5 1.75 6 6 0 0 1-.91 1.43 4.64 4.64 0 0 1-1.22 1 3.21 3.21 0 0 1-1.25.45 2.17 2.17 0 0 1-1.12-.13 2 2 0 0 1-.87-.7 2.78 2.78 0 0 1-.48-1.24.63.63 0 0 1 0-.33.43.43 0 0 1 .18-.23l.68-.28a.22.22 0 0 1 .21 0 .38.38 0 0 1 .13.21Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "318.114px 199.566px",
            }}
            className="animable"
          />
          <path
            d="m349.21 179.64.21-.2a2 2 0 0 1 .24-.16 2.8 2.8 0 0 1 1.36-.43 2.07 2.07 0 0 1 1.18.32 2.78 2.78 0 0 1 .89 1 4.52 4.52 0 0 1 .49 1.58 6.51 6.51 0 0 1 0 1.87 7 7 0 0 1-.49 1.78 6.13 6.13 0 0 1-.91 1.53 4.71 4.71 0 0 1-1.27 1.1 2.87 2.87 0 0 1-1.37.43 2.07 2.07 0 0 1-1.18-.32 2.87 2.87 0 0 1-.89-1 4.73 4.73 0 0 1-.49-1.58 6.05 6.05 0 0 1-.06-1 7.93 7.93 0 0 1 .1-1 9 9 0 0 1 .19-.93c.07-.31.15-.6.23-.88l1.63-6.2c0-.09.07-.19.1-.31a.47.47 0 0 1 .24-.28l.73-.42a.15.15 0 0 1 .2 0 .39.39 0 0 1 .11.24.43.43 0 0 1 0 .16v.11Zm-1 5.22a2.81 2.81 0 0 0 .29.94 1.82 1.82 0 0 0 .54.64 1.3 1.3 0 0 0 .75.22 1.75 1.75 0 0 0 .9-.27 2.81 2.81 0 0 0 .84-.73 3.75 3.75 0 0 0 .57-1 4.33 4.33 0 0 0 .29-1.11 4.2 4.2 0 0 0 0-1.12 2.94 2.94 0 0 0-.29-.95 1.88 1.88 0 0 0-.54-.63 1.35 1.35 0 0 0-.74-.23 1.77 1.77 0 0 0-.91.28 3.07 3.07 0 0 0-.84.73 3.75 3.75 0 0 0-.57 1 4.78 4.78 0 0 0-.29 1.11 4.2 4.2 0 0 0-.02 1.12Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "350.283px 181.482px",
            }}
            className="animable"
          />
          <path
            d="M163.58 311a.23.23 0 0 1 .26 0 .38.38 0 0 1 .15.28l.09.65a2.17 2.17 0 0 1 0 .37v.44l-1.35 12a2.34 2.34 0 0 1-.09.38.48.48 0 0 1-.21.27l-.59.34a.21.21 0 0 1-.24 0 .38.38 0 0 1-.13-.26.21.21 0 0 1 0-.08.47.47 0 0 1 0-.16l1.35-12-4.18 2.42a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-.1-.65a.74.74 0 0 1 .06-.41.49.49 0 0 1 .22-.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "161.105px 318.364px",
            }}
            className="animable"
          />
          <path
            d="M191.05 304.92a5.33 5.33 0 0 1 .08-1.9 6.19 6.19 0 0 1 .72-1.84 2 2 0 0 1-.9-.75 3.13 3.13 0 0 1-.47-1.36 4.8 4.8 0 0 1 0-1.51 6.12 6.12 0 0 1 .46-1.49 5.41 5.41 0 0 1 .83-1.3 4.47 4.47 0 0 1 1.13-1 2.73 2.73 0 0 1 1.23-.4 1.92 1.92 0 0 1 1.83 1 3.36 3.36 0 0 1 .42 1.25 4.89 4.89 0 0 1-.05 1.66 6.22 6.22 0 0 1-.57 1.6 2.08 2.08 0 0 1 1.09.8 3.21 3.21 0 0 1 .58 1.52 5.07 5.07 0 0 1 0 1.6 6 6 0 0 1-.49 1.59 5.84 5.84 0 0 1-.89 1.4 4.79 4.79 0 0 1-1.25 1.05 3.11 3.11 0 0 1-1.33.44 2 2 0 0 1-1.13-.23 2.25 2.25 0 0 1-.83-.82 3.37 3.37 0 0 1-.46-1.31Zm.64-6.55a1.45 1.45 0 0 0 .24.68 1 1 0 0 0 .45.39 1.27 1.27 0 0 0 .62.09 1.81 1.81 0 0 0 .71-.24 2.94 2.94 0 0 0 .67-.56 3.51 3.51 0 0 0 .5-.73 3.09 3.09 0 0 0 .29-.82 2.59 2.59 0 0 0 0-.83 1.71 1.71 0 0 0-.24-.68 1 1 0 0 0-.46-.39 1.21 1.21 0 0 0-.61-.09 1.88 1.88 0 0 0-.72.25 2.69 2.69 0 0 0-.67.55 3.46 3.46 0 0 0-.49.73 3.09 3.09 0 0 0-.29.82 2.59 2.59 0 0 0 0 .83Zm.57 5.85a1.67 1.67 0 0 0 .27.76 1.2 1.2 0 0 0 .5.45 1.44 1.44 0 0 0 .7.1 2.27 2.27 0 0 0 .83-.3 3.13 3.13 0 0 0 .78-.63 3.67 3.67 0 0 0 .56-.83 3.33 3.33 0 0 0 .31-.92 2.85 2.85 0 0 0 0-.92 1.72 1.72 0 0 0-.27-.76 1.27 1.27 0 0 0-.5-.45 1.35 1.35 0 0 0-.7-.09 2 2 0 0 0-.83.29 2.84 2.84 0 0 0-.78.64 3.41 3.41 0 0 0-.56.82 3.33 3.33 0 0 0-.31.92 2.85 2.85 0 0 0 0 .92Z"
            style={{
              fill: "#455a64",
              transformOrigin: "193.957px 300.327px",
            }}
            className="animable"
          />
          <path
            d="M226.43 283.69a1.06 1.06 0 0 1-.18.13l-.16.11a3 3 0 0 1-1.23.4 1.94 1.94 0 0 1-1.14-.23 2.46 2.46 0 0 1-.91-.93 4.43 4.43 0 0 1-.54-1.67 6.37 6.37 0 0 1 0-1.85 6.86 6.86 0 0 1 .5-1.76 6.26 6.26 0 0 1 .89-1.48 4.25 4.25 0 0 1 1.18-1 3 3 0 0 1 1.38-.44 1.92 1.92 0 0 1 1.14.31 2.66 2.66 0 0 1 .83 1 5.1 5.1 0 0 1 .47 1.57 4.52 4.52 0 0 1 0 1 9.47 9.47 0 0 1-.12 1c-.06.35-.13.69-.21 1s-.16.64-.23.91l-1.63 6.2-.11.31a.45.45 0 0 1-.23.28l-.73.42a.15.15 0 0 1-.2 0 .39.39 0 0 1-.11-.24.43.43 0 0 1 0-.16v-.11Zm1-5.19a2.85 2.85 0 0 0-.29-1 1.54 1.54 0 0 0-.53-.61 1.17 1.17 0 0 0-.71-.19 1.86 1.86 0 0 0-.83.26 3 3 0 0 0-.79.67 3.77 3.77 0 0 0-.54.91 4.3 4.3 0 0 0-.29 1.08 4 4 0 0 0 0 1.14 2.78 2.78 0 0 0 .29 1 1.57 1.57 0 0 0 .53.6 1.23 1.23 0 0 0 .71.2 1.8 1.8 0 0 0 .83-.27 3 3 0 0 0 .78-.66 3.74 3.74 0 0 0 .55-.92 4.34 4.34 0 0 0 .29-1.07 4 4 0 0 0 .03-1.14Z"
            style={{
              fill: "#455a64",
              transformOrigin: "225.445px 281.988px",
            }}
            className="animable"
          />
          <path
            d="M256.33 270.61a.7.7 0 0 1-.05.4.56.56 0 0 1-.22.29l-.52.3a.24.24 0 0 1-.27 0 .38.38 0 0 1-.15-.28l-1.43-10-1.69 3.42c-.07.14-.15.23-.24.25a.26.26 0 0 1-.26 0l-.38-.39a.45.45 0 0 1-.13-.32.9.9 0 0 1 .09-.4l2.3-4.55a.65.65 0 0 1 .19-.25l.2-.14.52-.3a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "253.665px 265.12px",
            }}
            className="animable"
          />
          <path
            d="M263.52 258.47c.08.54.16 1 .23 1.53s.13 1 .2 1.54a10.47 10.47 0 0 1 .07 2.09 7.35 7.35 0 0 1-.36 1.92 5.5 5.5 0 0 1-.85 1.63 4.55 4.55 0 0 1-1.39 1.22 2.91 2.91 0 0 1-1.51.46 1.83 1.83 0 0 1-1.15-.48 3.44 3.44 0 0 1-.82-1.24 8.3 8.3 0 0 1-.49-1.85c-.09-.54-.16-1.05-.23-1.52s-.14-1-.21-1.54a11.33 11.33 0 0 1-.07-2.09 7.86 7.86 0 0 1 .37-1.93 5.68 5.68 0 0 1 .85-1.64 4.44 4.44 0 0 1 1.39-1.22 2.66 2.66 0 0 1 1.5-.45 1.86 1.86 0 0 1 1.15.48 3.36 3.36 0 0 1 .82 1.25 8.19 8.19 0 0 1 .5 1.84Zm-4.87 6.13a3.61 3.61 0 0 0 .9 2.22 1.35 1.35 0 0 0 1.63-.05 3.09 3.09 0 0 0 1.4-1.69 6.4 6.4 0 0 0 .18-2.85c-.07-.55-.14-1.06-.21-1.54s-.15-1-.23-1.53a3.7 3.7 0 0 0-.91-2.23 1.33 1.33 0 0 0-1.63.05 3.07 3.07 0 0 0-1.39 1.69 6.19 6.19 0 0 0-.18 2.86c.07.55.14 1.07.21 1.54s.14.99.23 1.53Z"
            style={{
              fill: "#455a64",
              transformOrigin: "260.482px 261.88px",
            }}
            className="animable"
          />
          <path
            d="M289.66 251.37a.79.79 0 0 1-.05.4.54.54 0 0 1-.22.28l-.53.31a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-1.43-10-1.75 3.42a.4.4 0 0 1-.24.25.25.25 0 0 1-.25 0l-.39-.39a.49.49 0 0 1-.12-.32.75.75 0 0 1 .09-.41l2.3-4.54a.65.65 0 0 1 .19-.25l.2-.14.52-.3a.23.23 0 0 1 .26 0 .37.37 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "286.968px 245.88px",
            }}
            className="animable"
          />
          <path
            d="M295 248.27a.79.79 0 0 1 0 .4.58.58 0 0 1-.23.29l-.52.3a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-1.43-10-1.75 3.42c-.06.14-.14.23-.24.25a.25.25 0 0 1-.25 0l-.39-.39a.41.41 0 0 1-.12-.32.7.7 0 0 1 .09-.4L292 237a.77.77 0 0 1 .18-.25l.21-.14.52-.3a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "292.342px 242.785px",
            }}
            className="animable"
          />
          <path
            d="M320.6 233.5a.83.83 0 0 1-.05.41.53.53 0 0 1-.22.28l-.52.3a.22.22 0 0 1-.27 0 .43.43 0 0 1-.15-.29l-1.43-10-1.74 3.42a.48.48 0 0 1-.24.26.27.27 0 0 1-.26 0l-.39-.38a.55.55 0 0 1-.12-.33.81.81 0 0 1 .09-.4l2.3-4.55a.69.69 0 0 1 .19-.24l.2-.14.52-.3a.24.24 0 0 1 .27 0 .43.43 0 0 1 .15.29Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "317.908px 228.017px",
            }}
            className="animable"
          />
          <path
            d="M325.29 224.1a6 6 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.27-.77-.25-1.34.08a2.66 2.66 0 0 0-.74.62 3 3 0 0 0-.45.8 4.59 4.59 0 0 0-.23.92c0 .32-.06.63-.07 1a1.12 1.12 0 0 1-.09.39.52.52 0 0 1-.18.22l-.59.34a.2.2 0 0 1-.22 0 .39.39 0 0 1-.12-.23 6.24 6.24 0 0 1 0-1.49 6.89 6.89 0 0 1 .41-1.59 6.22 6.22 0 0 1 .81-1.47 3.93 3.93 0 0 1 1.21-1.09 2.64 2.64 0 0 1 1.29-.41 1.69 1.69 0 0 1 1 .32 2.64 2.64 0 0 1 .72.92 4.7 4.7 0 0 1 .39 1.4 7.16 7.16 0 0 1 .09 1.09 5.84 5.84 0 0 1-.08 1 6.88 6.88 0 0 1-.26 1 11.37 11.37 0 0 1-.44 1.14l-2.31 5.41 3.9-2.25a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28l.09.66a.81.81 0 0 1 0 .4.59.59 0 0 1-.22.28l-5.5 3.17a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 2.52 2.52 0 0 1 .17-.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "324.68px 225.483px",
            }}
            className="animable"
          />
          <path
            d="M352.49 215.09a.83.83 0 0 1-.05.41.55.55 0 0 1-.23.28l-.52.3a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-1.43-10-1.75 3.42a.39.39 0 0 1-.24.26.25.25 0 0 1-.25 0l-.39-.38a.49.49 0 0 1-.12-.33.8.8 0 0 1 .08-.4l2.31-4.55a.69.69 0 0 1 .19-.24l.2-.14.52-.3a.23.23 0 0 1 .26 0 .43.43 0 0 1 .15.29Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "349.798px 209.607px",
            }}
            className="animable"
          />
          <path
            d="M354.79 211a1.87 1.87 0 0 0 .26.48.87.87 0 0 0 .41.32 1.43 1.43 0 0 0 .66 0 3.36 3.36 0 0 0 1-.42 3.28 3.28 0 0 0 .73-.57 3 3 0 0 0 .57-.79 3.5 3.5 0 0 0 .32-1 3.23 3.23 0 0 0 0-1.12 2.22 2.22 0 0 0-.29-.9 1 1 0 0 0-.51-.41 1.27 1.27 0 0 0-.67 0 3.48 3.48 0 0 0-.79.34l-1.06.61a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.34c0-.12.07-.23.1-.32l1.79-4.84-3.67 2.12a.23.23 0 0 1-.26 0 .38.38 0 0 1-.16-.28l-.09-.66a.81.81 0 0 1 0-.4.58.58 0 0 1 .23-.29l5-2.9a.23.23 0 0 1 .26 0 .37.37 0 0 1 .15.28l.1.66a1.06 1.06 0 0 1 0 .35 3.57 3.57 0 0 1-.12.4l-1.77 4.76a3.1 3.1 0 0 1 1.21-.39 1.7 1.7 0 0 1 1 .22 2.17 2.17 0 0 1 .76.82 4.51 4.51 0 0 1 .43 1.41 6 6 0 0 1-1.42 4.79 5 5 0 0 1-1.2 1 4 4 0 0 1-1.51.57 2.06 2.06 0 0 1-1.13-.15 1.82 1.82 0 0 1-.74-.69 3 3 0 0 1-.38-1.05.63.63 0 0 1 0-.33.49.49 0 0 1 .18-.23l.59-.34a.21.21 0 0 1 .24 0 .44.44 0 0 1 .29.23Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "356.262px 206.116px",
            }}
            className="animable"
          />
          <path
            d="M164.37 352.42a.7.7 0 0 1-.05.4.56.56 0 0 1-.22.29l-.52.3a.24.24 0 0 1-.27 0 .38.38 0 0 1-.15-.28l-1.43-10-1.73 3.42c-.07.14-.14.23-.24.26a.27.27 0 0 1-.26-.05l-.38-.39a.45.45 0 0 1-.13-.32.93.93 0 0 1 .09-.4l2.31-4.55a.56.56 0 0 1 .18-.25l.2-.13.52-.31a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.29Z"
            style={{
              fill: "#455a64",
              transformOrigin: "161.685px 346.91px",
            }}
            className="animable"
          />
          <path
            d="M170.45 349.44a.23.23 0 0 1-.26 0 .36.36 0 0 1-.15-.29l-.36-2.5-4 2.31a.24.24 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-.09-.65a1.21 1.21 0 0 1 0-.33 1.38 1.38 0 0 1 .09-.39l3-9.83a1.91 1.91 0 0 1 .18-.45.71.71 0 0 1 .26-.28l.51-.29a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.29l1.08 7.58 1.1-.64a.22.22 0 0 1 .26 0 .38.38 0 0 1 .16.28l.09.66a.79.79 0 0 1 0 .4.62.62 0 0 1-.22.29l-1.1.63.36 2.5a.7.7 0 0 1-.06.4.48.48 0 0 1-.22.29Zm-1-4.42-.73-5.12-2 6.71Z"
            style={{
              fill: "#455a64",
              transformOrigin: "168.757px 342.945px",
            }}
            className="animable"
          />
          <path
            d="M196.44 333.9a.73.73 0 0 1-.05.41.49.49 0 0 1-.22.28l-.52.3a.21.21 0 0 1-.26 0 .38.38 0 0 1-.16-.29l-1.43-10-1.74 3.4a.42.42 0 0 1-.24.25.27.27 0 0 1-.26-.05l-.38-.38a.48.48 0 0 1-.13-.33.93.93 0 0 1 .09-.4l2.31-4.55a.58.58 0 0 1 .18-.24l.2-.14.52-.3a.24.24 0 0 1 .27 0 .43.43 0 0 1 .15.29Z"
            style={{
              fill: "#455a64",
              transformOrigin: "193.75px 328.377px",
            }}
            className="animable"
          />
          <path
            d="M198.73 329.54a1.38 1.38 0 0 0 .92.93 1.76 1.76 0 0 0 1.37-.25 3 3 0 0 0 .77-.62 3.71 3.71 0 0 0 .58-.86 4 4 0 0 0 .31-1.08 4.29 4.29 0 0 0 0-1.24 3 3 0 0 0-.33-1.06 1.38 1.38 0 0 0-.55-.57 1.07 1.07 0 0 0-.71-.12 2.13 2.13 0 0 0-.82.29 3 3 0 0 0-.75.6 3.89 3.89 0 0 0-.42.6c-.11.18-.2.36-.29.52a.82.82 0 0 1-.31.35l-.65.37a.2.2 0 0 1-.22 0 .39.39 0 0 1-.12-.24l-.48-6.27a.73.73 0 0 1 .05-.41.53.53 0 0 1 .22-.28l4.5-2.6a.23.23 0 0 1 .26 0 .36.36 0 0 1 .16.28l.09.65a.83.83 0 0 1-.05.41.55.55 0 0 1-.23.28l-3.71 2.14.25 3.26a4.63 4.63 0 0 1 .55-.62 4.67 4.67 0 0 1 .92-.68 3.09 3.09 0 0 1 1.3-.44 2 2 0 0 1 1.15.25 2.46 2.46 0 0 1 .89.94 4.8 4.8 0 0 1 .51 1.64 6.93 6.93 0 0 1 0 1.93 6.58 6.58 0 0 1-.51 1.75 6 6 0 0 1-.91 1.44 4.75 4.75 0 0 1-1.21 1 3.25 3.25 0 0 1-1.26.45 2.19 2.19 0 0 1-1.12-.13 2 2 0 0 1-.86-.7 2.91 2.91 0 0 1-.49-1.24.64.64 0 0 1 .05-.33.43.43 0 0 1 .18-.23l.58-.34a.24.24 0 0 1 .22 0 .34.34 0 0 1 .17.23Z"
            style={{
              fill: "#455a64",
              transformOrigin: "200.489px 324.931px",
            }}
            className="animable"
          />
          <path
            d="M228.39 315.46a.79.79 0 0 1 0 .4.58.58 0 0 1-.23.29l-.52.3a.23.23 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-1.43-10-1.8 3.43a.42.42 0 0 1-.24.26.25.25 0 0 1-.25-.05l-.39-.39a.45.45 0 0 1-.12-.32.71.71 0 0 1 .09-.4l2.3-4.55a1.08 1.08 0 0 1 .18-.25l.21-.13.52-.3a.21.21 0 0 1 .26 0 .41.41 0 0 1 .15.29Z"
            style={{
              fill: "#455a64",
              transformOrigin: "225.707px 309.953px",
            }}
            className="animable"
          />
          <path
            d="M231.61 305a2.08 2.08 0 0 1 .21-.2l.23-.16a2.87 2.87 0 0 1 1.37-.43 2.07 2.07 0 0 1 1.18.32 2.78 2.78 0 0 1 .89 1 4.73 4.73 0 0 1 .49 1.58 6.51 6.51 0 0 1 0 1.87 7 7 0 0 1-.49 1.78 6.13 6.13 0 0 1-.91 1.53 4.74 4.74 0 0 1-1.28 1.1 2.91 2.91 0 0 1-1.36.43 2 2 0 0 1-1.18-.33 2.66 2.66 0 0 1-.89-1 4.52 4.52 0 0 1-.49-1.58 6.05 6.05 0 0 1-.06-1 6.26 6.26 0 0 1 .1-1q.08-.48.18-.93c.08-.31.16-.6.24-.88l1.62-6.2c0-.09.07-.19.11-.31a.47.47 0 0 1 .24-.28l.72-.42a.15.15 0 0 1 .2 0 .39.39 0 0 1 .12.24v.15a1 1 0 0 1 0 .12Zm-1 5.22a2.94 2.94 0 0 0 .29.95 2 2 0 0 0 .54.63 1.3 1.3 0 0 0 .75.22 1.75 1.75 0 0 0 .9-.27 3.07 3.07 0 0 0 .84-.73 3.75 3.75 0 0 0 .57-1 4.78 4.78 0 0 0 .29-1.11 4.2 4.2 0 0 0 0-1.12 2.94 2.94 0 0 0-.29-.95 1.88 1.88 0 0 0-.54-.63 1.38 1.38 0 0 0-.75-.23 1.77 1.77 0 0 0-.9.28 2.81 2.81 0 0 0-.84.73 3.75 3.75 0 0 0-.57 1 4.45 4.45 0 0 0-.29 2.23Z"
            style={{
              fill: "#455a64",
              transformOrigin: "232.683px 306.837px",
            }}
            className="animable"
          />
          <path
            d="M260.89 296.7a.79.79 0 0 1-.05.4.58.58 0 0 1-.23.29l-.52.3a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-1.43-10-1.75 3.42a.4.4 0 0 1-.24.25.25.25 0 0 1-.25 0l-.39-.39a.41.41 0 0 1-.12-.32.78.78 0 0 1 .08-.4l2.31-4.55a.77.77 0 0 1 .18-.25l.2-.14.53-.3a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "258.198px 291.21px",
            }}
            className="animable"
          />
          <path
            d="M266 280.55a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.29l.09.65a1.48 1.48 0 0 1 0 .37 2.47 2.47 0 0 1-.05.44l-1.34 12a2.62 2.62 0 0 1-.09.38.46.46 0 0 1-.22.27l-.58.34a.21.21 0 0 1-.24 0 .4.4 0 0 1-.13-.26.22.22 0 0 1 0-.09v-.15l1.35-12.05-4.21 2.44a.22.22 0 0 1-.27 0 .41.41 0 0 1-.15-.29l-.09-.65a.79.79 0 0 1 .05-.4.62.62 0 0 1 .22-.29Z"
            style={{
              fill: "#455a64",
              transformOrigin: "263.502px 287.918px",
            }}
            className="animable"
          />
          <path
            d="M292.25 278.59a.79.79 0 0 1-.05.4.62.62 0 0 1-.22.29l-.53.3a.21.21 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-1.43-10-1.75 3.42a.42.42 0 0 1-.24.26.25.25 0 0 1-.25-.05l-.39-.39a.49.49 0 0 1-.12-.32.71.71 0 0 1 .09-.4l2.3-4.55a.86.86 0 0 1 .19-.25 1.37 1.37 0 0 1 .2-.13l.52-.3a.21.21 0 0 1 .26 0 .38.38 0 0 1 .16.29Z"
            style={{
              fill: "#fff",
              transformOrigin: "289.558px 273.085px",
            }}
            className="animable"
          />
          <path
            d="M293.44 274.53a5.32 5.32 0 0 1 .08-1.9 6.08 6.08 0 0 1 .72-1.84 2 2 0 0 1-.9-.76 3.27 3.27 0 0 1-.48-1.35 4.8 4.8 0 0 1 0-1.51 6.27 6.27 0 0 1 .45-1.49 5.87 5.87 0 0 1 .83-1.3 4.29 4.29 0 0 1 1.14-1 2.69 2.69 0 0 1 1.22-.4 1.93 1.93 0 0 1 1.05.21 2 2 0 0 1 .79.78 3.24 3.24 0 0 1 .42 1.24 4.71 4.71 0 0 1-.06 1.67 6.33 6.33 0 0 1-.56 1.6 2.06 2.06 0 0 1 1.09.79 3.3 3.3 0 0 1 .58 1.52 5.45 5.45 0 0 1 0 1.61 6 6 0 0 1-.49 1.59 5.76 5.76 0 0 1-.9 1.4 4.74 4.74 0 0 1-1.24 1 3.14 3.14 0 0 1-1.33.45 2.11 2.11 0 0 1-1.13-.24 2.2 2.2 0 0 1-.84-.82 3.48 3.48 0 0 1-.44-1.25Zm.63-6.55a1.54 1.54 0 0 0 .25.67 1 1 0 0 0 .45.4 1.23 1.23 0 0 0 .61.09 1.83 1.83 0 0 0 .72-.25 3.11 3.11 0 0 0 .67-.55 3.57 3.57 0 0 0 .5-.74 3 3 0 0 0 .28-.82 2.33 2.33 0 0 0 0-.83 1.67 1.67 0 0 0-.24-.67 1 1 0 0 0-.46-.4 1.38 1.38 0 0 0-.62-.08 1.74 1.74 0 0 0-.71.25 2.49 2.49 0 0 0-.67.55 3.63 3.63 0 0 0-.5.73 3 3 0 0 0-.28.82 2.59 2.59 0 0 0 0 .85Zm.58 5.85a1.72 1.72 0 0 0 .27.76 1.17 1.17 0 0 0 .5.44 1.2 1.2 0 0 0 .69.1 2.06 2.06 0 0 0 .84-.29 3.59 3.59 0 0 0 .78-.64 4.1 4.1 0 0 0 .56-.82 3.44 3.44 0 0 0 .31-.92 2.92 2.92 0 0 0 0-.93 2.07 2.07 0 0 0-.27-.76 1.14 1.14 0 0 0-.51-.44 1.4 1.4 0 0 0-.69-.1 2.23 2.23 0 0 0-.83.29 3.52 3.52 0 0 0-.79.64 4.17 4.17 0 0 0-.56.83 3.76 3.76 0 0 0-.31.91 2.65 2.65 0 0 0 .01.93Z"
            style={{
              fill: "#fff",
              transformOrigin: "296.335px 269.909px",
            }}
            className="animable"
          />
          <path
            d="M324.42 260a.8.8 0 0 1-.06.4.52.52 0 0 1-.22.29l-.52.3a.23.23 0 0 1-.26 0 .33.33 0 0 1-.15-.28l-1.43-10-1.78 3.44a.42.42 0 0 1-.24.26.27.27 0 0 1-.26 0l-.38-.39a.41.41 0 0 1-.12-.32.8.8 0 0 1 .08-.4l2.31-4.55a.64.64 0 0 1 .18-.25l.2-.13.53-.31a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.29Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "321.712px 254.525px",
            }}
            className="animable"
          />
          <path
            d="m328.81 253.3-.17.13-.17.11a2.92 2.92 0 0 1-1.22.4 2 2 0 0 1-1.14-.24 2.51 2.51 0 0 1-.91-.92 4.49 4.49 0 0 1-.54-1.68 6.37 6.37 0 0 1 0-1.85 7.34 7.34 0 0 1 .5-1.75 6.92 6.92 0 0 1 .89-1.49 4.25 4.25 0 0 1 1.19-1 2.85 2.85 0 0 1 1.38-.44 1.84 1.84 0 0 1 1.13.31 2.54 2.54 0 0 1 .83 1 4.9 4.9 0 0 1 .47 1.58 5.14 5.14 0 0 1 0 1 9.41 9.41 0 0 1-.13 1.05q-.09.52-.21 1c-.08.34-.16.64-.23.92l-1.62 6.2c0 .09-.07.19-.11.31a.53.53 0 0 1-.23.28l-.73.42a.16.16 0 0 1-.2 0 .34.34 0 0 1-.11-.24.92.92 0 0 1 0-.16.36.36 0 0 1 0-.11Zm1-5.19a2.7 2.7 0 0 0-.3-1 1.6 1.6 0 0 0-.53-.61 1.3 1.3 0 0 0-.71-.19 1.8 1.8 0 0 0-.83.27 2.62 2.62 0 0 0-.78.67 3.94 3.94 0 0 0-.55.91 4.44 4.44 0 0 0-.28 2.21 3.06 3.06 0 0 0 .3 1 1.64 1.64 0 0 0 .53.6 1.21 1.21 0 0 0 .7.19 1.65 1.65 0 0 0 .84-.27 2.53 2.53 0 0 0 .77-.66 3.43 3.43 0 0 0 .56-.92 4.11 4.11 0 0 0 .28-1.07 4 4 0 0 0 .04-1.13Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "327.833px 251.621px",
            }}
            className="animable"
          />
          <path
            d="M354.33 236.06a6.37 6.37 0 0 0 .43-1.33 4.33 4.33 0 0 0 0-1.44 2.12 2.12 0 0 0-.62-1.37c-.33-.28-.78-.25-1.35.07a2.79 2.79 0 0 0-.73.62 3.16 3.16 0 0 0-.45.8 4.77 4.77 0 0 0-.23.92c0 .32-.06.64-.07 1a1.06 1.06 0 0 1-.09.38.57.57 0 0 1-.19.23l-.58.33a.18.18 0 0 1-.22 0 .36.36 0 0 1-.12-.23 5.76 5.76 0 0 1 0-1.49 7.16 7.16 0 0 1 .41-1.59 6.29 6.29 0 0 1 .8-1.46 4.12 4.12 0 0 1 1.22-1.1 2.62 2.62 0 0 1 1.28-.4 1.58 1.58 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 4.63 4.63 0 0 1 .4 1.39 7.16 7.16 0 0 1 .09 1.09 7 7 0 0 1-.08 1 8.32 8.32 0 0 1-.26 1 9.92 9.92 0 0 1-.45 1.14L353 242.3l3.9-2.25a.22.22 0 0 1 .27 0 .41.41 0 0 1 .15.29l.09.65a.79.79 0 0 1-.05.4.62.62 0 0 1-.22.29l-5.5 3.17a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-.1-.66a1 1 0 0 1 0-.38 3.74 3.74 0 0 1 .16-.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "353.739px 237.445px",
            }}
            className="animable"
          />
          <path
            d="M364.24 229c.09.54.16 1 .23 1.52s.14 1 .21 1.54a10.49 10.49 0 0 1 .07 2.09 7.42 7.42 0 0 1-.36 1.93 5.88 5.88 0 0 1-.85 1.63 4.87 4.87 0 0 1-1.4 1.22 2.83 2.83 0 0 1-1.5.45 1.82 1.82 0 0 1-1.15-.47 3.36 3.36 0 0 1-.82-1.25 8.2 8.2 0 0 1-.49-1.84c-.09-.54-.17-1.05-.23-1.53s-.14-1-.21-1.54a10.47 10.47 0 0 1-.07-2.09 8 8 0 0 1 .36-1.93 5.88 5.88 0 0 1 .85-1.63 4.45 4.45 0 0 1 1.39-1.23 2.89 2.89 0 0 1 1.51-.45 1.84 1.84 0 0 1 1.15.49 3.31 3.31 0 0 1 .82 1.24 8.15 8.15 0 0 1 .49 1.85Zm-4.86 6.12a3.68 3.68 0 0 0 .9 2.23 1.35 1.35 0 0 0 1.63-.06 3 3 0 0 0 1.39-1.69 6.12 6.12 0 0 0 .18-2.85c-.07-.55-.14-1.06-.21-1.54s-.14-1-.23-1.52a3.74 3.74 0 0 0-.9-2.24 1.35 1.35 0 0 0-1.63 0 3.06 3.06 0 0 0-1.39 1.7 6.18 6.18 0 0 0-.18 2.86c.07.55.14 1.06.21 1.54s.14 1.08.23 1.61Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "361.21px 232.4px",
            }}
            className="animable"
          />
          <path
            d="M167.67 372.54a6.19 6.19 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.28-.78-.25-1.35.08a2.61 2.61 0 0 0-.73.62 3 3 0 0 0-.45.8 4 4 0 0 0-.23.92 7.45 7.45 0 0 0-.07.95 1.12 1.12 0 0 1-.09.39.53.53 0 0 1-.19.22l-.58.34a.22.22 0 0 1-.22 0 .39.39 0 0 1-.12-.24 5.68 5.68 0 0 1 0-1.48 6.89 6.89 0 0 1 .41-1.59 6.56 6.56 0 0 1 .8-1.47 4 4 0 0 1 1.22-1.09 2.64 2.64 0 0 1 1.28-.41 1.67 1.67 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 5 5 0 0 1 .4 1.4 6.6 6.6 0 0 1 0 2.11 8.78 8.78 0 0 1-.26 1q-.18.52-.45 1.14l-2.3 5.41 3.9-2.25a.24.24 0 0 1 .27 0 .43.43 0 0 1 .15.29l.09.65a.84.84 0 0 1-.05.41.55.55 0 0 1-.23.28l-5.4 3.21a.21.21 0 0 1-.26 0 .39.39 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.38 2.37 2.37 0 0 1 .16-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "167.044px 373.907px",
            }}
            className="animable"
          />
          <path
            d="M175.77 374.56a.81.81 0 0 1-.05.4.51.51 0 0 1-.23.28l-.52.31a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.28l-1.43-10-1.75 3.42a.4.4 0 0 1-.24.25.23.23 0 0 1-.25-.05l-.39-.38a.45.45 0 0 1-.12-.32.75.75 0 0 1 .09-.41l2.3-4.55a.83.83 0 0 1 .23-.23l.21-.14.52-.3a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.28Z"
            style={{
              fill: "#455a64",
              transformOrigin: "173.077px 369.055px",
            }}
            className="animable"
          />
          <path
            d="M198.61 354.68a6.37 6.37 0 0 0 .43-1.33 4.33 4.33 0 0 0 0-1.44 2.12 2.12 0 0 0-.62-1.37c-.33-.28-.77-.25-1.35.07a2.79 2.79 0 0 0-.73.62 3 3 0 0 0-.45.8 4.77 4.77 0 0 0-.23.92c0 .32-.06.64-.07 1a1.06 1.06 0 0 1-.09.38.65.65 0 0 1-.18.23l-.59.34a.2.2 0 0 1-.22 0 .36.36 0 0 1-.12-.23 6.24 6.24 0 0 1 0-1.49 7 7 0 0 1 .41-1.59 6 6 0 0 1 .81-1.46 4 4 0 0 1 1.21-1.1 2.62 2.62 0 0 1 1.28-.4 1.63 1.63 0 0 1 1 .32 2.43 2.43 0 0 1 .71.92 4.63 4.63 0 0 1 .4 1.39 7.16 7.16 0 0 1 .09 1.09 5.84 5.84 0 0 1-.08 1 8.32 8.32 0 0 1-.26 1 12 12 0 0 1-.44 1.14l-2.31 5.42 3.9-2.26a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.28l.09.66a.79.79 0 0 1 0 .4.62.62 0 0 1-.22.29l-5.5 3.17a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-.1-.66a1.2 1.2 0 0 1 0-.38 2.8 2.8 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "197.996px 356.06px",
            }}
            className="animable"
          />
          <path
            d="M206 350.39a6.19 6.19 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.28-.78-.25-1.34.08a2.52 2.52 0 0 0-.74.62 3 3 0 0 0-.45.8 4.59 4.59 0 0 0-.23.92c0 .31-.06.63-.07.95a1.12 1.12 0 0 1-.09.39.6.6 0 0 1-.18.22l-.59.34a.2.2 0 0 1-.22 0 .39.39 0 0 1-.12-.24 6.16 6.16 0 0 1 0-1.48 6.89 6.89 0 0 1 .41-1.59 6.22 6.22 0 0 1 .81-1.47 3.93 3.93 0 0 1 1.21-1.09 2.64 2.64 0 0 1 1.28-.41 1.7 1.7 0 0 1 1 .32 2.43 2.43 0 0 1 .71.92 4.69 4.69 0 0 1 .4 1.4 7.16 7.16 0 0 1 .09 1.09 5.84 5.84 0 0 1-.08 1 8.32 8.32 0 0 1-.26 1 11.37 11.37 0 0 1-.44 1.14l-2.31 5.41 3.9-2.25a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28l.09.65a.83.83 0 0 1-.05.41.59.59 0 0 1-.22.28l-5.5 3.17a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 2.52 2.52 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "205.376px 351.723px",
            }}
            className="animable"
          />
          <path
            d="M230.5 336.27a7 7 0 0 0 .43-1.33 4.33 4.33 0 0 0 0-1.44 2.08 2.08 0 0 0-.63-1.37c-.32-.28-.77-.25-1.34.07a2.63 2.63 0 0 0-.73.62 3 3 0 0 0-.45.8 4.13 4.13 0 0 0-.23.92c0 .32-.07.64-.08 1a.8.8 0 0 1-.09.39.51.51 0 0 1-.18.22l-.58.34a.2.2 0 0 1-.22 0 .29.29 0 0 1-.12-.23 5.76 5.76 0 0 1 0-1.49 7 7 0 0 1 .41-1.59 6.29 6.29 0 0 1 .8-1.46 4 4 0 0 1 1.22-1.1 2.59 2.59 0 0 1 1.28-.4 1.6 1.6 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 4.94 4.94 0 0 1 .4 1.39 8.72 8.72 0 0 1 .09 1.09 5.86 5.86 0 0 1-.09 1 6.82 6.82 0 0 1-.25 1 12.17 12.17 0 0 1-.45 1.14l-2.3 5.42 3.9-2.26a.23.23 0 0 1 .26 0 .35.35 0 0 1 .15.29l.1.65a.79.79 0 0 1-.05.4.58.58 0 0 1-.23.29l-5.49 3.17a.22.22 0 0 1-.26 0 .36.36 0 0 1-.16-.28l-.09-.66a1 1 0 0 1 0-.38 2.6 2.6 0 0 1 .16-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "229.879px 337.651px",
            }}
            className="animable"
          />
          <path
            d="M235.53 337.27a2.23 2.23 0 0 0 .26.48.85.85 0 0 0 .41.31 1.29 1.29 0 0 0 .66 0 3.36 3.36 0 0 0 1-.42 3.6 3.6 0 0 0 .73-.57 3 3 0 0 0 .57-.79 3.5 3.5 0 0 0 .32-1 3.23 3.23 0 0 0 0-1.12 2.16 2.16 0 0 0-.29-.9 1 1 0 0 0-.51-.41 1.27 1.27 0 0 0-.67 0 3.48 3.48 0 0 0-.79.34l-1.06.61a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.34c0-.12.07-.23.1-.32l1.79-4.84-3.67 2.12a.23.23 0 0 1-.26 0 .38.38 0 0 1-.16-.29l-.09-.65a.79.79 0 0 1 0-.4.58.58 0 0 1 .23-.29l5-2.9a.23.23 0 0 1 .26 0 .37.37 0 0 1 .15.28l.1.66a1.06 1.06 0 0 1 0 .35 3.57 3.57 0 0 1-.12.4l-1.76 4.76a3 3 0 0 1 1.2-.39 1.63 1.63 0 0 1 1 .22 2.09 2.09 0 0 1 .76.82 4.43 4.43 0 0 1 .43 1.41 6 6 0 0 1-1.42 4.79 5 5 0 0 1-1.2 1 4 4 0 0 1-1.51.57 2.06 2.06 0 0 1-1.13-.15 1.82 1.82 0 0 1-.74-.69 3 3 0 0 1-.38-1 .63.63 0 0 1 0-.33.49.49 0 0 1 .18-.23l.59-.34a.2.2 0 0 1 .24 0 .44.44 0 0 1 .29.19Z"
            style={{
              fill: "#455a64",
              transformOrigin: "237.002px 332.376px",
            }}
            className="animable"
          />
          <path
            d="M262.37 317.86a6.12 6.12 0 0 0 .43-1.32 4.33 4.33 0 0 0 0-1.44 2.18 2.18 0 0 0-.62-1.38c-.33-.27-.78-.25-1.34.08a2.52 2.52 0 0 0-.74.62 3 3 0 0 0-.45.8 4.59 4.59 0 0 0-.23.92c0 .32-.06.64-.07 1a1.12 1.12 0 0 1-.09.38.53.53 0 0 1-.18.22l-.59.34a.18.18 0 0 1-.22 0 .36.36 0 0 1-.12-.23 6.24 6.24 0 0 1 0-1.49 6.89 6.89 0 0 1 .41-1.59 6 6 0 0 1 .81-1.46 4 4 0 0 1 1.21-1.1 2.64 2.64 0 0 1 1.28-.41 1.7 1.7 0 0 1 1 .32 2.51 2.51 0 0 1 .71.92 4.42 4.42 0 0 1 .4 1.4 7.16 7.16 0 0 1 .09 1.09 5.84 5.84 0 0 1-.08 1 6.88 6.88 0 0 1-.26 1 9.77 9.77 0 0 1-.44 1.14L261 324.1l3.9-2.25a.24.24 0 0 1 .27 0 .38.38 0 0 1 .15.28l.09.66a.81.81 0 0 1-.05.4.54.54 0 0 1-.22.28l-5.5 3.18a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.28l-.09-.66a1 1 0 0 1 0-.38 2.52 2.52 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "261.761px 319.245px",
            }}
            className="animable"
          />
          <path
            d="M271.18 320a.22.22 0 0 1-.26 0 .4.4 0 0 1-.16-.29l-.35-2.5-4 2.31a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-.09-.65a.91.91 0 0 1 0-.33 1.8 1.8 0 0 1 .08-.39l3-9.84a2 2 0 0 1 .18-.44.65.65 0 0 1 .26-.28l.51-.29a.23.23 0 0 1 .26 0 .43.43 0 0 1 .15.29l1.08 7.58 1.1-.64a.23.23 0 0 1 .26 0 .41.41 0 0 1 .16.29l.09.65a.7.7 0 0 1-.06.4.52.52 0 0 1-.22.29l-1.09.63.33 2.49a.86.86 0 0 1-.06.41.53.53 0 0 1-.22.28Zm-1-4.42-.73-5.12-2 6.71Z"
            style={{
              fill: "#455a64",
              transformOrigin: "269.471px 313.511px",
            }}
            className="animable"
          />
          <path
            d="M294.44 299.35a6.37 6.37 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.15 2.15 0 0 0-.62-1.38c-.33-.28-.77-.25-1.34.08a2.52 2.52 0 0 0-.74.62 2.85 2.85 0 0 0-.45.8 4.49 4.49 0 0 0-.23.91c0 .32-.06.64-.07 1a1.12 1.12 0 0 1-.09.39.51.51 0 0 1-.18.22l-.59.34a.18.18 0 0 1-.21 0 .31.31 0 0 1-.13-.23 6.81 6.81 0 0 1 0-1.49 6.94 6.94 0 0 1 .41-1.58 5.85 5.85 0 0 1 .81-1.47 4 4 0 0 1 1.21-1.1 2.62 2.62 0 0 1 1.29-.4 1.62 1.62 0 0 1 1 .32 2.43 2.43 0 0 1 .71.92 4.61 4.61 0 0 1 .41 1.4 8.46 8.46 0 0 1 .08 1.08 5.84 5.84 0 0 1-.08 1 7.31 7.31 0 0 1-.26 1.05 11.37 11.37 0 0 1-.44 1.14l-2.31 5.41 3.9-2.25a.22.22 0 0 1 .27 0 .41.41 0 0 1 .15.29l.09.65a.79.79 0 0 1-.05.4.56.56 0 0 1-.22.29l-5.5 3.17a.24.24 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 2.29 2.29 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "293.823px 300.754px",
            }}
            className="animable"
          />
          <path
            d="M299.46 300.1a1.4 1.4 0 0 0 .92.93 1.76 1.76 0 0 0 1.37-.25 3.23 3.23 0 0 0 .77-.62 3.39 3.39 0 0 0 .57-.86 3.67 3.67 0 0 0 .32-1.08 4 4 0 0 0 0-1.24 2.83 2.83 0 0 0-.32-1.06 1.47 1.47 0 0 0-.55-.58 1.16 1.16 0 0 0-.72-.11 2.15 2.15 0 0 0-.81.29 3 3 0 0 0-.75.6 3.89 3.89 0 0 0-.42.6c-.11.18-.2.36-.29.52a.89.89 0 0 1-.31.35l-.65.37a.22.22 0 0 1-.22 0 .39.39 0 0 1-.12-.24l-.48-6.27a.73.73 0 0 1 .05-.41.53.53 0 0 1 .22-.28l4.5-2.6a.23.23 0 0 1 .26 0 .33.33 0 0 1 .15.28l.1.65a.74.74 0 0 1-.06.41.49.49 0 0 1-.22.28l-3.71 2.14.25 3.26a4.63 4.63 0 0 1 .55-.62 4.31 4.31 0 0 1 .92-.68 3.09 3.09 0 0 1 1.3-.44 2 2 0 0 1 1.15.25 2.46 2.46 0 0 1 .89.94 4.88 4.88 0 0 1 .51 1.64 6.64 6.64 0 0 1-.51 3.68 5.71 5.71 0 0 1-.91 1.43 4.6 4.6 0 0 1-1.21 1 3.43 3.43 0 0 1-1.26.45 2.19 2.19 0 0 1-1.12-.13 2 2 0 0 1-.86-.69 2.83 2.83 0 0 1-.49-1.25.64.64 0 0 1 .05-.33.43.43 0 0 1 .18-.23l.58-.34a.24.24 0 0 1 .22 0 .34.34 0 0 1 .16.24Z"
            style={{
              fill: "#455a64",
              transformOrigin: "301.23px 295.486px",
            }}
            className="animable"
          />
          <path
            d="M326.38 280.91a6.45 6.45 0 0 0 .44-1.33 4.62 4.62 0 0 0 0-1.44 2.08 2.08 0 0 0-.63-1.37c-.32-.28-.77-.26-1.34.07a2.63 2.63 0 0 0-.73.62 3 3 0 0 0-.45.8 4.13 4.13 0 0 0-.23.92c0 .32-.07.64-.08 1a.76.76 0 0 1-.09.38.49.49 0 0 1-.18.23l-.59.33a.17.17 0 0 1-.21 0 .29.29 0 0 1-.12-.23 5.76 5.76 0 0 1 0-1.49 7 7 0 0 1 .41-1.59 5.94 5.94 0 0 1 .8-1.46 3.89 3.89 0 0 1 1.22-1.1 2.56 2.56 0 0 1 1.28-.4 1.62 1.62 0 0 1 1 .32 2.28 2.28 0 0 1 .72.92 4.94 4.94 0 0 1 .4 1.39c.05.39.08.75.09 1.09a6.68 6.68 0 0 1-.35 2.06 9.77 9.77 0 0 1-.44 1.14l-2.3 5.42 3.9-2.26a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.28l.1.66a.82.82 0 0 1-.06.4.52.52 0 0 1-.22.29l-5.49 3.17a.24.24 0 0 1-.27 0 .38.38 0 0 1-.15-.28l-.09-.66a1.2 1.2 0 0 1 0-.38 3.54 3.54 0 0 1 .17-.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "325.768px 282.311px",
            }}
            className="animable"
          />
          <path
            d="M332.34 275.53a1.37 1.37 0 0 1 .21-.2l.23-.16a2.83 2.83 0 0 1 1.37-.43 2.07 2.07 0 0 1 1.18.32 2.87 2.87 0 0 1 .89 1 4.73 4.73 0 0 1 .49 1.58 6.51 6.51 0 0 1 0 1.87 7.43 7.43 0 0 1-.49 1.78 6.23 6.23 0 0 1-.92 1.53 4.4 4.4 0 0 1-1.27 1.1 2.91 2.91 0 0 1-1.36.43 2.16 2.16 0 0 1-1.18-.32 2.78 2.78 0 0 1-.89-1 4.74 4.74 0 0 1-.5-1.58 7.25 7.25 0 0 1-.05-1 7.76 7.76 0 0 1 .09-1c.05-.31.12-.63.19-.93s.16-.6.24-.88l1.62-6.2c0-.09.07-.19.11-.31a.5.5 0 0 1 .24-.28l.72-.42a.15.15 0 0 1 .2 0 .34.34 0 0 1 .11.24.86.86 0 0 1 0 .15.34.34 0 0 1 0 .12Zm-1 5.22a2.94 2.94 0 0 0 .29.95 1.88 1.88 0 0 0 .54.63 1.24 1.24 0 0 0 .74.22 1.76 1.76 0 0 0 .91-.27 3.07 3.07 0 0 0 .84-.73 3.75 3.75 0 0 0 .57-1 4.78 4.78 0 0 0 .29-1.11 4.2 4.2 0 0 0 0-1.12 2.72 2.72 0 0 0-.3-.95 1.75 1.75 0 0 0-.53-.63 1.38 1.38 0 0 0-.75-.23 1.77 1.77 0 0 0-.9.28 2.81 2.81 0 0 0-.84.73 3.75 3.75 0 0 0-.57 1 4.8 4.8 0 0 0-.3 1.11 4.2 4.2 0 0 0-.01 1.12Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "333.413px 277.371px",
            }}
            className="animable"
          />
          <path
            d="M358.88 262.14a6 6 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.27-.77-.25-1.34.08a2.66 2.66 0 0 0-.74.62 3 3 0 0 0-.45.8 4 4 0 0 0-.22.92 7.77 7.77 0 0 0-.08 1 1.12 1.12 0 0 1-.09.38.46.46 0 0 1-.18.22l-.59.34a.17.17 0 0 1-.21 0 .35.35 0 0 1-.13-.23 6.8 6.8 0 0 1 0-1.49 7.44 7.44 0 0 1 .41-1.59 6 6 0 0 1 .81-1.46 3.84 3.84 0 0 1 1.21-1.1 2.64 2.64 0 0 1 1.29-.41 1.69 1.69 0 0 1 1 .32 2.64 2.64 0 0 1 .72.92 5 5 0 0 1 .4 1.4 8.61 8.61 0 0 1 .08 1.09 5.84 5.84 0 0 1-.08 1 6.88 6.88 0 0 1-.26 1 9.77 9.77 0 0 1-.44 1.14l-2.31 5.41 3.91-2.25a.23.23 0 0 1 .26 0 .38.38 0 0 1 .15.28l.09.65a.83.83 0 0 1-.05.41.53.53 0 0 1-.22.28l-5.5 3.18a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 3.54 3.54 0 0 1 .17-.47Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "358.263px 263.515px",
            }}
            className="animable"
          />
          <path
            d="M366.69 251.12a.23.23 0 0 1 .26 0 .36.36 0 0 1 .15.29l.1.65a2.19 2.19 0 0 1 0 .37v.44l-1.34 12a2.34 2.34 0 0 1-.09.38.54.54 0 0 1-.22.27l-.59.34a.19.19 0 0 1-.23 0 .34.34 0 0 1-.13-.26.19.19 0 0 1 0-.08 1 1 0 0 1 0-.16l1.36-12-4.19 2.42a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.28l-.09-.66a.81.81 0 0 1 0-.4.56.56 0 0 1 .22-.29Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "364.226px 258.489px",
            }}
            className="animable"
          />
          <path
            d="M170.26 399.76a6 6 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.27-.78-.25-1.35.08a2.61 2.61 0 0 0-.73.62 3 3 0 0 0-.45.8 4 4 0 0 0-.23.92c0 .32-.07.64-.08.95a.93.93 0 0 1-.08.39.53.53 0 0 1-.19.22l-.58.34a.2.2 0 0 1-.22 0 .34.34 0 0 1-.12-.23 5.76 5.76 0 0 1 0-1.49 6.89 6.89 0 0 1 .41-1.59 6.56 6.56 0 0 1 .8-1.47 4 4 0 0 1 1.22-1.09 2.61 2.61 0 0 1 1.28-.41 1.67 1.67 0 0 1 1 .32 2.43 2.43 0 0 1 .72.92 5 5 0 0 1 .4 1.4 7.16 7.16 0 0 1 .09 1.09 7 7 0 0 1-.08 1 8.32 8.32 0 0 1-.26 1q-.18.53-.45 1.14L168.9 406l3.9-2.25a.22.22 0 0 1 .26 0 .36.36 0 0 1 .16.28l.09.66a.81.81 0 0 1-.05.4.59.59 0 0 1-.22.28l-5.5 3.17a.21.21 0 0 1-.26 0 .38.38 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.38 2.37 2.37 0 0 1 .16-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "169.654px 401.123px",
            }}
            className="animable"
          />
          <path
            d="M174.18 400.82a5.1 5.1 0 0 1 .08-1.9 6.08 6.08 0 0 1 .72-1.84 2 2 0 0 1-.9-.76 3.27 3.27 0 0 1-.48-1.35 4.8 4.8 0 0 1 0-1.51 5.65 5.65 0 0 1 1.28-2.79 4.53 4.53 0 0 1 1.14-1 3 3 0 0 1 1.22-.4 1.93 1.93 0 0 1 1 .22 2.08 2.08 0 0 1 .79.77 3.36 3.36 0 0 1 .42 1.25 4.71 4.71 0 0 1-.06 1.67 6.47 6.47 0 0 1-.56 1.6 2.1 2.1 0 0 1 1.09.79 3.3 3.3 0 0 1 .58 1.52 5.45 5.45 0 0 1 0 1.61 5.8 5.8 0 0 1-.49 1.58 6.14 6.14 0 0 1-.9 1.41 4.74 4.74 0 0 1-1.24 1 3 3 0 0 1-1.33.44 2 2 0 0 1-1.13-.23 2.2 2.2 0 0 1-.84-.82 3.48 3.48 0 0 1-.39-1.26Zm.63-6.55a1.67 1.67 0 0 0 .24.67 1.09 1.09 0 0 0 .46.4 1.35 1.35 0 0 0 .61.08 1.71 1.71 0 0 0 .71-.24 2.74 2.74 0 0 0 .68-.56 3.26 3.26 0 0 0 .5-.73 3 3 0 0 0 .28-.82 2.34 2.34 0 0 0 0-.83 1.67 1.67 0 0 0-.24-.67 1.09 1.09 0 0 0-.46-.4 1.25 1.25 0 0 0-.62-.08 1.68 1.68 0 0 0-.72.25 2.45 2.45 0 0 0-.66.55 3.26 3.26 0 0 0-.5.73 3 3 0 0 0-.28.82 2.33 2.33 0 0 0 0 .83Zm.58 5.85a1.9 1.9 0 0 0 .26.76 1.26 1.26 0 0 0 .51.44 1.29 1.29 0 0 0 .69.1 2 2 0 0 0 .83-.29 3.17 3.17 0 0 0 .78-.64 3.83 3.83 0 0 0 .57-.83 3.27 3.27 0 0 0 .31-.91 2.92 2.92 0 0 0 0-.93 2.07 2.07 0 0 0-.27-.76 1.26 1.26 0 0 0-.51-.44 1.29 1.29 0 0 0-.69-.1 2.07 2.07 0 0 0-.83.29 3.26 3.26 0 0 0-.79.64 4.41 4.41 0 0 0-.56.82 4 4 0 0 0-.31.92 2.65 2.65 0 0 0 .01.93Z"
            style={{
              fill: "#455a64",
              transformOrigin: "177.05px 396.203px",
            }}
            className="animable"
          />
          <path
            d="M202.42 381.19a6.19 6.19 0 0 0 .43-1.33 4.53 4.53 0 0 0 0-1.43 2.13 2.13 0 0 0-.63-1.38c-.32-.27-.77-.25-1.34.08a2.48 2.48 0 0 0-.73.62 3 3 0 0 0-.45.8 4 4 0 0 0-.23.92c0 .31-.07.63-.08.95a.8.8 0 0 1-.09.39.46.46 0 0 1-.18.22l-.59.34a.2.2 0 0 1-.21 0 .31.31 0 0 1-.12-.24 5.68 5.68 0 0 1 0-1.48 6.42 6.42 0 0 1 .41-1.59 6.18 6.18 0 0 1 .8-1.47 3.85 3.85 0 0 1 1.22-1.09 2.58 2.58 0 0 1 1.28-.41 1.69 1.69 0 0 1 1 .32 2.35 2.35 0 0 1 .72.92 5 5 0 0 1 .4 1.4 8.61 8.61 0 0 1 .08 1.09 5 5 0 0 1-.08 1 5.86 5.86 0 0 1-.26 1 11.37 11.37 0 0 1-.44 1.14l-2.3 5.41 3.9-2.25a.24.24 0 0 1 .26 0 .43.43 0 0 1 .15.29l.1.65a.84.84 0 0 1-.06.41.49.49 0 0 1-.22.28l-5.45 3.25a.22.22 0 0 1-.27 0 .41.41 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 3.54 3.54 0 0 1 .17-.47Z"
            style={{
              fill: "#455a64",
              transformOrigin: "201.798px 382.568px",
            }}
            className="animable"
          />
          <path
            d="m209.55 379.59-.17.13-.17.1a2.94 2.94 0 0 1-1.22.41 2 2 0 0 1-1.14-.24 2.46 2.46 0 0 1-.91-.93 4.37 4.37 0 0 1-.54-1.67 6 6 0 0 1 0-1.85 7.21 7.21 0 0 1 .5-1.75 6.68 6.68 0 0 1 .89-1.49 4.39 4.39 0 0 1 1.19-1 2.87 2.87 0 0 1 1.38-.45 1.92 1.92 0 0 1 1.13.32 2.54 2.54 0 0 1 .83 1 4.82 4.82 0 0 1 .47 1.58 5.11 5.11 0 0 1 0 1 9.41 9.41 0 0 1-.13 1.05c-.06.34-.13.69-.21 1s-.16.64-.23.92l-1.62 6.2c0 .08-.07.19-.11.3a.51.51 0 0 1-.23.29l-.73.42a.16.16 0 0 1-.2 0 .36.36 0 0 1-.11-.24 1 1 0 0 1 0-.16.56.56 0 0 1 0-.12Zm1-5.2a2.71 2.71 0 0 0-.3-1 1.6 1.6 0 0 0-.53-.61 1.2 1.2 0 0 0-.71-.19 1.8 1.8 0 0 0-.83.27 2.74 2.74 0 0 0-.78.66 3.84 3.84 0 0 0-.54.92 3.74 3.74 0 0 0-.29 1.08 4.27 4.27 0 0 0 0 1.13 3.06 3.06 0 0 0 .3 1 1.64 1.64 0 0 0 .53.6 1.21 1.21 0 0 0 .7.19 1.87 1.87 0 0 0 .84-.27 2.68 2.68 0 0 0 .77-.66 3.9 3.9 0 0 0 .56-.92 4.11 4.11 0 0 0 .28-1.07 3.7 3.7 0 0 0 .04-1.13Z"
            style={{
              fill: "#455a64",
              transformOrigin: "208.571px 377.907px",
            }}
            className="animable"
          />
          <path
            d="M231.57 368.27a2.77 2.77 0 0 0 .26.48.85.85 0 0 0 .42.32 1.29 1.29 0 0 0 .66 0 3.43 3.43 0 0 0 1-.42 3.33 3.33 0 0 0 .74-.57 3.22 3.22 0 0 0 .56-.79 3.29 3.29 0 0 0 .32-1 3.48 3.48 0 0 0 0-1.12 2.37 2.37 0 0 0-.3-.9 1 1 0 0 0-.51-.41 1.23 1.23 0 0 0-.66 0 3.55 3.55 0 0 0-.8.34l-1.06.62a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a.79.79 0 0 1 0-.34l.1-.32 1.79-4.84-3.59 2.17a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.28l-.1-.66a.82.82 0 0 1 .06-.4.56.56 0 0 1 .22-.29l5-2.9a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.29l.09.65a.84.84 0 0 1 0 .35 3.57 3.57 0 0 1-.12.4l-1.76 4.76a3.06 3.06 0 0 1 1.2-.39 1.75 1.75 0 0 1 1 .22 2.23 2.23 0 0 1 .75.82 4.34 4.34 0 0 1 .43 1.41 5.77 5.77 0 0 1 0 1.81 6.09 6.09 0 0 1-.51 1.63 5.74 5.74 0 0 1-.89 1.35 5 5 0 0 1-1.19 1 4.06 4.06 0 0 1-1.52.57 2 2 0 0 1-1.12-.15 1.91 1.91 0 0 1-.75-.69 2.92 2.92 0 0 1-.38-1 .64.64 0 0 1 0-.33.43.43 0 0 1 .18-.23l.58-.34c.1-.05.18-.06.24 0a.38.38 0 0 1 .15.12Z"
            style={{
              fill: "#455a64",
              transformOrigin: "233.169px 363.446px",
            }}
            className="animable"
          />
          <path
            d="M244 355.87c.08.54.16 1.05.23 1.52s.14 1 .21 1.54a11.33 11.33 0 0 1 .07 2.09 7.86 7.86 0 0 1-.37 1.93 5.63 5.63 0 0 1-.85 1.63 4.69 4.69 0 0 1-1.39 1.22 2.83 2.83 0 0 1-1.5.45 1.8 1.8 0 0 1-1.15-.47 3.36 3.36 0 0 1-.82-1.25 7.7 7.7 0 0 1-.49-1.84q-.14-.81-.24-1.53c-.06-.47-.13-1-.2-1.54a9.7 9.7 0 0 1-.07-2.08 7.42 7.42 0 0 1 .36-1.93 5.68 5.68 0 0 1 .85-1.64 4.58 4.58 0 0 1 1.39-1.23 2.73 2.73 0 0 1 1.5-.44 1.78 1.78 0 0 1 1.16.48 3.31 3.31 0 0 1 .82 1.24 8.3 8.3 0 0 1 .49 1.85Zm-4.83 6.13a3.61 3.61 0 0 0 .91 2.22 1.34 1.34 0 0 0 1.63-.06 3.09 3.09 0 0 0 1.39-1.68 6.14 6.14 0 0 0 .18-2.85c-.07-.55-.14-1.07-.21-1.54s-.14-1-.23-1.53a3.61 3.61 0 0 0-.91-2.23 1.33 1.33 0 0 0-1.62 0 3.11 3.11 0 0 0-1.4 1.7 6.33 6.33 0 0 0-.17 2.86c.06.55.13 1.06.2 1.54l.23 1.57Z"
            style={{
              fill: "#455a64",
              transformOrigin: "240.967px 359.275px",
            }}
            className="animable"
          />
          <path
            d="M265 349a2.77 2.77 0 0 0 .26.48.88.88 0 0 0 .42.32 1.29 1.29 0 0 0 .66 0 3.46 3.46 0 0 0 1-.42 3.52 3.52 0 0 0 .73-.57 3.36 3.36 0 0 0 .56-.78 3.83 3.83 0 0 0 .33-1 3.42 3.42 0 0 0 0-1.11 2.11 2.11 0 0 0-.3-.9 1 1 0 0 0-.5-.42 1.18 1.18 0 0 0-.67 0 3 3 0 0 0-.79.34l-1.06.61a.24.24 0 0 1-.27 0 .38.38 0 0 1-.15-.28l-.09-.66a.62.62 0 0 1 0-.33q0-.18.09-.33l1.8-4.84-3.68 2.12a.23.23 0 0 1-.26 0 .38.38 0 0 1-.08-.23l-.09-.65a.83.83 0 0 1 .05-.41.53.53 0 0 1 .22-.28l5-2.9a.24.24 0 0 1 .27 0 .41.41 0 0 1 .15.29l.09.65a.84.84 0 0 1 0 .35 1.64 1.64 0 0 1-.12.4l-1.76 4.77a3 3 0 0 1 1.21-.4 1.73 1.73 0 0 1 1 .22 2 2 0 0 1 .75.83 4 4 0 0 1 .43 1.41 5.71 5.71 0 0 1 0 1.8 6.46 6.46 0 0 1-.5 1.63 5.68 5.68 0 0 1-.9 1.35 4.74 4.74 0 0 1-1.19 1 4.08 4.08 0 0 1-1.51.57 2 2 0 0 1-1.13-.15 1.78 1.78 0 0 1-.75-.69 3 3 0 0 1-.38-1.05.65.65 0 0 1 .05-.33.43.43 0 0 1 .18-.23l.58-.34a.23.23 0 0 1 .24 0 .43.43 0 0 1 .11.16Z"
            style={{
              fill: "#455a64",
              transformOrigin: "266.587px 344.187px",
            }}
            className="animable"
          />
          <path
            d="M275.44 345.73a.79.79 0 0 1-.05.4.58.58 0 0 1-.23.29l-.52.3a.24.24 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-1.43-10-1.75 3.42a.42.42 0 0 1-.24.26.25.25 0 0 1-.25-.05l-.39-.39a.45.45 0 0 1-.12-.32.71.71 0 0 1 .09-.4l2.3-4.55a.86.86 0 0 1 .19-.25 1.37 1.37 0 0 1 .2-.13l.52-.31a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.29Z"
            style={{
              fill: "#455a64",
              transformOrigin: "272.748px 340.214px",
            }}
            className="animable"
          />
          <path
            d="M303.73 329.4a.81.81 0 0 1-.05.4.62.62 0 0 1-.22.29l-.53.3a.23.23 0 0 1-.26 0 .41.41 0 0 1-.15-.28l-1.43-10-1.75 3.42a.4.4 0 0 1-.24.25.23.23 0 0 1-.25 0l-.39-.38a.52.52 0 0 1-.12-.32.75.75 0 0 1 .09-.41l2.3-4.55a.69.69 0 0 1 .19-.24l.2-.14.52-.3a.23.23 0 0 1 .26 0 .41.41 0 0 1 .15.28Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "301.037px 323.915px",
            }}
            className="animable"
          />
          <path
            d="M334 305.23a6.19 6.19 0 0 0 .43-1.33 4.27 4.27 0 0 0 0-1.43 2.18 2.18 0 0 0-.62-1.38c-.33-.27-.77-.25-1.34.08a2.52 2.52 0 0 0-.74.62 3 3 0 0 0-.45.8 4 4 0 0 0-.22.92 7.45 7.45 0 0 0-.08.95 1.12 1.12 0 0 1-.09.39.46.46 0 0 1-.18.22l-.59.34a.2.2 0 0 1-.21 0 .35.35 0 0 1-.13-.24 6.72 6.72 0 0 1 0-1.48 6.89 6.89 0 0 1 .41-1.59 6.22 6.22 0 0 1 .81-1.47 3.93 3.93 0 0 1 1.21-1.09 2.64 2.64 0 0 1 1.29-.41 1.69 1.69 0 0 1 1 .32 2.43 2.43 0 0 1 .71.92 4.69 4.69 0 0 1 .41 1.4 8.61 8.61 0 0 1 .08 1.09 5.84 5.84 0 0 1-.08 1 7.19 7.19 0 0 1-.26 1 11.37 11.37 0 0 1-.44 1.14l-2.31 5.41 3.9-2.25a.26.26 0 0 1 .27 0 .43.43 0 0 1 .15.29l.09.65a.83.83 0 0 1-.05.41.59.59 0 0 1-.22.28l-5.5 3.17a.21.21 0 0 1-.26 0 .41.41 0 0 1-.15-.29l-.09-.65a1 1 0 0 1 0-.38 3.54 3.54 0 0 1 .17-.47Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "333.383px 306.568px",
            }}
            className="animable"
          />
          <path
            d="M363.48 292.11a2.82 2.82 0 0 0 .27.48.78.78 0 0 0 .42.31 1.25 1.25 0 0 0 .65 0 3.36 3.36 0 0 0 1-.42 3.28 3.28 0 0 0 .73-.57 3 3 0 0 0 .57-.79 3.5 3.5 0 0 0 .32-1 3.23 3.23 0 0 0 0-1.12 2.16 2.16 0 0 0-.29-.9 1 1 0 0 0-.51-.41 1.27 1.27 0 0 0-.67 0 3.69 3.69 0 0 0-.79.34l-1.06.61a.21.21 0 0 1-.26 0 .43.43 0 0 1-.15-.29l-.1-.65a1 1 0 0 1 0-.34c0-.12.07-.22.1-.32l1.79-4.84-3.67 2.12a.23.23 0 0 1-.26 0 .38.38 0 0 1-.15-.29l-.1-.65a.79.79 0 0 1 .05-.4.58.58 0 0 1 .23-.29l5-2.9a.23.23 0 0 1 .26 0 .37.37 0 0 1 .15.28l.1.66a1.06 1.06 0 0 1 0 .35 3.57 3.57 0 0 1-.12.4l-1.76 4.76a3.06 3.06 0 0 1 1.2-.39 1.63 1.63 0 0 1 1 .22 2.17 2.17 0 0 1 .76.82 4.43 4.43 0 0 1 .43 1.41 6 6 0 0 1-.53 3.44 5.74 5.74 0 0 1-.89 1.35 5 5 0 0 1-1.2 1 4 4 0 0 1-1.51.57 2 2 0 0 1-1.13-.16 1.73 1.73 0 0 1-.74-.68 3 3 0 0 1-.38-1.05.63.63 0 0 1 0-.33.49.49 0 0 1 .18-.23l.59-.34a.21.21 0 0 1 .24 0 .37.37 0 0 1 .23.24Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "364.996px 287.216px",
            }}
            className="animable"
          />
        </g>
      </g>
      <AnimateCharacter
        className="animable"
        style={{
          transformOrigin: "163.369px 177.004px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "163.369px 177.004px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "192.831px 113.956px",
            }}
          >
            <path
              d="M153 81.7c8 1.09 9.92.88 17 9.84 5.76 7.34 13.93 17.91 21.37 29.32l24.14-9.9 5.28 13.11s-20.4 11.49-27.66 15c-5.43 2.64-9.66 2.09-13.91-2.31-6.79-7-21-22.56-21-22.56Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "186.895px 111.182px",
              }}
              className="animable"
            />
            <g
              className="animable"
              style={{
                transformOrigin: "208.608px 115.849px",
              }}
            >
              <path
                d="m229.54 86.38-1.64-.81a1.56 1.56 0 0 0-1.42.21L189.7 106.9a5.57 5.57 0 0 0-2.48 3.9l-2.63 33a1.41 1.41 0 0 0 .59 1.49l1.7.83a1.57 1.57 0 0 0 1.44-.2l36.78-21.12a5.58 5.58 0 0 0 2.48-3.91c.51-6.48 2.12-26.48 2.63-32.95.08-.84-.21-1.37-.67-1.56Z"
                style={{
                  fill: "#455a64",
                  transformOrigin: "207.388px 115.848px",
                }}
                className="animable"
              />
              <path
                d="M190 109a5.46 5.46 0 0 0-1.11 2.66l-2.64 33a1.47 1.47 0 0 0 .54 1.47l-1.59-.78a1.41 1.41 0 0 1-.6-1.49l2.63-33a5.32 5.32 0 0 1 1-2.51Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "187.283px 127.24px",
                }}
                className="animable"
              />
              <path
                d="m186.27 144.58 2.63-33a5.52 5.52 0 0 1 2.48-3.91l36.78-21.07c1.25-.72 2.18-.13 2.06 1.31-.51 6.47-2.12 26.47-2.63 33a5.58 5.58 0 0 1-2.48 3.91l-36.78 21.12c-1.25.67-2.18.06-2.06-1.36Z"
                style={{
                  fill: "#37474f",
                  transformOrigin: "208.245px 116.253px",
                }}
                className="animable"
              />
              <path
                d="m191.38 107.72 8.59-4.8 8.56-4.86 17.11-9.73 2.13-1.23a4.59 4.59 0 0 1 1-.52.88.88 0 0 1 .91.18c.46.5.23 1.4.2 2.2l-.19 2.45-.74 9.82-.74 9.81-.66 9.82.91-9.8.82-9.81.83-9.8.21-2.45c0-.42.07-.81.09-1.24a1.79 1.79 0 0 0-.39-1.31 1.34 1.34 0 0 0-1.37-.33 5 5 0 0 0-1.16.56l-2.14 1.22-17 9.87-8.51 4.94Z"
                style={{
                  fill: "#455a64",
                  transformOrigin: "210.9px 103.457px",
                }}
                className="animable"
              />
              <path
                d="m190.56 118 .5-6.17a1.05 1.05 0 0 1 .46-.73l2.53-1.45c.24-.13.41 0 .39.25-.1 1.21-.4 5-.49 6.17a1 1 0 0 1-.47.73l-2.48 1.41c-.28.13-.46.02-.44-.21Z"
                style={{
                  fill: "#455a64",
                  transformOrigin: "192.5px 113.932px",
                }}
                className="animable"
              />
              <path
                d="M191.54 113.11a2.58 2.58 0 0 1 1.2-1.81c.6-.35 1-.1 1 .56a2.61 2.61 0 0 1-1.2 1.81c-.6.33-1.05.1-1-.56Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "192.638px 112.481px",
                }}
                className="animable"
              />
              <path
                d="M191.33 116.22a2.62 2.62 0 0 1 1.19-1.82c.61-.35 1.06-.1 1 .56a2.59 2.59 0 0 1-1.19 1.82c-.61.34-1.05.09-1-.56Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "192.426px 115.587px",
                }}
                className="animable"
              />
              <path
                d="M231.51 106.86c1-2 .8-2.27-.08-3.06a5.82 5.82 0 0 0-5.08-1.51c-1.58.35-3.19.62-3.93 1.19s.28 2.18 2.44 2.25c3.4.12 3.54 1 3.54 1a43.47 43.47 0 0 0-4.35 0 31.52 31.52 0 0 0-4.65 1.62c-1.34.48-1.28 2.31 1.17 2.48l-2.45.88c-1.71.61-2.14 1.66-.55 2.5a2.67 2.67 0 0 0 1.72.3s-1.89.35-1.81 1c.23 1.82 1.48 2.07 5.49 2.46 3.82.38 4.93 2.19 4.46 3.67 0 0 1.3-1.12 2.43-2.26.83-.84 1.5-1.73.8-3.14 0 0 2.08-.35 2-1.65a6.71 6.71 0 0 0-1-2.65 2.3 2.3 0 0 0 .74-2.34 3.76 3.76 0 0 0-1.17-2.11Z"
                style={{
                  fill: "#ffbda7",
                  transformOrigin: "224.621px 111.916px",
                }}
                className="animable"
              />
              <path
                d="M220.57 110.89a11.63 11.63 0 0 1 2.24-.67 7.47 7.47 0 0 1 2.35.28 27.12 27.12 0 0 1 4.4 1.4 28.64 28.64 0 0 1-4.54-.73 12.16 12.16 0 0 0-2.18-.43c-.7.02-1.5.15-2.27.15Z"
                style={{
                  fill: "#f0997a",
                  transformOrigin: "225.065px 111.057px",
                }}
                className="animable"
              />
              <path
                d="M219.29 114.57a5.07 5.07 0 0 1 2.46-.54 13 13 0 0 1 2.5.3 24.08 24.08 0 0 1 4.75 1.51 49.42 49.42 0 0 1-4.89-.84 12.89 12.89 0 0 0-4.82-.43Z"
                style={{
                  fill: "#f0997a",
                  transformOrigin: "224.145px 114.933px",
                }}
                className="animable"
              />
            </g>
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "171.93px 135.385px",
            }}
          >
            <path
              d="M174.61 110.24c3.22 13.61 5.25 50.29 5.25 50.29l-15.86-2.4v-47.89Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "171.93px 135.385px",
              }}
              className="animable"
            />
            <path
              d="M174.61 110.24c3.22 13.61 5.25 50.29 5.25 50.29l-15.86-2.4v-47.89Z"
              style={{
                opacity: 0.25,
                transformOrigin: "171.93px 135.385px",
              }}
              className="animable"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "176.442px 241.636px",
            }}
          >
            <path
              d="M172.57 153.1c0 3.28 19.88 9.48 34 14.46 16.21 5.72 23.89 9.71 29.75 16 3.3 3.53 5.14 7.92 4 13.44-.85 4-4.53 10.46-12.38 16.31-14.91 11.09-22.05 13.57-32.5 19.91 0 0-10.3-7.26-11.72-15.35l15.12-15.61-41.65-13.67Z"
              style={{
                fill: "#455a64",
                transformOrigin: "198.924px 193.16px",
              }}
              className="animable"
            />
            <path
              d="M203.28 219.14c.17 3.06.3 6.32.41 9.32-2.66 1.45-5.35 2.93-8.29 4.71 0 0-10.3-7.25-11.72-15.34l13.24-13.67c4.2 4.42 5.88 6.37 6.36 14.98Z"
              style={{
                fill: "#37474f",
                transformOrigin: "193.685px 218.665px",
              }}
              className="animable"
            />
            <path
              d="m157.15 188.55 1.39-2.69s24.15 6.43 32.55 8.61c7.11 1.86 8.52 2.13 12.26-1 5.19-4.29 8.72-4.87 12.22-3.95-5.37.5-11.24 6.35-16.77 12.66Z"
              style={{
                fill: "#37474f",
                transformOrigin: "186.36px 194.02px",
              }}
              className="animable"
            />
            <path
              d="m168.14 177.23 25 23.14-36-11.82L168.7 160l2.91-.3a53.75 53.75 0 0 1-3.47 17.53Z"
              style={{
                fill: "#37474f",
                transformOrigin: "175.14px 180.035px",
              }}
              className="animable"
            />
            <path
              d="M186.36 216.71c-2.67 2.8-4.71 4.81-5.17 4.93a5.81 5.81 0 0 1-1.64.27s-10.55 8.36-17.38 14.79-10.79 9.54-9.28 15.52 9.49 16.58 10.8 17.43 3.84-8 3.84-8c1.08-3.2 3.72-9.31 6.4-12.62s6.24-5.77 10.92-9.15c1.88-1.35 6.62-4.48 11.8-7.83Z"
              style={{
                fill: "#ffbda7",
                transformOrigin: "174.61px 243.209px",
              }}
              className="animable"
            />
            <path
              d="M184.85 239.86c1.88-1.35 6.62-4.48 11.8-7.83l-10.29-15.32c-2.67 2.8-4.71 4.81-5.17 4.93a5.81 5.81 0 0 1-1.64.27s-4.24 3.35-9.07 7.44a14.23 14.23 0 0 1 1.15 6.39 61.12 61.12 0 0 0 1.37 14.53c.31-.45.62-.88.93-1.26 2.67-3.32 6.24-5.77 10.92-9.15Z"
              style={{
                fill: "#f0997a",
                transformOrigin: "183.565px 233.49px",
              }}
              className="animable"
            />
            <path
              d="M167.28 224c-1.73 1.31-3.06 4-5.65 6.27a60.13 60.13 0 0 1-9.54 6.76l-4.72 2.72.74 1.28 8.59-5c2.62-1.51 4.92-2.09 5.93-1 0 .08 8.23-4.79 4.65-11.03Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "157.776px 232.515px",
              }}
              className="animable"
            />
            <path
              d="M167.28 224c-1.73 1.31-3.06 4-5.65 6.27a60.13 60.13 0 0 1-9.54 6.76l-4.72 2.72.74 1.28 8.59-5c2.62-1.51 4.92-2.09 5.93-1 0 .08 8.23-4.79 4.65-11.03Z"
              style={{
                opacity: 0.4,
                transformOrigin: "157.776px 232.515px",
              }}
              className="animable"
            />
            <path
              d="M180.72 221.49c-2.65.47-6.06-.33-10 .61a8.12 8.12 0 0 0-4.18 2.62c-.47 1.63-.45 2.51-.74 3.69a12.18 12.18 0 0 1-2.25 5.48 90.08 90.08 0 0 1-8.41 9.16c-2.94 2.86-4.83 4.41-4.76 8.37.05 3.09 2.78 11.05 5.34 16 3.48 6.75 8.45 7.47 9.49 3.54s2.2-8.25 2.29-9.32a13.8 13.8 0 0 0-4.47-5.53c-3.75-2.7-6.56-2.59-6.94-7.56-.35-4.5 5-10.62 14.35-15.85 10.68-5.94 10.28-11.21 10.28-11.21Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "165.55px 247.423px",
              }}
              className="animable"
            />
            <path
              d="M180.72 221.49c-2.65.47-6.06-.33-10 .61a8.12 8.12 0 0 0-4.18 2.62c-.47 1.63-.45 2.51-.74 3.69a12.18 12.18 0 0 1-2.25 5.48 90.08 90.08 0 0 1-8.41 9.16c-2.94 2.86-4.83 4.41-4.76 8.37.05 3.09 2.78 11.05 5.34 16 3.48 6.75 8.45 7.47 9.49 3.54s2.2-8.25 2.29-9.32a13.8 13.8 0 0 0-4.47-5.53c-3.75-2.7-6.56-2.59-6.94-7.56-.35-4.5 5-10.62 14.35-15.85 10.68-5.94 10.28-11.21 10.28-11.21Z"
              style={{
                opacity: 0.35,
                transformOrigin: "165.55px 247.423px",
              }}
              className="animable"
            />
            <path
              d="M180.72 221.49c-2.65.47-6.06-.33-10 .61a8 8 0 0 0-4.07 2.5 12 12 0 0 1 4.68 7.58c9.77-5.72 9.39-10.69 9.39-10.69Z"
              style={{
                opacity: 0.35,
                transformOrigin: "173.686px 226.835px",
              }}
              className="animable"
            />
            <path
              d="M215.24 317.21a39.06 39.06 0 0 1-7.13-10.46c-1.68-4-3-9.66-4-15.4a174.09 174.09 0 0 1-1.57-17.94l-18.4 2.71c1.31 4.29 2.33 8.26 2 9.78a6.57 6.57 0 0 1-.54 1.6s2.4 13.43 4.88 22.58 3.37 14.19 9.43 15.7 19.33-.54 20.72-1.31-5.39-7.26-5.39-7.26Z"
              style={{
                fill: "#ffbda7",
                transformOrigin: "202.479px 299.865px",
              }}
              className="animable"
            />
            <path
              d="M181.56 299.46c.34 2.17 2.14 4.66 2.89 8.05a59.9 59.9 0 0 1 1.48 11.74c.15 4.83.17 5.52.17 5.52h1.5s-.22-7-.32-10 .49-5.39 1.94-5.77c0-.09-.42-9.77-7.66-9.54Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "185.39px 312.113px",
              }}
              className="animable"
            />
            <path
              d="M181.56 299.46c.34 2.17 2.14 4.66 2.89 8.05a59.9 59.9 0 0 1 1.48 11.74c.15 4.83.17 5.52.17 5.52h1.5s-.22-7-.32-10 .49-5.39 1.94-5.77c0-.09-.42-9.77-7.66-9.54Z"
              style={{
                opacity: 0.25,
                transformOrigin: "185.39px 312.113px",
              }}
              className="animable"
            />
            <path
              d="M185.71 286.24c-.85 2.6-3.2 5.26-4.22 9.2a8.2 8.2 0 0 0 .34 5c1.22 1.19 2 1.6 2.94 2.42a12.43 12.43 0 0 1 3.81 4.63 91 91 0 0 1 4.16 11.89c1.15 4 1.63 6.41 5.2 8.25 2.78 1.43 11.19 2.79 16.82 2.87 7.69.12 10.71-4 7.7-6.78s-6.31-5.91-7.22-6.5a14 14 0 0 0-7.08 1.35c-4.2 2.05-5.45 4.61-10.07 2.58-4.18-1.84-7.1-9.51-7.28-20.38-.21-12.36-5.1-14.53-5.1-14.53Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "202.429px 308.371px",
              }}
              className="animable"
            />
            <path
              d="M185.71 286.24c-.85 2.6-3.2 5.26-4.22 9.2a8.2 8.2 0 0 0 .34 5c1.22 1.19 2 1.6 2.94 2.42a12.43 12.43 0 0 1 3.81 4.63 91 91 0 0 1 4.16 11.89c1.15 4 1.63 6.41 5.2 8.25 2.78 1.43 11.19 2.79 16.82 2.87 7.69.12 10.71-4 7.7-6.78s-6.31-5.91-7.22-6.5a14 14 0 0 0-7.08 1.35c-4.2 2.05-5.45 4.61-10.07 2.58-4.18-1.84-7.1-9.51-7.28-20.38-.21-12.36-5.1-14.53-5.1-14.53Z"
              style={{
                opacity: 0.2,
                transformOrigin: "202.429px 308.371px",
              }}
              className="animable"
            />
            <path
              d="m172.57 153.1-58 2.43c-2.85 12.17-3 19.76-1 26.66 1.78 6.31 7.1 13.86 18.9 21.24 14 8.76 31.31 16.85 34.63 19.11 4.77 3.27 7.39 2.37 7.25 14.28-.08 7.63 3.6 18.86 5.53 25.73 2 7.22 4.64 16.34 4.64 16.34 2.32 3.64 14.29 3.92 18.63-.71 0 0-.77-47.42-1.87-57.13-.61-5.43-1.24-10.3-7.06-16.84-5-5.6-30.16-26.41-30.16-26.41s6.99-8.39 8.51-24.7Z"
              style={{
                fill: "#455a64",
                transformOrigin: "157.688px 217.369px",
              }}
              className="animable"
            />
            <path
              d="M180.48 252.56c1.48 8.05 5.68 21.33 7.45 28.44a15 15 0 0 0 1.6.37c-1.77-7.15-6.06-20.76-7.59-29.09-2-10.91-1.5-13.15-1.43-20.74 0-3.21.05-6-.1-8.33-.37-6.13-12.59-13.16-28-22.06-5.21-3-10.6-6.1-15.77-9.33-17.15-10.7-16.13-18.7-14.42-32 .18-1.38.36-2.83.53-4.32l-1.51.18c-.16 1.35-.33 2.68-.49 3.95-1.72 13.39-2.86 22.24 15.12 33.45 5.19 3.24 10.59 6.34 15.81 9.35 13.87 8 27 15.53 27.31 20.85.14 2.29.12 5 .09 8.22-.08 7.68-.63 10.01 1.4 21.06Z"
              style={{
                fill: "#37474f",
                transformOrigin: "154.689px 218.435px",
              }}
              className="animable"
            />
            <path
              d="M131.08 189.56c.24-.15 5.82-3.76 4.12-13.64-1.85-10.79-1.19-15.73 0-22.89l-1.46-.26c-1.25 7.35-1.88 12.59 0 23.41 1.53 8.88-3.39 12.06-3.44 12.09Z"
              style={{
                fill: "#37474f",
                transformOrigin: "132.911px 171.165px",
              }}
              className="animable"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "131.32px 126.491px",
            }}
          >
            <g
              className="animable"
              style={{
                transformOrigin: "142.388px 125.326px",
              }}
            >
              <path
                d="m133.51 79.33-16.57 4.41c-2.83 1-11.54 10.43-7.81 26.51 1 4.35 4 12.84 6.83 21.16a23.36 23.36 0 0 1 .84 12.15c-1.51 7.37-3.28 12.67-5.35 23.65 0 0 7.83 6.4 35.89 3.23 21.41-2.41 27.27-14.91 27.27-14.91-.56-3.37-2.28-8.4-4-14.9.13-7.91-.16-12.78-.14-16.82 0 0 6.09-3.29 6.09-12.36 0-7.11-2.81-10.83-10.08-18.09A109.14 109.14 0 0 0 153 81.7Z"
                style={{
                  fill: "#37474f",
                  transformOrigin: "142.388px 125.326px",
                }}
                className="animable"
              />
            </g>
            <g
              className="animable"
              style={{
                transformOrigin: "139.098px 64.9523px",
              }}
            >
              <path
                d="M162.07 71.13A128.46 128.46 0 0 1 158 54.64l1.47-.5c6.58-3.82 5.95-12.54 4.18-17-4-10-15.07-13.48-21.87-13.62-12.91-.28-19.09 3.25-20.19 10-1.75-.09-4.1 1.39-5.49 3.41-3 4.42-3.93 21-.81 34.27 0 0 1.24 1.29 5.48 2.06a34.5 34.5 0 0 0 6.4.55s25.18 3.6 34.9-2.68Z"
                style={{
                  fill: "#37474f",
                  transformOrigin: "139.098px 49.1708px",
                }}
                className="animable"
              />
              <path
                d="M123.72 66.79c-2.32.42-4.16-.74-5.56-2.3-3.1-3.45-3.37-6.95-1.9-9.27 1.21-1.91 4.16-3.12 6.22-1.81s2.27 2.53 3.09 4.1 4.06 1.45 4.87-4.85c.75-5.89 1.68-11.28 4.58-13.92 4.33-4 9.11-3.27 10.81-.91 1.78-2.74 4.46-3.83 7.39-2.24s5.14 6 6.09 17.17c1 11.4-1.76 18.49-4.38 20.39-2 1.44-4.21 2.08-8.49 2.25l.36 6s7.48 15.25 7.41 25c0 0-3.76-6.06-14.67-15l-11.86-9.69L126.52 65a3.65 3.65 0 0 1-2.8 1.79Z"
                style={{
                  fill: "#ffbda7",
                  transformOrigin: "137.459px 70.6265px",
                }}
                className="animable"
              />
              <path
                d="m156.94 47.36-4.36-1.1a2.15 2.15 0 0 1 2.65-1.66 2.36 2.36 0 0 1 1.71 2.76Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "154.784px 45.9453px",
                }}
                className="animable"
              />
              <path
                d="M141.55 47.31 137 49a2.31 2.31 0 0 1 1.33-3.08 2.52 2.52 0 0 1 3.22 1.39Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "139.182px 47.3783px",
                }}
                className="animable"
              />
              <path
                d="M137 39.59c-.76 1.44-1 3.89-1.18 6.25-.15 1.9-.18 6.38-1.38 9.08a6.9 6.9 0 0 1-5.16 4.31 9.07 9.07 0 0 1-4.48-.3c-.89-.38-3.42-2-3.2-4.6a5.37 5.37 0 0 0 1.85 1.22 5.51 5.51 0 0 0 1.65.34 5 5 0 0 0 4.14-2.48c1.58-2.52 1.36-5.85 1.78-8.69.53-3.62 1-7.72 4.2-9.61 3.77-2.23 9.64-1.17 10.6 2.72a5.93 5.93 0 0 0-8.82 1.76Z"
                style={{
                  fill: "#37474f",
                  transformOrigin: "133.703px 46.6698px",
                }}
                className="animable"
              />
              <path
                d="m140.41 63.07 6.25 1.8a3.25 3.25 0 0 1-4.33 2.13 3.05 3.05 0 0 1-1.92-3.93Z"
                style={{
                  fill: "#b16668",
                  transformOrigin: "143.445px 65.1506px",
                }}
                className="animable"
              />
              <path
                d="M144.13 67.13a3.43 3.43 0 0 0-3.53-2.93 1.77 1.77 0 0 0-.32 0 2.89 2.89 0 0 0 2.05 2.8 3.72 3.72 0 0 0 1.8.13Z"
                style={{
                  fill: "#f0997a",
                  transformOrigin: "142.205px 65.6891px",
                }}
                className="animable"
              />
              <path
                style={{
                  fill: "#f0997a",
                  transformOrigin: "149.35px 55.225px",
                }}
                className="animable"
                d="m145.7 49.63 1.21 11.19 6.09-2.3-7.3-8.89z"
              />
              <path
                d="M146.44 75.4a39.75 39.75 0 0 1-12.14-2.33c-1.42-.56-3.37-3.07-5-5.88 0 0 1.21 5.58 4.29 7.44 4.68 2.82 13 3.26 13 3.26Z"
                style={{
                  fill: "#f0997a",
                  transformOrigin: "137.945px 72.54px",
                }}
                className="animable"
              />
              <path
                d="M155.65 51.71c.32.92-.32 1.22-1.2 1.53s-1.68.49-2-.42a1.69 1.69 0 1 1 3.2-1.11Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "154.045px 52.0311px",
                }}
                className="animable"
              />
              <path
                d="M152.64 50.94a4.29 4.29 0 0 1 1.27-.46 3.62 3.62 0 0 1 1.31-.07 4.37 4.37 0 0 1 1.34.39s.06.11 0 .11c-.36 0-.67-.1-1.19-.12a6.57 6.57 0 0 0-1.47.18 6.14 6.14 0 0 0-1.67.62c-.17.09-.51.27-.54.3s-.09-.1-.06-.14a2.88 2.88 0 0 1 1.01-.81Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "154.104px 51.1372px",
                }}
                className="animable"
              />
              <path
                d="M138.48 52.42c-.21.95.46 1.18 1.38 1.38s1.72.3 1.93-.65a1.72 1.72 0 0 0-1.27-2.08 1.75 1.75 0 0 0-2.04 1.35Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "140.14px 52.4858px",
                }}
                className="animable"
              />
              <path
                d="M141.39 51.31a4.54 4.54 0 0 0-1.32-.31 3.61 3.61 0 0 0-1.31.08 4.34 4.34 0 0 0-1.28.54s0 .12 0 .11a11 11 0 0 1 1.17-.25 6.11 6.11 0 0 1 1.48 0 6.62 6.62 0 0 1 1.73.43l.57.23c.05 0 .08-.1.05-.14a3 3 0 0 0-1.09-.69Z"
                style={{
                  fill: "#263238",
                  transformOrigin: "139.986px 51.5566px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M127.66 80.88c4.14 7.12 7.94 17.83 8.05 33.12s-4 63.58-4 63.58a21.46 21.46 0 0 1-20.77-9.4c.1-4.39 3.14-14.83 4.94-22.16s.07-13-2.94-22c-2-5.9-6.61-15.33-5.69-23.54s4-15.17 9.72-16.7Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "121.421px 129.328px",
              }}
              className="animable"
            />
            <path
              d="M127.66 80.88c4.14 7.12 7.94 17.83 8.05 33.12s-4 63.58-4 63.58a21.46 21.46 0 0 1-20.77-9.4c.1-4.39 3.14-14.83 4.94-22.16s.07-13-2.94-22c-2-5.9-6.61-15.33-5.69-23.54s4-15.17 9.72-16.7Z"
              style={{
                opacity: 0.15,
                transformOrigin: "121.421px 129.328px",
              }}
              className="animable"
            />
            <path
              d="M146.8 81.45S167.27 93 170.91 98c-7.09-9.86-15.48-19.52-24.43-22Z"
              className="animable"
              style={{
                transformOrigin: "158.695px 87px",
              }}
            />
            <path
              d="M135.6 120.09c-.44-4.76-3.84-17.45-7.13-24.68-3.91-8.6-6.23-13.08-6.23-13.08a17.79 17.79 0 0 0 3.1-4.65 5.47 5.47 0 0 1 1.86-2.81l.2 2.81s2.19 4.31 4.49 9.52 5.24 19.72 3.71 32.89Z"
              className="animable"
              style={{
                transformOrigin: "129.132px 97.48px",
              }}
            />
            <g
              className="animable"
              style={{
                transformOrigin: "103.589px 156.609px",
              }}
            >
              <path
                d="M116.94 84.35c-11.92 3.15-16 5.83-18.82 18.29C97 107.8 94 121 90.49 142.41c-.67 4.1-.11 7.12.37 11.47 2.75 25 3.4 30.92 4.17 38.83.43 4.43-.56 3-7.56 12.76a6 6 0 0 0-1.38 2.84c-.11 1.33.71 4.31.67 5.14-.32 1.86-.94 4.68 1 6a12.17 12.17 0 0 0 .3 3.5c.31.88 1.16 1.18 1.48 1.92.41.95-.69 5.19 1.18 4.54s2.25-2.63 2.71-4.23c1.09-3.15.41-7.21 2.43-9.91 1.76-1.54 3.9-4.47 6.45-4.17.25.27-.65 1.45-.82 1.85-.42 1-.81 2.13-1.16 3.19-1 2-.92 7.93 2.39 6 1.82-3.73 3.83-6.67 5.75-10.35 4-7.64 1.18-14.41 1.12-21.69-.1-9.9.37-26.93.69-41.76l6.72-29.17c2.74-10.45 5.49-25.62-.06-34.82Z"
                style={{
                  fill: "#ffbda7",
                  transformOrigin: "103.118px 156.914px",
                }}
                className="animable"
              />
              <path
                d="m89.61 225.45.17-4.37c.06-1.46.11-2.91.27-4.36.07-.72.13-1.45.24-2.16a8.47 8.47 0 0 1 .69-2 21.06 21.06 0 0 1 2.33-3.67 16.41 16.41 0 0 0-2.57 3.55 7.6 7.6 0 0 0-.77 2.09c-.12.73-.2 1.45-.28 2.18a65.67 65.67 0 0 0-.08 8.74Z"
                style={{
                  fill: "#f0997a",
                  transformOrigin: "91.4058px 217.17px",
                }}
                className="animable"
              />
              <path
                d="M116.94 83.74c-5.19 1.34-11.53 3-15.12 7.39s-4.54 10.39-7.82 26.31-4.78 24.18-4.33 29.49c.54 6.37 1.6 16.3 1.6 16.3a21 21 0 0 1 10.59-3.53c6.08-.22 8.13 1.76 8.13 1.76l.76-13.53 9.09-34s4.26-23.93-2.9-30.19Z"
                style={{
                  fill: "#f6a293",
                  transformOrigin: "105.345px 123.485px",
                }}
                className="animable"
              />
            </g>
          </g>
        </g>
      </AnimateCharacter>
      <g
        className="animable"
        style={{
          transformOrigin: "83.1863px 403.471px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "83.1863px 403.471px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "82.2901px 438.582px",
            }}
          >
            <path
              d="M110.51 434.22H54l5.84 24.34c.44 2.94 2.6 5.8 6.49 8.05 8.79 5.07 23 5.07 31.83 0 4.18-2.42 6.35-5.55 6.55-8.72Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "82.255px 452.316px",
              }}
              className="animable"
            />
            <path
              d="M110.51 434.22H54l5.84 24.34c.44 2.94 2.6 5.8 6.49 8.05 8.79 5.07 23 5.07 31.83 0 4.18-2.42 6.35-5.55 6.55-8.72Z"
              style={{
                fill: "#fff",
                opacity: 0.6,
                transformOrigin: "82.255px 452.316px",
              }}
              className="animable"
            />
            <path
              d="M110.51 434.22H54l5.84 24.34c.44 2.94 2.6 5.8 6.49 8.05 8.79 5.07 23 5.07 31.83 0 4.18-2.42 6.35-5.55 6.55-8.72Z"
              style={{
                fill: "#fff",
                opacity: 0.6,
                transformOrigin: "82.255px 452.316px",
              }}
              className="animable"
            />
            <path
              d="M103.62 450.91a23.79 23.79 0 0 0 3.39-2.37l3.18-13a23.11 23.11 0 0 1-5.71 4.54c-11.92 6.88-31 7.05-43.35.56l1.43-5.8-.44-.61H54l5.84 24.33c.44 2.94 2.6 5.8 6.49 8.05 6.26 3.61 15.29 4.64 23.14 3.1-14.08 1.05-23.74-5.1-25.19-10.78-.57-2.26-1.58-7.27-1.58-7.27 11.78 5.96 29.69 5.73 40.92-.75Z"
              style={{
                fill: "#f6a293",
                opacity: 0.2,
                transformOrigin: "82.095px 452.316px",
              }}
              className="animable"
            />
            <path
              d="M113.45 427a12 12 0 0 1-1.88 4.4 21.08 21.08 0 0 1-7.09 6.29c-12.27 7.08-32.16 7.08-44.43 0a21 21 0 0 1-7.05-6.27 12.11 12.11 0 0 1-1.87-4.4c-1.1-5.32 1.9-10.87 9-14.95 12.27-7.09 32.16-7.09 44.43 0 6.99 4.08 9.99 9.63 8.89 14.93Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "82.2901px 424.876px",
              }}
              className="animable"
            />
            <path
              d="M113.45 427a12 12 0 0 1-1.88 4.4 21.08 21.08 0 0 1-7.09 6.29c-12.27 7.08-32.16 7.08-44.43 0a21 21 0 0 1-7.05-6.27 12.11 12.11 0 0 1-1.87-4.4c-1.1-5.32 1.9-10.87 9-14.95 12.27-7.09 32.16-7.09 44.43 0 6.99 4.08 9.99 9.63 8.89 14.93Z"
              style={{
                fill: "#fff",
                opacity: 0.8,
                transformOrigin: "82.2901px 424.876px",
              }}
              className="animable"
            />
            <path
              d="M111.57 431.42a21.08 21.08 0 0 1-7.09 6.29c-12.27 7.08-32.16 7.08-44.43 0a21 21 0 0 1-7.05-6.29 12.11 12.11 0 0 1-1.87-4.4l1.39 9.58c.64 3.86 3.51 7.61 8.63 10.56 11.69 6.75 30.64 6.75 42.33 0 5-2.91 7.92-6.62 8.6-10.42l.07-.49 1.35-9.23a12 12 0 0 1-1.93 4.4Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "82.315px 439.621px",
              }}
              className="animable"
            />
            <path
              d="M111.57 431.42a21.08 21.08 0 0 1-7.09 6.29c-12.27 7.08-32.16 7.08-44.43 0a21 21 0 0 1-7.05-6.29 12.11 12.11 0 0 1-1.87-4.4l1.39 9.58c.64 3.86 3.51 7.61 8.63 10.56 11.69 6.75 30.64 6.75 42.33 0 5-2.91 7.92-6.62 8.6-10.42l.07-.49 1.35-9.23a12 12 0 0 1-1.93 4.4Z"
              style={{
                fill: "#fff",
                opacity: 0.6,
                transformOrigin: "82.315px 439.621px",
              }}
              className="animable"
            />
            <path
              d="M100.78 414.2c-10.23-5.9-26.8-5.9-37 0-5.78 3.35-8.29 7.86-7.53 12.21.58 3.35 3.09 6.6 7.53 9.16 10.22 5.91 26.79 5.91 37 0 4.43-2.56 6.94-5.81 7.52-9.15.77-4.36-1.74-8.87-7.52-12.22Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "82.2766px 424.889px",
              }}
              className="animable"
            />
            <path
              d="M100.78 414.2c-10.23-5.9-26.8-5.9-37 0-5.78 3.35-8.29 7.86-7.53 12.21.58 3.35 3.09 6.6 7.53 9.16 10.22 5.91 26.79 5.91 37 0 4.43-2.56 6.94-5.81 7.52-9.15.77-4.36-1.74-8.87-7.52-12.22Z"
              style={{
                fill: "#fff",
                opacity: 0.6,
                transformOrigin: "82.2766px 424.889px",
              }}
              className="animable"
            />
            <path
              d="M58 430.46a17.6 17.6 0 0 0 5.81 5.11c10.22 5.91 26.79 5.91 37 0a17.55 17.55 0 0 0 5.8-5.11c-.08-3.54-2.44-7-7.11-9.75-9.5-5.49-24.91-5.49-34.4 0-4.7 2.7-7.1 6.22-7.1 9.75Z"
              style={{
                fill: "#fafafa",
                transformOrigin: "82.305px 428.297px",
              }}
              className="animable"
            />
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "83.1863px 394.97px",
            }}
          >
            <path
              d="M74.36 392.38c-.49-14.44-5.92-36.88-11.15-45.94 7.9 9.45 15.82 25.3 16.45 42.71Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "71.435px 369.41px",
              }}
              className="animable"
            />
            <path
              d="M74.36 392.38c-.49-14.44-5.92-36.88-11.15-45.94 7.9 9.45 15.82 25.3 16.45 42.71Z"
              style={{
                opacity: 0.35,
                transformOrigin: "71.435px 369.41px",
              }}
              className="animable"
            />
            <path
              d="M90 423.53c.48-10 7.87-13.3 16.18-10 5.91 2.33 14.45 11.11 17.14 25.1-2.6-7.26-21.77-31.63-33.32-15.1Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "106.66px 425.462px",
              }}
              className="animable"
            />
            <path
              d="M90.48 428.37c.47-3.74 3.84-8.65 9.71-7.44s19.69 12 25.56 29.7c-1.07-11.88-4.92-22.13-12.86-28.76s-13.71-7.67-19.52-4.23c-4.99 2.96-2.89 10.73-2.89 10.73Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "107.896px 433.174px",
              }}
              className="animable"
            />
            <path
              d="M90.48 428.37c.47-3.74 3.84-8.65 9.71-7.44s19.69 12 25.56 29.7c-1.07-11.88-4.92-22.13-12.86-28.76s-13.71-7.67-19.52-4.23c-4.99 2.96-2.89 10.73-2.89 10.73Z"
              style={{
                opacity: 0.2,
                transformOrigin: "107.896px 433.174px",
              }}
              className="animable"
            />
            <path
              d="M80 433.22c-4.78-16-5.49-45.65-.89-61.69 6.5-22.67 20-32.61 30.05-35-9.53 4-19.59 18.51-22.42 32.73s-1.21 64-1.21 64Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "92.586px 384.895px",
              }}
              className="animable"
            />
            <path
              d="M97.91 382.79c6.49-6.36 11.56-10.66 19.62-10.25s18.8 11.67 25 35.51c-6.44-15.15-14.78-28.46-28.14-29.88-10.48-1.12-16.48 4.62-16.48 4.62Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "120.22px 390.282px",
              }}
              className="animable"
            />
            <path
              d="M97.91 382.79c6.49-6.36 11.56-10.66 19.62-10.25s18.8 11.67 25 35.51c-6.44-15.15-14.78-28.46-28.14-29.88-10.48-1.12-16.48 4.62-16.48 4.62Z"
              style={{
                opacity: 0.2,
                transformOrigin: "120.22px 390.282px",
              }}
              className="animable"
            />
            <path
              d="M25.36 368.63c11.86-.75 24.26 2.59 35.69 12.29a49.31 49.31 0 0 1 17.68 31.54l-7.16-1.16s-5.94-18.77-16.24-28.51c-9.16-8.66-15.95-12.11-29.97-14.16Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "52.045px 390.494px",
              }}
              className="animable"
            />
            <path
              d="M80.49 408c.55-8.05-3.24-25-15.55-36.47s-16.76-14-29.44-17.21c6.76 3.14 18.24 11.29 26.38 21.93s8.52 23.26 8.52 28c1.39 3.75 6.38 11.49 10.09 3.75Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "58.0206px 382.818px",
              }}
              className="animable"
            />
            <path
              d="M80.49 408c.55-8.05-3.24-25-15.55-36.47s-16.76-14-29.44-17.21c6.76 3.14 18.24 11.29 26.38 21.93s8.52 23.26 8.52 28c1.39 3.75 6.38 11.49 10.09 3.75Z"
              style={{
                opacity: 0.2,
                transformOrigin: "58.0206px 382.818px",
              }}
              className="animable"
            />
            <path
              d="M80 411.93c-1.61-10.26 3.91-28.63 10.36-37.62 7.8-10.87 19.31-19 32.08-21.22-13.73 5.23-27.44 20.5-31.52 34.91s-1.68 29.28-1.68 29.28Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "101.079px 385.185px",
              }}
              className="animable"
            />
            <path
              d="M80 411.93c-1.61-10.26 3.91-28.63 10.36-37.62 7.8-10.87 19.31-19 32.08-21.22-13.73 5.23-27.44 20.5-31.52 34.91s-1.68 29.28-1.68 29.28Z"
              style={{
                opacity: 0.2,
                transformOrigin: "101.079px 385.185px",
              }}
              className="animable"
            />
            <path
              d="M83.87 417.64c.61-8.92 5.82-28.73 16.14-36.71s21.83-2.64 25.31 1.56c-6.25-4.38-13.76-4.18-19.18.3s-11 17.93-13.71 30.7Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "104.595px 397.225px",
              }}
              className="animable"
            />
            <path
              d="M83.87 417.64c.61-8.92 5.82-28.73 16.14-36.71s21.83-2.64 25.31 1.56c-6.25-4.38-13.76-4.18-19.18.3s-11 17.93-13.71 30.7Z"
              style={{
                opacity: 0.35,
                transformOrigin: "104.595px 397.225px",
              }}
              className="animable"
            />
            <path
              d="M84.3 433.22c-1.73-9.6 1.32-29.57 17.11-40.57s26.7-8.1 30.85-6.85c-12.23-.83-24.5 6-32 14.39-5.21 5.85-10.11 15.43-10.41 31.29Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "108.065px 408.861px",
              }}
              className="animable"
            />
            <path
              d="M84.52 434s4.14-.1 5.8-2c0-6.2 1.66-18.61 10.37-25.93s15.47-5.93 16.84-3.05c0-4.22-5.3-8-11.18-6.72-9.84 2.05-23.68 14.76-21.83 37.7Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "100.941px 415.023px",
              }}
              className="animable"
            />
            <path
              d="M84.52 434s4.14-.1 5.8-2c0-6.2 1.66-18.61 10.37-25.93s15.47-5.93 16.84-3.05c0-4.22-5.3-8-11.18-6.72-9.84 2.05-23.68 14.76-21.83 37.7Z"
              style={{
                opacity: 0.35,
                transformOrigin: "100.941px 415.023px",
              }}
              className="animable"
            />
            <path
              d="M101.22 398.16c5.35-2.92 10-5.42 15.92-2.65.26-.15 3.66-1 5 .52 5 5.89 3.37 20.54-5.76 34.58 4.21-10.53 4.4-30-3.37-33a15.51 15.51 0 0 0-11.79.55Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "113.072px 412.459px",
              }}
              className="animable"
            />
            <path
              d="M101.22 398.16c5.35-2.92 10-5.42 15.92-2.65.26-.15 3.66-1 5 .52 5 5.89 3.37 20.54-5.76 34.58 4.21-10.53 4.4-30-3.37-33a15.51 15.51 0 0 0-11.79.55Z"
              style={{
                opacity: 0.2,
                transformOrigin: "113.072px 412.459px",
              }}
              className="animable"
            />
            <path
              d="M117.14 395.51c2.4 1.12 7.34 9.55 4.15 21.3 3-8.88 1.9-17.42-3.08-21.56a6 6 0 0 0-1.07.26Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "120.044px 406.03px",
              }}
              className="animable"
            />
            <path
              d="M117.14 395.51c2.4 1.12 7.34 9.55 4.15 21.3 3-8.88 1.9-17.42-3.08-21.56a6 6 0 0 0-1.07.26Z"
              style={{
                opacity: 0.35,
                transformOrigin: "120.044px 406.03px",
              }}
              className="animable"
            />
            <path
              d="M74 431.15c-.47-3.74-3.83-8.65-9.71-7.44s-19.69 12-25.56 29.7c1.07-11.88 5.4-21.85 12.52-29.36 6.39-6.73 14.77-10 21.42-6.41S74 431.15 74 431.15Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "57.3723px 434.787px",
              }}
              className="animable"
            />
            <path
              d="M74 431.15c-.47-3.74-3.83-8.65-9.71-7.44s-19.69 12-25.56 29.7c1.07-11.88 5.4-21.85 12.52-29.36 6.39-6.73 14.77-10 21.42-6.41S74 431.15 74 431.15Z"
              style={{
                opacity: 0.35,
                transformOrigin: "57.3723px 434.787px",
              }}
              className="animable"
            />
            <path
              d="M71.57 408.77c-5.15-5.16-8.76-10.1-18.24-8.14s-16 12.26-18.55 26.17c1.61-5.37 6.49-17.67 16.22-19.8s14.39-1.32 20.57 1.77Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "53.175px 413.495px",
              }}
              className="animable"
            />
            <path
              d="M74 431.15c-1.34-9.1-4.8-22.07-14.49-22.59s-20.3 5.57-24.73 18.24c2.27-11.54 12.1-22.54 22.36-22.57s20.36 2.22 22.81 29Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "57.365px 418.73px",
              }}
              className="animable"
            />
            <path
              d="M74 431.15c-1.34-9.1-4.8-22.07-14.49-22.59s-20.3 5.57-24.73 18.24c2.27-11.54 12.1-22.54 22.36-22.57s20.36 2.22 22.81 29Z"
              style={{
                opacity: 0.2,
                transformOrigin: "57.365px 418.73px",
              }}
              className="animable"
            />
            <path
              d="M65.85 392.54a26.34 26.34 0 0 0-13.36-6.61c-3.29-.55-9.71-3.1-16.58 3.31S21.81 410.57 24.37 421c1.1-11.07 15.99-42.17 41.48-28.46Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "44.8463px 402.984px",
              }}
              className="animable"
            />
            <path
              d="M65.85 392.54a26.34 26.34 0 0 0-13.36-6.61c-3.29-.55-9.71-3.1-16.58 3.31S21.81 410.57 24.37 421c1.1-11.07 15.99-42.17 41.48-28.46Z"
              style={{
                opacity: 0.2,
                transformOrigin: "44.8463px 402.984px",
              }}
              className="animable"
            />
            <path
              d="M81.32 434.12c0-8.44-6.16-35.19-15.89-42-12.18-8.52-20.33-1.26-20.33-1.26a16.27 16.27 0 0 1 14.51 2.3c6.29 4.6 12.15 18 14.39 38 0-.01 2.13 3.01 7.32 2.96Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "63.21px 411.049px",
              }}
              className="animable"
            />
            <path
              d="M81.32 434.12c0-8.44-6.16-35.19-15.89-42-12.18-8.52-20.33-1.26-20.33-1.26a16.27 16.27 0 0 1 14.51 2.3c6.29 4.6 12.15 18 14.39 38 0-.01 2.13 3.01 7.32 2.96Z"
              style={{
                opacity: 0.35,
                transformOrigin: "63.21px 411.049px",
              }}
              className="animable"
            />
            <path
              d="M75.79 409c-.59 2.47 2 20.86 3.95 25a17.31 17.31 0 0 0 5.88-.09c1.86-3.22.06-24 3.62-24.43-2.77-1.27-12.16-4.73-13.45-.48Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "82.4723px 420.577px",
              }}
              className="animable"
            />
            <path
              d="M75.79 409c-.59 2.47 2 20.86 3.95 25a17.31 17.31 0 0 0 5.88-.09c1.86-3.22.06-24 3.62-24.43-2.77-1.27-12.16-4.73-13.45-.48Z"
              style={{
                opacity: 0.2,
                transformOrigin: "82.4723px 420.577px",
              }}
              className="animable"
            />
            <path
              d="M75.79 409c2.87-3 14.53 2.86 16.72 20.24 2.91-8.24 1.62-18.44-1.29-21a5.23 5.23 0 0 0-6-.81s-9.03-3.99-9.43 1.57Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "84.9707px 417.642px",
              }}
              className="animable"
            />
            <path
              d="M85.24 407.41c3.57 1.5 7.65 6.46 7.61 14.92.27-4.33-.56-11.93-6.69-15.29a6.49 6.49 0 0 0-.92.37Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "89.0669px 414.685px",
              }}
              className="animable"
            />
            <path
              d="M85.24 407.41c3.57 1.5 7.65 6.46 7.61 14.92.27-4.33-.56-11.93-6.69-15.29a6.49 6.49 0 0 0-.92.37Z"
              style={{
                opacity: 0.2,
                transformOrigin: "89.0669px 414.685px",
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "339.36px 410.985px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "339.36px 410.985px",
          }}
        >
          <path
            d="M362.67 408.59a3.32 3.32 0 0 1-3.36-.33 10.52 10.52 0 0 1-4.78-8.23 3.35 3.35 0 0 1 1.39-3.08l59.2-37.44c1.21-.82 2.94-.77 4.87.33a14.72 14.72 0 0 1 6.68 11.51c0 2.22-.82 3.75-2.12 4.4Z"
            style={{
              fill: "#455a64",
              transformOrigin: "390.591px 383.924px",
            }}
            className="animable"
          />
          <path
            d="M354.53 400c0-3 2.12-4.27 4.75-2.76a10.55 10.55 0 0 1 4.78 8.23c0 3-2.12 4.27-4.75 2.76a10.52 10.52 0 0 1-4.78-8.23Z"
            style={{
              fill: "#37474f",
              transformOrigin: "359.295px 402.735px",
            }}
            className="animable"
          />
          <path
            d="M347.54 412.93a6.37 6.37 0 0 1-2.89-5 2 2 0 0 1 .84-1.87l11.76-6.84a2 2 0 0 1 2 .2 6.37 6.37 0 0 1 2.89 5 2 2 0 0 1-.84 1.87l-11.77 6.84a2 2 0 0 1-1.99-.2Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "353.395px 406.174px",
            }}
            className="animable"
          />
          <path
            d="M347.54 412.93a6.37 6.37 0 0 1-2.89-5 2 2 0 0 1 .84-1.87l11.76-6.84a2 2 0 0 1 2 .2 6.37 6.37 0 0 1 2.89 5 2 2 0 0 1-.84 1.87l-11.77 6.84a2 2 0 0 1-1.99-.2Z"
            style={{
              opacity: 0.2,
              transformOrigin: "353.395px 406.174px",
            }}
            className="animable"
          />
          <path
            d="m353.07 403.46-1.34-1-6.2 3.6a36.53 36.53 0 0 1 6.9 5.4l5.67-3.29c-.16-.18-.29-.36-.46-.54a37.29 37.29 0 0 0-4.57-4.17Z"
            style={{
              opacity: 0.2,
              transformOrigin: "351.815px 406.96px",
            }}
            className="animable"
          />
          <path
            d="m361.52 399.21 60.9-37.42a11.64 11.64 0 0 0-2.43-1.94c-1.93-1.1-3.66-1.15-4.87-.33L355.92 397a3.34 3.34 0 0 1 3.37.32 9 9 0 0 1 2.23 1.89Z"
            style={{
              opacity: 0.15,
              transformOrigin: "389.17px 379.084px",
            }}
            className="animable"
          />
          <path
            d="M360.86 423.53V422.27c0-.56-.09-1.11-.17-1.66 0-.21-.06-.41-.1-.62a19.79 19.79 0 0 0-.56-2.27c-.07-.21-.14-.42-.2-.63-.21-.55-.42-1.11-.67-1.65l-.27-.58c-.09-.18-.18-.35-.26-.52s-.25-.49-.4-.73-.27-.48-.42-.72-.3-.48-.46-.72a26.44 26.44 0 0 0-2.75-3.49 32.93 32.93 0 0 0-4.35-4 47.07 47.07 0 0 0-5.46-3.64c-21.38-12.2-55.84-12.2-77 0-.53.31-1.05.62-1.55.94a42.73 42.73 0 0 0-5.36 3.94c-.48.43-.95.85-1.39 1.29a31.31 31.31 0 0 0-3.06 3.47c-.17.22-.32.44-.48.66s-.4.59-.59.89-.52.83-.75 1.25-.49.92-.71 1.39a4.72 4.72 0 0 0-.27.61c-.13.28-.24.56-.35.85a5.33 5.33 0 0 0-.23.63 19.29 19.29 0 0 0-1 4.55v9.97c0 8.07 5.32 16.16 16 22.34 21.25 12.27 55.71 12.27 77 0 10.73-6.19 16-14.31 15.87-22.41-.08-.89-.04-5.92-.06-7.88Zm-90-17.15c9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.78 13 10.77 13 16.87s-4.54 12-12.82 16.81c-9.36 5.41-21.93 8.38-35.42 8.38s-26.05-3-35.41-8.38c-8.35-4.82-12.95-10.85-12.95-17s4.53-11.96 12.72-16.69Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "306.486px 427.456px",
            }}
            className="animable"
          />
          <path
            d="M360.86 423.53V422.27c0-.56-.09-1.11-.17-1.66 0-.21-.06-.41-.1-.62a19.79 19.79 0 0 0-.56-2.27c-.07-.21-.14-.42-.2-.63-.21-.55-.42-1.11-.67-1.65l-.27-.58c-.09-.18-.18-.35-.26-.52s-.25-.49-.4-.73-.27-.48-.42-.72-.3-.48-.46-.72a26.44 26.44 0 0 0-2.75-3.49 32.93 32.93 0 0 0-4.35-4 47.07 47.07 0 0 0-5.46-3.64c-21.38-12.2-55.84-12.2-77 0-.53.31-1.05.62-1.55.94a42.73 42.73 0 0 0-5.36 3.94c-.48.43-.95.85-1.39 1.29a31.31 31.31 0 0 0-3.06 3.47c-.17.22-.32.44-.48.66s-.4.59-.59.89-.52.83-.75 1.25-.49.92-.71 1.39a4.72 4.72 0 0 0-.27.61c-.13.28-.24.56-.35.85a5.33 5.33 0 0 0-.23.63 19.29 19.29 0 0 0-1 4.55v9.97c0 8.07 5.32 16.16 16 22.34 21.25 12.27 55.71 12.27 77 0 10.73-6.19 16-14.31 15.87-22.41-.08-.89-.04-5.92-.06-7.88Zm-90-17.15c9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.78 13 10.77 13 16.87s-4.54 12-12.82 16.81c-9.36 5.41-21.93 8.38-35.42 8.38s-26.05-3-35.41-8.38c-8.35-4.82-12.95-10.85-12.95-17s4.53-11.96 12.72-16.69Z"
            style={{
              fill: "#fff",
              opacity: 0.25,
              transformOrigin: "306.486px 427.456px",
            }}
            className="animable"
          />
          <path
            d="M360.86 423.53h-6.12c0 6.06-4.54 11.76-12.82 16.54-9.08 5.25-21.19 8.2-34.22 8.37V463c13.53-.17 27-3.23 37.29-9.19 10.73-6.19 16-14.31 15.87-22.41-.02-.88.02-5.91 0-7.87Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "334.283px 443.265px",
            }}
            className="animable"
          />
          <path
            d="M360.86 423v-.69c0-.56-.09-1.11-.17-1.66 0-.21-.06-.41-.1-.62a19.79 19.79 0 0 0-.56-2.27c-.07-.21-.14-.42-.2-.63-.21-.55-.42-1.11-.67-1.65l-.27-.58c-.09-.18-.18-.35-.26-.52s-.25-.49-.4-.73-.27-.48-.42-.72-.3-.48-.46-.72a26.44 26.44 0 0 0-2.75-3.49 34.3 34.3 0 0 0-4.35-4 47.07 47.07 0 0 0-5.46-3.64c-21.38-12.2-55.84-12.2-77 0-.53.31-1.05.62-1.55.94a42.73 42.73 0 0 0-5.36 3.94c-.48.43-.95.85-1.39 1.29a31.31 31.31 0 0 0-3.06 3.47c-.17.22-.32.44-.48.66s-.4.59-.59.89-.52.83-.75 1.25-.49.92-.71 1.39a4.72 4.72 0 0 0-.27.61c-.13.28-.24.56-.35.85a5.33 5.33 0 0 0-.23.63 19.29 19.29 0 0 0-1 4.55v1.56c0 8 5.35 16.12 16 22.27 21.25 12.27 55.71 12.27 77 0 10.48-6 15.77-13.93 15.87-21.84-.05-.25-.06-.44-.06-.54Zm-18.94 17.11c-9.36 5.41-21.93 8.38-35.42 8.38s-26.05-3-35.41-8.38c-8.35-4.82-12.95-10.85-12.95-17s4.52-12 12.71-16.72c9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.78 13 10.77 13 16.87s-4.52 12.02-12.8 16.8Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "306.485px 423.256px",
            }}
            className="animable"
          />
          <path
            d="M360.86 423v-.69c0-.56-.09-1.11-.17-1.66 0-.21-.06-.41-.1-.62a19.79 19.79 0 0 0-.56-2.27c-.07-.21-.14-.42-.2-.63-.21-.55-.42-1.11-.67-1.65l-.27-.58c-.09-.18-.18-.35-.26-.52s-.25-.49-.4-.73-.27-.48-.42-.72-.3-.48-.46-.72a26.44 26.44 0 0 0-2.75-3.49 34.3 34.3 0 0 0-4.35-4 47.07 47.07 0 0 0-5.46-3.64c-21.38-12.2-55.84-12.2-77 0-.53.31-1.05.62-1.55.94a42.73 42.73 0 0 0-5.36 3.94c-.48.43-.95.85-1.39 1.29a31.31 31.31 0 0 0-3.06 3.47c-.17.22-.32.44-.48.66s-.4.59-.59.89-.52.83-.75 1.25-.49.92-.71 1.39a4.72 4.72 0 0 0-.27.61c-.13.28-.24.56-.35.85a5.33 5.33 0 0 0-.23.63 19.29 19.29 0 0 0-1 4.55v1.56c0 8 5.35 16.12 16 22.27 21.25 12.27 55.71 12.27 77 0 10.48-6 15.77-13.93 15.87-21.84-.05-.25-.06-.44-.06-.54Zm-18.94 17.11c-9.36 5.41-21.93 8.38-35.42 8.38s-26.05-3-35.41-8.38c-8.35-4.82-12.95-10.85-12.95-17s4.52-12 12.71-16.72c9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.78 13 10.77 13 16.87s-4.52 12.02-12.8 16.8Z"
            style={{
              fill: "#fff",
              opacity: 0.45,
              transformOrigin: "306.485px 423.256px",
            }}
            className="animable"
          />
          <path
            d="M354.74 423.26a12.37 12.37 0 0 1-.38 3.08c-1.28-5-5.65-9.85-12.64-13.83-9.43-5.38-22.05-8.33-35.55-8.33s-26 2.95-35.32 8.32c-6.81 3.92-11.08 8.69-12.33 13.65a12.2 12.2 0 0 1-.38-3c0-6.06 4.52-12 12.71-16.72 9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.73 13 10.72 13.02 16.82Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "306.44px 412.22px",
            }}
            className="animable"
          />
          <path
            d="M354.74 423.26a12.37 12.37 0 0 1-.38 3.08c-1.28-5-5.65-9.85-12.64-13.83-9.43-5.38-22.05-8.33-35.55-8.33s-26 2.95-35.32 8.32c-6.81 3.92-11.08 8.69-12.33 13.65a12.2 12.2 0 0 1-.38-3c0-6.06 4.52-12 12.71-16.72 9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c8.39 4.73 13 10.72 13.02 16.82Z"
            style={{
              fill: "#fff",
              opacity: 0.25,
              transformOrigin: "306.44px 412.22px",
            }}
            className="animable"
          />
          <path
            d="M354.65 424.86c-.73 5.49-5.17 10.85-12.73 15.21-9.36 5.41-21.93 8.38-35.42 8.38s-26.05-3-35.41-8.38c-7.65-4.41-12.15-9.84-12.86-15.43.71-5.51 5.12-10.84 12.62-15.17 9.3-5.37 21.85-8.33 35.32-8.33s26.12 3 35.55 8.34c7.7 4.38 12.22 9.79 12.93 15.38Z"
            style={{
              fill: "#fff",
              opacity: 0.55,
              transformOrigin: "306.44px 424.795px",
            }}
            className="animable"
          />
        </g>
      </g>
      <AnimateDater
        className="animable"
        style={{
          transformOrigin: "375.182px 273.37px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "375.182px 273.37px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "375.182px 273.37px",
            }}
          >
            <path
              d="m417.26 172.42-101.58 58.64a1.77 1.77 0 0 0-.85 1.66l19.79 138.38a2.34 2.34 0 0 0 1.32 1.56l4.16 1.71a2.78 2.78 0 0 0 2.18-.1l101.58-58.64a1.8 1.8 0 0 0 .85-1.66l-19.79-138.38a2.33 2.33 0 0 0-1.33-1.56l-4.15-1.71a2.74 2.74 0 0 0-2.18.1Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "379.769px 273.343px",
              }}
              className="animable"
            />
            <path
              d="m417.26 172.42-101.58 58.64a1.77 1.77 0 0 0-.85 1.66l19.79 138.38a2.34 2.34 0 0 0 1.32 1.56l4.16 1.71a2.78 2.78 0 0 0 2.18-.1l101.58-58.64a1.8 1.8 0 0 0 .85-1.66l-19.79-138.38a2.33 2.33 0 0 0-1.33-1.56l-4.15-1.71a2.74 2.74 0 0 0-2.18.1Z"
              style={{
                fill: "#fff",
                opacity: 0.45,
                transformOrigin: "379.769px 273.343px",
              }}
              className="animable"
            />
            <path
              d="M342.28 374.27a2.84 2.84 0 0 1-2.18.1l-4.1-1.71a2.33 2.33 0 0 1-1.33-1.56l-19.84-138.38a1.57 1.57 0 0 1 .21-1l6.47 2.72a1.57 1.57 0 0 0-.19.93l19.8 138.38a.71.71 0 0 0 1.16.52Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "328.549px 303.13px",
              }}
              className="animable"
            />
            <path
              d="m317.09 248.55-11.25 14.77a1.35 1.35 0 0 0 .65 2.2l6.76 2.87a1.86 1.86 0 0 0 1.13.1l11.32-4.24-1.84-12.83Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "315.599px 258.543px",
              }}
              className="animable"
            />
            <path
              d="m317.09 248.55-11.25 14.77a1.35 1.35 0 0 0 .65 2.2l6.76 2.87a1.86 1.86 0 0 0 1.13.1l11.32-4.24-1.84-12.83Z"
              style={{
                fill: "#fff",
                opacity: 0.45,
                transformOrigin: "315.599px 258.543px",
              }}
              className="animable"
            />
            <path
              d="M424.25 175.16a.86.86 0 0 0-.35.12l-101.57 58.64a1.6 1.6 0 0 0-.76 1.47l2.29 16-11.25 14.77c-1 1 .22 2.63 1.77 2.3l11.79-.92 15.19 106.2c0 .13.1.45.42.44a.86.86 0 0 0 .35-.12l101.58-58.64a1.64 1.64 0 0 0 .76-1.47l-19.8-138.35c-.02-.14-.1-.45-.42-.44Z"
              style={{
                fill: "#fff",
                transformOrigin: "378.359px 274.67px",
              }}
              className="animable"
            />
            <path
              d="M341.76 374.6a.81.81 0 0 1-.79-.77L325.83 268l-11.42.89a2.18 2.18 0 0 1-2.36-1.07 1.55 1.55 0 0 1 .28-1.91l11.12-14.59-2.28-15.87a2 2 0 0 1 1-1.87l101.53-58.65a1.26 1.26 0 0 1 .53-.17.82.82 0 0 1 .83.78l19.8 138.38a2 2 0 0 1-.95 1.87l-101.58 58.65a1.11 1.11 0 0 1-.53.16Zm-15.59-107.43a.41.41 0 0 1 .4.35l15.19 106.19a.91.91 0 0 0 0 .12s.07 0 .14-.08l101.61-58.65a1.22 1.22 0 0 0 .56-1.06l-19.79-138.38a.41.41 0 0 0 0-.1.64.64 0 0 0-.15.06l-101.6 58.65a1.21 1.21 0 0 0-.57 1.06l2.3 16a.47.47 0 0 1-.08.3l-11.25 14.76a.79.79 0 0 0-.18 1 1.44 1.44 0 0 0 1.55.67l11.84-.93Z"
              style={{
                fill: "#f6a293",
                transformOrigin: "378.353px 274.68px",
              }}
              className="animable"
            />
          </g>
          <path
            d="m366.68 352.77-18.34 10.58c-1.36.79-2.68-.14-3-2.08l-17.1-119.82a5.15 5.15 0 0 1 2-4.92L348.53 226c1.36-.79 2.69.14 3 2.08l17.15 119.82a5.2 5.2 0 0 1-2 4.87Z"
            style={{
              fill: "#e0e0e0",
              transformOrigin: "348.455px 294.675px",
            }}
            className="animable"
          />
          <path
            d="m435.63 313-59.11 34.12c-1.36.79-2.69-.14-3-2.07l-17.11-119.86c-.27-1.94.6-4.14 2-4.92l59.12-34.13c1.35-.79 2.68.14 3 2.08L437.59 308c.27 2-.59 4.17-1.96 5Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "397px 266.63px",
            }}
            className="animable"
          />
          <path
            d="m435.63 313-59.11 34.12c-1.36.79-2.69-.14-3-2.07l-17.11-119.86c-.27-1.94.6-4.14 2-4.92l59.12-34.13c1.35-.79 2.68.14 3 2.08L437.59 308c.27 2-.59 4.17-1.96 5Z"
            style={{
              fill: "#fff",
              opacity: 0.45,
              transformOrigin: "397px 266.63px",
            }}
            className="animable"
          />
          <path
            d="M340.1 256.47a1 1 0 0 1-.07.51.7.7 0 0 1-.28.36l-.66.38a.3.3 0 0 1-.34 0 .53.53 0 0 1-.19-.37l-1.82-12.71-2.22 4.36a.5.5 0 0 1-.3.32.32.32 0 0 1-.33-.06l-.49-.49a.57.57 0 0 1-.16-.41 1 1 0 0 1 .11-.51l2.93-5.79a1 1 0 0 1 .24-.31 1.45 1.45 0 0 1 .26-.17l.66-.39a.3.3 0 0 1 .34 0 .52.52 0 0 1 .19.36Z"
            style={{
              fill: "#455a64",
              transformOrigin: "336.673px 249.455px",
            }}
            className="animable"
          />
          <path
            d="M341.61 251.3a6.84 6.84 0 0 1 .1-2.42 7.88 7.88 0 0 1 .92-2.34 2.58 2.58 0 0 1-1.15-1 4.21 4.21 0 0 1-.6-1.73 6.14 6.14 0 0 1 0-1.91 7.62 7.62 0 0 1 .58-1.9 7.43 7.43 0 0 1 1.06-1.66 5.38 5.38 0 0 1 1.44-1.22 3.62 3.62 0 0 1 1.56-.51 2.37 2.37 0 0 1 1.33.28 2.56 2.56 0 0 1 1 1 4.32 4.32 0 0 1 .53 1.59 6.26 6.26 0 0 1-.07 2.11 8 8 0 0 1-.72 2 2.69 2.69 0 0 1 1.39 1 4.13 4.13 0 0 1 .73 1.94 6.36 6.36 0 0 1 0 2 8 8 0 0 1-.62 2 7.43 7.43 0 0 1-1.15 1.78 5.89 5.89 0 0 1-1.58 1.33 3.87 3.87 0 0 1-1.69.56 2.55 2.55 0 0 1-1.44-.29 2.74 2.74 0 0 1-1.06-1 4.27 4.27 0 0 1-.56-1.61Zm.81-8.34a2 2 0 0 0 .31.86 1.26 1.26 0 0 0 .58.5 1.53 1.53 0 0 0 .78.11 2.08 2.08 0 0 0 .9-.3 3.82 3.82 0 0 0 .86-.71 4.81 4.81 0 0 0 .64-.93 3.84 3.84 0 0 0 .36-1.05 3.1 3.1 0 0 0 0-1.05 2 2 0 0 0-.31-.86 1.26 1.26 0 0 0-.58-.5 1.55 1.55 0 0 0-.79-.11 2.29 2.29 0 0 0-.91.31 3.78 3.78 0 0 0-.85.71 4.41 4.41 0 0 0-.63.92 3.84 3.84 0 0 0-.36 1 3.11 3.11 0 0 0 0 1.14Zm.73 7.45a2.42 2.42 0 0 0 .34 1 1.58 1.58 0 0 0 .64.57 1.8 1.8 0 0 0 .88.13 2.63 2.63 0 0 0 1.06-.38 3.83 3.83 0 0 0 1-.81 4.66 4.66 0 0 0 1.12-2.21 3.41 3.41 0 0 0 0-1.19 2.28 2.28 0 0 0-.34-1 1.43 1.43 0 0 0-.64-.56 1.71 1.71 0 0 0-.89-.13 2.83 2.83 0 0 0-1 .37 4.13 4.13 0 0 0-1 .81 5.11 5.11 0 0 0-.71 1.05 4.63 4.63 0 0 0-.4 1.17 3.9 3.9 0 0 0-.06 1.18Z"
            style={{
              fill: "#455a64",
              transformOrigin: "345.297px 245.406px",
            }}
            className="animable"
          />
          <path
            d="M365.38 226.21a3.22 3.22 0 0 1 1.29-.45 1.55 1.55 0 0 1 1 .26 2.17 2.17 0 0 1 .71.89 5.62 5.62 0 0 1 .46 1.45c.12.67.22 1.35.29 2a8.14 8.14 0 0 1 0 1.71 5.64 5.64 0 0 1-.37 1.52 4.42 4.42 0 0 1-.76 1.27 4.25 4.25 0 0 1-1.19 1l-2.45 1.42a.18.18 0 0 1-.2 0 .32.32 0 0 1-.12-.22l-1.28-9a.57.57 0 0 1 0-.31.44.44 0 0 1 .17-.22Zm2.14 2.91a2.71 2.71 0 0 0-.24-.76 1.21 1.21 0 0 0-.39-.49.91.91 0 0 0-.57-.15 1.66 1.66 0 0 0-.74.25l-1.31.76.89 6.24 1.36-.78a2.48 2.48 0 0 0 1.09-1.28 2.87 2.87 0 0 0 .2-.84 3.87 3.87 0 0 0 0-.9c-.06-.7-.16-1.38-.29-2.05Z"
            style={{
              fill: "#455a64",
              transformOrigin: "365.957px 231.532px",
            }}
            className="animable"
          />
          <path
            d="M370.09 228.11a3.44 3.44 0 0 1 .09-.72 3.87 3.87 0 0 1 .88-1.7 3.06 3.06 0 0 1 .85-.69 2.24 2.24 0 0 1 .92-.33 1.26 1.26 0 0 1 .77.15 1.54 1.54 0 0 1 .57.65 3.64 3.64 0 0 1 .33 1.16l.59 4.08a.68.68 0 0 1 0 .31.44.44 0 0 1-.17.22l-.74.42a.17.17 0 0 1-.21 0 .29.29 0 0 1-.11-.22l-.07-.46a3.34 3.34 0 0 1-.49 1 2.77 2.77 0 0 1-.94.85 2.07 2.07 0 0 1-.77.28 1.05 1.05 0 0 1-.62-.13 1.17 1.17 0 0 1-.44-.49 2.22 2.22 0 0 1-.25-.8 3 3 0 0 1 .26-1.77 4.54 4.54 0 0 1 1.18-1.47l1.53-1.31c-.06-.38-.18-.6-.38-.65a.88.88 0 0 0-.69.14 1 1 0 0 0-.36.32 1.76 1.76 0 0 0-.23.41 1.11 1.11 0 0 1-.14.25.47.47 0 0 1-.15.13l-.91.53a.19.19 0 0 1-.18 0c-.09.01-.12-.05-.12-.16Zm2.19 3a2 2 0 0 0 .57-.47 2.42 2.42 0 0 0 .38-.6 2.32 2.32 0 0 0 .2-.65 2.14 2.14 0 0 0 0-.62v-.14l-1.27 1.1a2.2 2.2 0 0 0-.54.61 1 1 0 0 0-.1.61c0 .2.11.3.27.31a.92.92 0 0 0 .49-.18Z"
            style={{
              fill: "#455a64",
              transformOrigin: "372.599px 228.888px",
            }}
            className="animable"
          />
          <path
            d="M377.73 226.77a.93.93 0 0 0 .26.59c.13.11.35.08.64-.09l.59-.34a.18.18 0 0 1 .2 0 .3.3 0 0 1 .12.22l.13.91a.65.65 0 0 1 0 .31.4.4 0 0 1-.17.22l-.72.42a1.46 1.46 0 0 1-1.5.18 2.2 2.2 0 0 1-.77-1.65l-.43-3-.64.37a.18.18 0 0 1-.2 0 .36.36 0 0 1-.12-.22l-.13-.92a.68.68 0 0 1 0-.31.41.41 0 0 1 .17-.21l.65-.38-.33-2.25a.65.65 0 0 1 0-.31.4.4 0 0 1 .17-.22l.74-.43a.18.18 0 0 1 .2 0 .29.29 0 0 1 .12.22l.32 2.26 1.26-.72a.16.16 0 0 1 .2 0 .3.3 0 0 1 .12.22l.13.91a.65.65 0 0 1 0 .31.4.4 0 0 1-.17.22l-1.26.73Z"
            style={{
              fill: "#455a64",
              transformOrigin: "377.33px 224.475px",
            }}
            className="animable"
          />
          <path
            d="M379.91 224.43a6.79 6.79 0 0 1 0-1.56 5.81 5.81 0 0 1 .3-1.47 4.77 4.77 0 0 1 .64-1.23 3.26 3.26 0 0 1 .95-.87 1.85 1.85 0 0 1 1-.28 1.52 1.52 0 0 1 .87.32 2.29 2.29 0 0 1 .64.85 4.16 4.16 0 0 1 .37 1.25l.08.63a.56.56 0 0 1 0 .31.46.46 0 0 1-.17.21l-3.26 1.88a1.22 1.22 0 0 0 .17.51.72.72 0 0 0 .31.27.75.75 0 0 0 .4 0 1.62 1.62 0 0 0 .43-.16 2.25 2.25 0 0 0 .49-.38 2.11 2.11 0 0 0 .29-.42 2 2 0 0 1 .15-.25.45.45 0 0 1 .18-.15l.78-.45a.2.2 0 0 1 .21 0 .29.29 0 0 1 .11.22 2.22 2.22 0 0 1-.08.59 4 4 0 0 1-.34.84 5.38 5.38 0 0 1-.62.9 3.53 3.53 0 0 1-.94.76 1.91 1.91 0 0 1-1 .3 1.4 1.4 0 0 1-.87-.33 2.48 2.48 0 0 1-.65-.91 5.61 5.61 0 0 1-.44-1.38ZM382 221a1.5 1.5 0 0 0-.46.4 1.71 1.71 0 0 0-.3.5 2.46 2.46 0 0 0-.15.53 4.57 4.57 0 0 0 0 .49l2.21-1.27a3 3 0 0 0-.14-.39.88.88 0 0 0-.23-.32.59.59 0 0 0-.37-.12 1.14 1.14 0 0 0-.56.18Z"
            style={{
              fill: "#455a64",
              transformOrigin: "382.358px 223.035px",
            }}
            className="animable"
          />
          <path
            d="M386.39 217.05a.16.16 0 0 1 .2 0 .31.31 0 0 1 .12.22l.19 1.36a.52.52 0 0 1 0 .3.4.4 0 0 1-.17.22l-.9.52a.16.16 0 0 1-.2 0 .27.27 0 0 1-.12-.22l-.2-1.36a.53.53 0 0 1 .05-.3.39.39 0 0 1 .16-.22Zm.7 4.86a.18.18 0 0 1 .2 0 .29.29 0 0 1 .11.22l.2 1.36a.68.68 0 0 1 0 .31.41.41 0 0 1-.17.21l-.91.53a.16.16 0 0 1-.2 0 .31.31 0 0 1-.12-.21L386 223a.55.55 0 0 1 0-.31.4.4 0 0 1 .17-.22Z"
            style={{
              fill: "#455a64",
              transformOrigin: "386.462px 220.795px",
            }}
            className="animable"
          />
          <path
            d="M334.78 267.82a.5.5 0 0 1-.43-.25.5.5 0 0 1 .18-.68l18-10.39a.51.51 0 0 1 .69.18.52.52 0 0 1-.19.69l-18 10.39a.51.51 0 0 1-.25.06Z"
            style={{
              fill: "#455a64",
              transformOrigin: "343.782px 262.126px",
            }}
            className="animable"
          />
          <path
            d="m418.23 217-52.34 30.22c-.67.39-1.32-.07-1.46-1a2.57 2.57 0 0 1 1-2.43l52.34-30.22c.67-.38 1.33.08 1.46 1a2.54 2.54 0 0 1-1 2.43Z"
            style={{
              fill: "#fff",
              transformOrigin: "391.831px 230.398px",
            }}
            className="animable"
          />
          <path
            d="m419.51 225.89-52.34 30.22c-.67.39-1.33-.07-1.46-1a2.55 2.55 0 0 1 1-2.44L419 222.44c.67-.39 1.33.07 1.47 1a2.55 2.55 0 0 1-.96 2.45Z"
            style={{
              fill: "#fff",
              transformOrigin: "393.093px 239.275px",
            }}
            className="animable"
          />
          <path
            d="M387.13 254.23 368.44 265c-.67.38-1.32-.08-1.46-1a2.54 2.54 0 0 1 1-2.43l18.68-10.79c.68-.39 1.33.07 1.47 1a2.57 2.57 0 0 1-1 2.45Z"
            style={{
              fill: "#fff",
              transformOrigin: "377.555px 257.887px",
            }}
            className="animable"
          />
          <path
            d="m428.58 289.31-41.78 24.12c-.67.39-1.33-.07-1.46-1a2.51 2.51 0 0 1 1-2.43l41.78-24.12c.67-.39 1.32.07 1.46 1a2.56 2.56 0 0 1-1 2.43Z"
            style={{
              fill: "#fff",
              transformOrigin: "407.458px 299.655px",
            }}
            className="animable"
          />
          <path
            d="m429.85 298.22-41.78 24.12c-.67.38-1.32-.08-1.46-1a2.55 2.55 0 0 1 1-2.43l41.78-24.12c.67-.39 1.33.07 1.46 1a2.55 2.55 0 0 1-1 2.43Z"
            style={{
              fill: "#fff",
              transformOrigin: "408.73px 308.562px",
            }}
            className="animable"
          />
          <path
            d="m408 320.45-18.68 10.79c-.67.39-1.33-.07-1.47-1a2.57 2.57 0 0 1 1-2.43L407.54 317c.67-.38 1.33.08 1.46 1a2.52 2.52 0 0 1-1 2.45Z"
            style={{
              fill: "#fff",
              transformOrigin: "398.428px 324.123px",
            }}
            className="animable"
          />
          <path
            d="M377.67 312.28c-2.05 1.18-3.39 4.69-2.95 7.8l.11.7c.29 2.08 2.52 4.34 4.06 5.77.49.46 1.23 0 1.53-.89.93-2.85 2.21-7.14 1.92-9.21l-.11-.71c-.44-3.11-2.51-4.65-4.56-3.46Zm1.16 8.08c-1.09.63-2.19-.09-2.41-1.64a4.17 4.17 0 0 1 1.61-4c1.09-.63 2.19.09 2.41 1.64a4.19 4.19 0 0 1-1.61 4Z"
            style={{
              fill: "#f6a293",
              transformOrigin: "378.509px 319.305px",
            }}
            className="animable"
          />
          <path
            d="m415.94 199.89-.25-1.76c-.28-2-1.66-3-3.06-2.15-1.41.81-2.32 3.1-2 5.1l.22 1.57a5.45 5.45 0 0 1-.5 3 1.55 1.55 0 0 0-.11.8c.07.5.42.74.77.54l6-3.44a1.35 1.35 0 0 0 .51-1.28.8.8 0 0 0-.28-.54 2.29 2.29 0 0 1-1.3-1.84Z"
            style={{
              fill: "#fff",
              transformOrigin: "413.882px 201.368px",
            }}
            className="animable"
          />
          <path
            d="M415.29 205.38a2.54 2.54 0 0 1-1 2.44c-.68.4-1.34-.07-1.47-1Z"
            style={{
              fill: "#fff",
              transformOrigin: "414.071px 206.672px",
            }}
            className="animable"
          />
        </g>
      </AnimateDater>
      <AnimateDay
        className="animable"
        style={{
          transformOrigin: "441.629px 91.9322px",
        }}
      >
        <g
          className="animable"
          style={{
            transformOrigin: "441.629px 91.9322px",
          }}
        >
          <g
            className="animable"
            style={{
              transformOrigin: "436.259px 94.705px",
            }}
          >
            <g
              className="animable"
              style={{
                transformOrigin: "436.259px 94.705px",
              }}
            >
              <path
                d="m459.73 53.83-41.25 23.86c-.81.47-1.47 1.61-1.47 3.82v50.4c0-.32.66.81 1.48 1.27l4.24 2.41a3.29 3.29 0 0 0 2.95 0l41.25-23.85a3.27 3.27 0 0 0 1.47-2.55V58.76a3.21 3.21 0 0 0-1.48-2.54l-4.24-2.41a3.29 3.29 0 0 0-2.95.02Z"
                style={{
                  fill: "#f6a293",
                  transformOrigin: "442.705px 94.705px",
                }}
                className="animable"
              />
              <path
                d="M425.68 135.57a3.33 3.33 0 0 1-2.95 0l-4.24-2.41c-.81-.46-1.48-1.59-1.48-1.27V81.51c0-1.76.18-2.3.47-2.78l7.17 4.14c-.27.45-.44 1-.44.18v50.4c0 2.13.61 2.63 1.47 2.12Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "421.345px 107.322px",
                }}
                className="animable"
              />
              <path
                d="M468.38 58.49c-.11-.74-.72-1-1.45-.58l-41.24 23.86a3 3 0 0 0-1 1.1l-7.18-4.14a2.91 2.91 0 0 1 1-1l41.24-23.86a3.29 3.29 0 0 1 2.95 0l4.24 2.41a3.23 3.23 0 0 1 1.44 2.21Z"
                style={{
                  fill: "#fff",
                  opacity: 0.3,
                  transformOrigin: "442.945px 68.1954px",
                }}
                className="animable"
              />
              <path
                d="M411.36 116.7c-.93-.55-6.36-3.6-6.58-3.73a1.37 1.37 0 0 1-.3-2.1L417 96.5l7.2 4.14-13.1 14a1.4 1.4 0 0 0 .26 2.06Z"
                style={{
                  fill: "#f6a293",
                  transformOrigin: "414.159px 106.6px",
                }}
                className="animable"
              />
              <path
                d="M411.36 116.7c-.93-.55-6.36-3.6-6.58-3.73a1.37 1.37 0 0 1-.3-2.1L417 96.5l7.2 4.14-13.1 14a1.4 1.4 0 0 0 .26 2.06Z"
                style={{
                  fill: "#fff",
                  opacity: 0.3,
                  transformOrigin: "414.159px 106.6px",
                }}
                className="animable"
              />
              <path
                d="m466.93 57.91-41.25 23.86a3.26 3.26 0 0 0-1.47 2.55v16.32l-13.1 14a1.32 1.32 0 0 0 .84 2.26l12.26-.9v18.73c0 .94.66 1.32 1.47.85l41.25-23.85a3.27 3.27 0 0 0 1.47-2.55V58.76c0-.94-.66-1.32-1.47-.85Z"
                style={{
                  fill: "#f6a293",
                  transformOrigin: "439.557px 96.745px",
                }}
                className="animable"
              />
            </g>
            <g
              className="animable"
              style={{
                transformOrigin: "446.305px 96.866px",
              }}
            >
              <path
                d="M460.13 76.38v5.93l-27.65 16v-5.97c0-2.94 1.55-6.21 3.46-7.31l2.51-1.45V86c0 2 1.08 3.05 2.39 2.29s2.39-3 2.39-5v-2.47l6.16-3.56v2.38c0 2 1.06 3.06 2.38 2.3s2.39-3 2.39-5v-2.43l2.52-1.45c1.9-1.06 3.45.38 3.45 3.32Z"
                style={{
                  fill: "#fafafa",
                  transformOrigin: "446.305px 85.5114px",
                }}
                className="animable"
              />
              <path
                d="M456.42 110.32 436.2 122c-2.05 1.19-3.72-.07-3.72-2.8v-18.67l27.65-16v18.65c0 2.82-1.66 5.96-3.71 7.14Z"
                style={{
                  fill: "#fafafa",
                  transformOrigin: "446.305px 103.489px",
                }}
                className="animable"
              />
              <path
                d="M440.84 86.61c-.81.48-1.47 0-1.47-1.11v-4.91a3.55 3.55 0 0 1 1.47-2.82c.82-.47 1.48 0 1.48 1.12v4.9a3.52 3.52 0 0 1-1.48 2.82Z"
                style={{
                  fill: "#fafafa",
                  transformOrigin: "440.845px 82.1922px",
                }}
                className="animable"
              />
              <path
                d="M451.77 80.3a3.52 3.52 0 0 0 1.48-2.82v-4.9c0-1.09-.66-1.59-1.48-1.12a3.55 3.55 0 0 0-1.47 2.82v4.91c0 1.08.7 1.58 1.47 1.11Z"
                style={{
                  fill: "#fafafa",
                  transformOrigin: "451.775px 75.8801px",
                }}
                className="animable"
              />
              <path
                d="M440.23 105.44a.46.46 0 0 1-.07-.32 1 1 0 0 1 .12-.4l2.53-4.52c.06-.1.12-.21.19-.31a.68.68 0 0 1 .21-.23l.91-.52a.17.17 0 0 1 .22 0 .38.38 0 0 1 .09.28V111a.92.92 0 0 1-.09.39.56.56 0 0 1-.22.27l-.94.55a.17.17 0 0 1-.22 0 .39.39 0 0 1-.09-.29v-8.84l-1.66 2.92a.45.45 0 0 1-.22.23.19.19 0 0 1-.22-.06Z"
                style={{
                  fill: "#455a64",
                  transformOrigin: "442.293px 105.675px",
                }}
                className="animable"
              />
              <path
                d="M445.81 107a6.29 6.29 0 0 1 .25-1.79 6.72 6.72 0 0 1 .72-1.65 2.54 2.54 0 0 1-.68-2 6 6 0 0 1 .22-1.63 7.21 7.21 0 0 1 .61-1.52 6.55 6.55 0 0 1 .92-1.27 5.09 5.09 0 0 1 1.17-.93 2.83 2.83 0 0 1 1.16-.42 1.42 1.42 0 0 1 .92.21 1.71 1.71 0 0 1 .61.81 3.7 3.7 0 0 1 .22 1.38 6 6 0 0 1-.18 1.47 7.14 7.14 0 0 1-.5 1.36 1.6 1.6 0 0 1 .72.81 3.79 3.79 0 0 1 .26 1.51A6.66 6.66 0 0 1 452 105a7 7 0 0 1-1.66 3 6.09 6.09 0 0 1-1.34 1 3.24 3.24 0 0 1-1.33.47 1.52 1.52 0 0 1-1-.21 1.69 1.69 0 0 1-.65-.85 4.14 4.14 0 0 1-.21-1.41Zm1.57-.9a1.17 1.17 0 0 0 .14.64.64.64 0 0 0 .36.31.91.91 0 0 0 .52 0 2.08 2.08 0 0 0 .62-.24 3.62 3.62 0 0 0 .61-.46 3.88 3.88 0 0 0 .52-.62 3.57 3.57 0 0 0 .37-.73 2.45 2.45 0 0 0 .14-.8 1.24 1.24 0 0 0-.14-.64.71.71 0 0 0-.37-.3 1 1 0 0 0-.52 0 2.07 2.07 0 0 0-.61.25 3.2 3.2 0 0 0-.62.46 3.81 3.81 0 0 0-.52.61 3.46 3.46 0 0 0-.36.72 2.21 2.21 0 0 0-.14.77Zm.29-5.48a1.14 1.14 0 0 0 .11.56.53.53 0 0 0 .3.27.77.77 0 0 0 .43 0 1.73 1.73 0 0 0 .51-.2 3.31 3.31 0 0 0 .5-.38 3.13 3.13 0 0 0 .43-.52 2.37 2.37 0 0 0 .3-.62 2 2 0 0 0 .11-.69 1.09 1.09 0 0 0-.11-.56.55.55 0 0 0-.3-.28.78.78 0 0 0-.43 0 1.71 1.71 0 0 0-.5.19 2.66 2.66 0 0 0-.51.39 3.05 3.05 0 0 0-.43.51 2.53 2.53 0 0 0-.3.62 2.09 2.09 0 0 0-.11.68Z"
                style={{
                  fill: "#455a64",
                  transformOrigin: "449.02px 102.632px",
                }}
                className="animable"
              />
            </g>
          </g>
          <g
            className="animable"
            style={{
              transformOrigin: "468.4px 60.4835px",
            }}
          >
            <path
              d="M476.66 50.65 473 48.5c-1.62-.91-3.84-.77-6.29.64-4.94 2.86-8.95 9.8-8.95 15.51 0 2.85 1 4.85 2.61 5.79l3.38 1.94.79-1.32A9.13 9.13 0 0 0 467 70c4.94-2.86 9-9.8 9-15.51a9.42 9.42 0 0 0-.28-2.28Z"
              style={{
                fill: "#37474f",
                transformOrigin: "467.21px 60.1526px",
              }}
              className="animable"
            />
            <path
              d="M458 61.62a14.32 14.32 0 0 0-.34 3c0 2.85 1 4.85 2.61 5.79l3.38 1.94.79-1.32A9.13 9.13 0 0 0 467 70a15 15 0 0 0 2.44-1.8Z"
              style={{
                fill: "#263238",
                transformOrigin: "463.55px 66.985px",
              }}
              className="animable"
            />
            <path
              d="M470.14 51.15c-4.94 2.86-8.95 9.8-8.95 15.51s4 8 8.95 5.17 9-9.8 9-15.51-4.05-8.02-9-5.17Z"
              style={{
                fill: "#455a64",
                transformOrigin: "470.165px 61.4856px",
              }}
              className="animable"
            />
            <path
              d="M473.68 59.1v-2.19c0-2.5-1.52-3.65-3.4-2.57a8.12 8.12 0 0 0-3.4 6.49v2a7.79 7.79 0 0 1-1.14 3.83 2.14 2.14 0 0 0-.27 1c0 .63.38.92.85.65l7.94-4.58a2.08 2.08 0 0 0 .86-1.64.83.83 0 0 0-.25-.66 2.32 2.32 0 0 1-1.19-2.33Z"
              style={{
                fill: "#fff",
                transformOrigin: "470.296px 61.1726px",
              }}
              className="animable"
            />
            <path
              d="M471.91 65.72a3.9 3.9 0 0 1-1.63 3.12c-.9.52-1.63 0-1.63-1.23Z"
              style={{
                fill: "#fff",
                transformOrigin: "470.28px 67.3802px",
              }}
              className="animable"
            />
          </g>
        </g>
      </AnimateDay>
    </svg>);
}